webpackJsonp([0],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _LoadingButton = __webpack_require__(43);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  LoadingButton: {
	    displayName: 'LoadingButton'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Loader/LoadingButton.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var LoadingButton = _wrapComponent('LoadingButton')((_dec = (0, _reactCssModules2.default)(_LoadingButton2.default), _dec(_class = function (_Component) {
	  (0, _inherits3.default)(LoadingButton, _Component);
	
	  function LoadingButton() {
	    (0, _classCallCheck3.default)(this, LoadingButton);
	    return (0, _possibleConstructorReturn3.default)(this, (LoadingButton.__proto__ || (0, _getPrototypeOf2.default)(LoadingButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoadingButton, [{
	    key: 'render',
	
	    // static propTypes = {
	    //   color: PropTypes.string,
	    //   text: PropTypes.string,
	    //   style: PropTypes.object,
	    // };
	    // static defaultProps = {
	    //   color: 'orange',
	    // };
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'sk-folding-cube' },
	        _react3.default.createElement('div', { styleName: 'sk-cube' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube2' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube4' }),
	        _react3.default.createElement('div', { styleName: 'sk-cube3' })
	      );
	    }
	  }]);
	  return LoadingButton;
	}(_react2.Component)) || _class));
	
	exports.default = LoadingButton;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(57);
	
	var animateScroll = __webpack_require__(50);
	var scrollSpy = __webpack_require__(68);
	var defaultScroller = __webpack_require__(69);
	var assign = __webpack_require__(28);
	
	
	var protoTypes = {
	  to: React.PropTypes.string.isRequired,
	  containerId: React.PropTypes.string,
	  activeClass:React.PropTypes.string,
	  spy: React.PropTypes.bool,
	  smooth: React.PropTypes.bool,
	  offset: React.PropTypes.number,
	  delay: React.PropTypes.number,
	  isDynamic: React.PropTypes.bool,
	  onClick: React.PropTypes.func,
	  duration: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.func]),
	  absolute: React.PropTypes.bool,
	  onSetActive: React.PropTypes.func
	};
	
	var Helpers = {
	
	  Scroll: function (Component, customScroller) {
	
	    var scroller = customScroller || defaultScroller;
	
	    return React.createClass({
	
	      propTypes: protoTypes,
	
	      getDefaultProps: function() {
	        return {offset: 0};
	      },
	
	      scrollTo : function(to, props) {
	          scroller.scrollTo(to, props);
	      },
	
	      handleClick: function(event) {
	
	        /*
	         * give the posibility to override onClick
	         */
	
	        if(this.props.onClick) {
	          this.props.onClick(event);
	        }
	
	        /*
	         * dont bubble the navigation
	         */
	
	        if (event.stopPropagation) event.stopPropagation();
	        if (event.preventDefault) event.preventDefault();
	
	        /*
	         * do the magic!
	         */
	        this.scrollTo(this.props.to, this.props);
	
	      },
	
	      spyHandler: function(y) {
	        var element = scroller.get(this.props.to);
	        if (!element) return;
	        var cords = element.getBoundingClientRect();
	        var topBound = cords.top + y;
	        var bottomBound = topBound + cords.height;
	        var offsetY = y - this.props.offset;
	        var to = this.props.to;
	        var isInside = (offsetY >= topBound && offsetY <= bottomBound);
	        var isOutside = (offsetY < topBound || offsetY > bottomBound);
	        var activeLink = scroller.getActiveLink();
	
	        if (isOutside && activeLink === to) {
	          scroller.setActiveLink(void 0);
	          this.setState({ active : false });
	
	        } else if (isInside && activeLink != to) {
	          scroller.setActiveLink(to);
	          this.setState({ active : true });
	
	          if(this.props.onSetActive) {
	            this.props.onSetActive(to);
	          }
	
	          scrollSpy.updateStates();
	        }
	      },
	
	      componentDidMount: function() {
	
	
	
	        var containerId = this.props.containerId;
	
	        var scrollSpyContainer = containerId ? document.getElementById(containerId) : document;
	
	        if(!scrollSpy.isMounted(scrollSpyContainer)) {
	          scrollSpy.mount(scrollSpyContainer);
	        }
	
	
	        if(this.props.spy) {
	          var to = this.props.to;
	          var element = null;
	          var elemTopBound = 0;
	          var elemBottomBound = 0;
	
	          this._stateHandler = function() {
	            if(scroller.getActiveLink() != to) {
	                this.setState({ active : false });
	            }
	          }.bind(this)
	
	          scrollSpy.addStateHandler(this._stateHandler);
	
	          this._spyHandler = function(y) {
	
	            var containerTop = 0;
	            if(scrollSpyContainer.getBoundingClientRect) {
	              var containerCords = scrollSpyContainer.getBoundingClientRect();
	              containerTop = containerCords.top;
	            }
	
	            if(!element || this.props.isDynamic) {
	                element = scroller.get(to);
	                if(!element){ return;}
	
	                var cords = element.getBoundingClientRect();
	                elemTopBound = (cords.top - containerTop + y);
	                elemBottomBound = elemTopBound + cords.height;
	            }
	
	
	
	            var offsetY = y - this.props.offset;
	            var isInside = (offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound));
	            var isOutside = (offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound));
	            var activeLink = scroller.getActiveLink();
	
	            if (isOutside && activeLink === to) {
	              scroller.setActiveLink(void 0);
	              this.setState({ active : false });
	
	            } else if (isInside && activeLink != to) {
	              scroller.setActiveLink(to);
	              this.setState({ active : true });
	
	              if(this.props.onSetActive) {
	                this.props.onSetActive(to);
	              }
	
	              scrollSpy.updateStates();
	
	            }
	          }.bind(this);
	
	          scrollSpy.addSpyHandler(this._spyHandler, scrollSpyContainer);
	        }
	      },
	      componentWillUnmount: function() {
	        scrollSpy.unmount(this._stateHandler, this._spyHandler);
	      },
	      render: function() {
	
	        var className = "";
	        if(this.state && this.state.active) {
	          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
	        } else {
	          className = this.props.className;
	        }
	
	        var props = assign({}, this.props);
	
	        for(var prop in protoTypes) {
	          if(props.hasOwnProperty(prop)) {
	            delete props[prop];
	          }
	        }
	
	        props.className = className;
	        props.onClick = this.handleClick;
	
	        return React.createElement(Component, props);
	      }
	    });
	  },
	
	
	  Element: function(Component) {
	    return React.createClass({
	      propTypes: {
	        name: React.PropTypes.string,
	        id:   React.PropTypes.string
	      },
	      componentDidMount: function() {
	        this.registerElems(this.props.name);
	      },
	      componentWillReceiveProps: function(nextProps) {
	        if (this.props.name !== nextProps.name) {
	          this.registerElems(nextProps.name);
	        }
	      },
	      componentWillUnmount: function() {
	        defaultScroller.unregister(this.props.name);
	      },
	      registerElems: function(name) {
	        var domNode = ReactDOM.findDOMNode(this);
	        defaultScroller.register(name, domNode);
	      },
	      render: function() {
	        return React.createElement(Component, this.props);
	      }
	    });
	  }
	};
	
	module.exports = Helpers;


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sk-folding-cube":"_3ZAb3_qiNCia2o-S1wIY3c","sk-cube":"cM_IClr0gGW5A2Imk2vxW","sk-foldCubeAngle":"_16bGu_rygZvtWh0Tu77F8W","sk-cube2":"rMPTh051RdQo66Hop6tBJ cM_IClr0gGW5A2Imk2vxW","sk-cube3":"_3JGd_SX97yM_QOw9kD-BhP cM_IClr0gGW5A2Imk2vxW","sk-cube4":"_3ilhocWnejoD6gplyLVdAU cM_IClr0gGW5A2Imk2vxW"};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(28);
	
	var smooth = __webpack_require__(104);
	
	var easing = smooth.defaultEasing;
	
	var cancelEvents = __webpack_require__(103);
	
	var events = __webpack_require__(51);
	
	/*
	 * Function helper
	 */
	var functionWrapper = function(value) {
	  return typeof value === 'function' ? value : function() { return value; };
	};
	
	/*
	 * Sets the cancel trigger
	 */
	
	cancelEvents.register(function() {
	  __cancel = true;
	});
	
	/*
	 * Wraps window properties to allow server side rendering
	 */
	var currentWindowProperties = function() {
	  if (typeof window !== 'undefined') {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
	  }
	};
	
	/*
	 * Helper function to never extend 60fps on the webpage.
	 */
	var requestAnimationFrameHelper = (function () {
	  return  currentWindowProperties() ||
	          function (callback, element, delay) {
	              window.setTimeout(callback, delay || (1000/60), new Date().getTime());
	          };
	})();
	
	
	var __currentPositionY  = 0;
	var __startPositionY    = 0;
	var __targetPositionY   = 0;
	var __progress          = 0;
	var __duration          = 0;
	var __cancel            = false;
	
	var __target;
	var __containerElement;
	var __to;
	var __start;
	var __deltaTop;
	var __percent;
	var __delayTimeout;
	
	
	var currentPositionY = function() {
	  if (__containerElement) {
	        return __containerElement.scrollTop;
		} else {
	    var supportPageOffset = window.pageXOffset !== undefined;
	    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	    return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	           document.documentElement.scrollTop : document.body.scrollTop;
	   }
	};
	
	var scrollContainerHeight = function() {
	  if(__containerElement) {
	    return Math.max(
	      __containerElement.scrollHeight,
	      __containerElement.offsetHeight,
	      __containerElement.clientHeight
	    );
	  } else {
	    var body = document.body;
	    var html = document.documentElement;
	
	    return Math.max(
	      body.scrollHeight,
	      body.offsetHeight,
	      html.clientHeight,
	      html.scrollHeight,
	      html.offsetHeight
	    );
	  }
	};
	
	var animateTopScroll = function(timestamp) {
	  // Cancel on specific events
	  if(__cancel) { return };
	
	  __deltaTop = Math.round(__targetPositionY - __startPositionY);
	
	  if (__start === null) {
	    __start = timestamp;
	  }
	
	  __progress = timestamp - __start;
	
	  __percent = (__progress >= __duration ? 1 : easing(__progress/__duration));
	
	  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);
	
	  if(__containerElement) {
	    __containerElement.scrollTop = __currentPositionY;
	  } else {
	    window.scrollTo(0, __currentPositionY);
	  }
	
	  if(__percent < 1) {
	    requestAnimationFrameHelper.call(window, animateTopScroll);
	    return;
	  }
	
	  if(events.registered['end']) {
	    events.registered['end'](__to, __target, __currentPositionY);
	  }
	
	};
	
	var setContainer = function (options) {
	  if(!options || !options.containerId) {
	    __containerElement = null;
	    return;
	  }
	  if(!__containerElement) {
		   __containerElement = document.getElementById(options.containerId);
	  }
	};
	
	var startAnimateTopScroll = function(y, options, to, target) {
	
	  window.clearTimeout(__delayTimeout);
	
	  setContainer(options);
	
	
	  __start           = null;
	  __cancel          = false;
	  __startPositionY  = currentPositionY();
	  __targetPositionY = options.absolute ? y : y + __startPositionY;
	  __deltaTop        = Math.round(__targetPositionY - __startPositionY);
	
	  __duration        = functionWrapper(options.duration)(__deltaTop);
	  __duration        = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
	  __to              = to;
	  __target          = target;
	
	  if(options && options.delay > 0) {
	    __delayTimeout = window.setTimeout(function animate() {
	      requestAnimationFrameHelper.call(window, animateTopScroll);
	    }, options.delay);
	    return;
	  }
	
	  requestAnimationFrameHelper.call(window, animateTopScroll);
	
	};
	
	var scrollToTop = function (options) {
	  startAnimateTopScroll(0, assign(options || {}, { absolute : true }));
	};
	
	var scrollTo = function (toY, options) {
	  startAnimateTopScroll(toY, assign(options || {}, { absolute : true }));
	};
	
	var scrollToBottom = function(options) {
	  setContainer(options);
	  startAnimateTopScroll(scrollContainerHeight(), assign(options || {}, { absolute : true }));
	};
	
	var scrollMore = function(toY, options) {
	  setContainer(options);
	  startAnimateTopScroll(currentPositionY() + toY, assign(options || {}, { absolute : true }));
	};
	
	module.exports = {
	  animateTopScroll: startAnimateTopScroll,
	  scrollToTop: scrollToTop,
	  scrollToBottom: scrollToBottom,
	  scrollTo: scrollTo,
	  scrollMore: scrollMore,
	};


/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	
	var Events = {
		registered : {},
		scrollEvent : {
			register: function(evtName, callback) {
				Events.registered[evtName] = callback;
			},
			remove: function(evtName) {
				Events.registered[evtName] = null;
			}
		}
	};
	
	module.exports = Events;

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumb-item":"_3lyK8OooH9BWh1wHXAdwTL","breadcrumb-last-item":"_2rO8V_yo7fat1Rv3nlfC3Z","separator":"_1Z2WQR0IcvSWaAgxtmgljU","breadcrumb":"_17ZA2aQYdxXc7mteT2QDuM _13UyNN6lRQaIE4nGDzE2-d","breadcrumb-hidden":"_1W4CorlN8AMJGoX4oKVBqr"};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Breadcrumbs = __webpack_require__(62);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _config = __webpack_require__(37);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Breadcrumbs: {
	    displayName: 'Breadcrumbs'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Breadcrumbs/Breadcrumbs.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Breadcrumbs = _wrapComponent('Breadcrumbs')((_dec = (0, _reactCssModules2.default)(_Breadcrumbs2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Breadcrumbs, _Component);
	
	  function Breadcrumbs() {
	    (0, _classCallCheck3.default)(this, Breadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Breadcrumbs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          trip = _props.trip,
	          localExpert = _props.localExpert,
	          inspiration = _props.inspiration,
	          customStyle = _props.customStyle;
	
	      var separator = function separator(key) {
	        return _react3.default.createElement('i', { className: 'fa fa-angle-right', styleName: 'separator', key: 'separator-' + key });
	      };
	      return _react3.default.createElement(
	        'span',
	        { styleName: 'breadcrumb', style: customStyle, itemScope: true, itemType: 'http://schema.org/BreadcrumbList' },
	        _react3.default.createElement(
	          'span',
	          { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem' },
	          _react3.default.createElement(
	            'a',
	            { itemProp: 'item', href: '/' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'breadcrumb-item', itemProp: 'name' },
	              'Home'
	            ),
	            _react3.default.createElement('meta', { itemProp: 'position', content: '1' })
	          )
	        ),
	        function () {
	          switch (type) {
	            case 'TripDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/to/' + encodeURIComponent(trip.destination_location) },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    trip.destination_location
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  trip.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' })
	              )];
	            case 'LocalExpertProfile':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  localExpert.name.first + ' ' + localExpert.name.last
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Inspirations':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Inspiration'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration '
	                })
	              )];
	            case 'InspirationDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/inspiration' },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    'Inspiration'
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  inspiration.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration/' + inspiration.slug
	                })
	              )];
	            case 'Career':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Career'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/career'
	                })
	              )];
	            case 'TrustAndSafety':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Trust & Safety'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/trust-and-safety'
	                })
	              )];
	            case 'Dtac':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Dtac'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Digi':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Digi'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/digi'
	                })
	              )];
	            case 'LocalExpertBenefits':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Local Expert Benefits'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/local-expert-benefits'
	                })
	              )];
	            case 'Sitemap':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Sitemap'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/sitemap'
	                })
	              )];
	            default:
	              return null;
	          }
	        }()
	      );
	    }
	  }]);
	  return Breadcrumbs;
	}(_react2.Component), _class2.propTypes = {
	  type: _react2.PropTypes.string.isRequired,
	  trip: _react2.PropTypes.object,
	  localExpert: _react2.PropTypes.object,
	  inspiration: _react2.PropTypes.object,
	  customStyle: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Breadcrumbs;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	/*
	 * Tell the browser that the event listener won't prevent a scroll.
	 * Allowing the browser to continue scrolling without having to
	 * to wait for the listener to return.
	 */
	var addPassiveEventListener = function(target, eventName, listener) {
	    var supportsPassiveOption = (function(){
	        var supportsPassiveOption = false;
	        try {
	            var opts = Object.defineProperty({}, 'passive', {
	                get: function() {
	                    supportsPassiveOption = true;
	                }
	            });
	            window.addEventListener('test', null, opts);
	        } catch (e) {}
	        return supportsPassiveOption;
	    })();
	
	    target.addEventListener(eventName, listener, supportsPassiveOption ? {passive: true} : false);
	};
	
	module.exports = addPassiveEventListener;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(67);
	
	var eventThrottler = function(eventHandler) {
	  var eventHandlerTimeout;
	  return function(event) {
	    // ignore events as long as an eventHandler execution is in the queue
	    if ( !eventHandlerTimeout ) {
	      eventHandlerTimeout = setTimeout(function() {
	        eventHandlerTimeout = null;
	        eventHandler(event);
	        // The eventHandler will execute at a rate of 15fps
	      }, 66);
	    }
	  };
	};
	
	var scrollSpy = {
	
	  spyCallbacks: [],
	  spySetState: [],
	  scrollSpyContainers: [],
	
	  mount: function (scrollSpyContainer) {
	    var t = this;
	    if (scrollSpyContainer) {
	      var eventHandler = eventThrottler(function(event) {
	        t.scrollHandler(scrollSpyContainer);
	      });
	      this.scrollSpyContainers.push(scrollSpyContainer);
	      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
	    }
	  },
	
	  isMounted: function (scrollSpyContainer) {
	    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
	  },
	
	  currentPositionY: function (scrollSpyContainer) {
	    if(scrollSpyContainer === document) {
	      var supportPageOffset = window.pageXOffset !== undefined;
	      var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	      return supportPageOffset ? window.pageYOffset : isCSS1Compat ?
	      document.documentElement.scrollTop : document.body.scrollTop;
	    } else {
	      return scrollSpyContainer.scrollTop;
	    }
	  },
	
	  scrollHandler: function (scrollSpyContainer) {
	    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
	    if (callbacks) {
	      for(var i = 0; i < callbacks.length; i++) {
	        var position =this.currentPositionY(scrollSpyContainer);
	        callbacks[i](this.currentPositionY(scrollSpyContainer));
	      }
	    }
	  },
	
	  addStateHandler: function(handler){
	    this.spySetState.push(handler);
	  },
	
	  addSpyHandler: function(handler, scrollSpyContainer) {
	    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
	    if(!container.spyCallbacks) {
	      container.spyCallbacks = [];
	    }
	    container.spyCallbacks.push(handler);
	  },
	
	  updateStates: function(){
	    var length = this.spySetState.length;
	
	    for(var i = 0; i < length; i++) {
	      this.spySetState[i]();
	    }
	  },
	
	  unmount: function (stateHandler, spyHandler) {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
	      if(callbacks && callbacks.length) {
	        callbacks.splice(callbacks.indexOf(spyHandler), 1);
	      }
	    }
	
	    if(this.spySetState && this.spySetState.length) {
	      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
	    }
	
	    document.removeEventListener('scroll', this.scrollHandler);
	  },
	
	  update: function() {
	    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
	      this.scrollHandler(this.scrollSpyContainers[i]);
	    }
	  }
	}
	
	module.exports = scrollSpy;


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(28);
	
	var animateScroll = __webpack_require__(50);
	var events = __webpack_require__(51);
	
	var __mapped = {};
	var __activeLink;
	
	module.exports = {
	
	  unmount: function() {
	    __mapped = {};
	  },
	
	  register: function(name, element){
	    __mapped[name] = element;
	  },
	
	  unregister: function(name) {
	    delete __mapped[name];
	  },
	
	  get: function(name) {
	    return __mapped[name] || document.getElementById(name);
	  },
	
	  setActiveLink: function(link) {
	    __activeLink = link;
	  },
	
	  getActiveLink: function() {
	    return __activeLink;
	  },
	
	  scrollTo: function(to, props) {
	
	     /*
	     * get the mapped DOM element
	     */
	
	      var target = this.get(to);
	
	      if(!target) {
	        console.warn("target Element not found");
	        return;
	      }
	
	      props = assign({}, props, { absolute : false });
	
	
	      if(events.registered['begin']) {
	        events.registered['begin'](to, target);
	      }
	
	      var containerId = props.containerId;
	      var containerElement = containerId ? document.getElementById(containerId) : null;
	
	      var scrollOffset;
	
	      if(containerId && containerElement) {
	        props.absolute = true;
	        if(containerElement !== target.offsetParent) {
	          if(!containerElement.contains(target)) {
	            throw new Error('Container with ID ' + containerId + ' is not a parent of target ' + to);
	          } else {
	            throw new Error('Container with ID ' + containerId + ' is not a positioned element');
	          }
	        }
	
	        scrollOffset = target.offsetTop;
	      } else {
	        var coordinates = target.getBoundingClientRect();
	        var bodyRect = document.body.getBoundingClientRect();
	        scrollOffset = coordinates.top;
	      }
	
	      scrollOffset += (props.offset || 0);
	
	
	      /*
	       * if animate is not provided just scroll into the view
	       */
	      if(!props.smooth) {
	        if(containerId && containerElement) {
	          containerElement.scrollTop = scrollOffset;
	        } else {
	          window.scrollTo(0, scrollOffset);
	        }
	
	        if(events.registered['end']) {
	          events.registered['end'](to, target);
	        }
	
	        return;
	      }
	
	      /*
	       * Animate scrolling
	       */
	
	      animateScroll.animateTopScroll(scrollOffset, props, to, target);
	  }
	};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	exports.Link = __webpack_require__(102);
	exports.Button = __webpack_require__(100);
	exports.Element = __webpack_require__(101);
	exports.Helpers = __webpack_require__(36);
	exports.scroller = __webpack_require__(69);
	exports.Events = __webpack_require__(51);
	exports.scrollSpy = __webpack_require__(68);
	exports.animateScroll = __webpack_require__(50);


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(26);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SelectPeople = __webpack_require__(123);
	
	var _SelectPeople2 = _interopRequireDefault(_SelectPeople);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  SelectPeople: {
	    displayName: 'SelectPeople'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/FormElements/SelectPeople.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var SelectPeople = _wrapComponent('SelectPeople')((_dec = (0, _reactCssModules2.default)(_SelectPeople2.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(SelectPeople, _Component);
	
	  function SelectPeople() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SelectPeople);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectPeople.__proto__ || (0, _getPrototypeOf2.default)(SelectPeople)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          fieldName = _this$props.fieldName;
	      var value = e.target.value;
	
	      onChange(fieldName, 'SelectPeople', isNaN(value) ? value : parseInt(value, 10));
	      e.target.blur();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	  // constructor(props) {
	  //   super(props);
	  //   if (props.default) {
	  //     const selectedOption = props.options.filter((opt)=> {
	  //       return opt.value === props.default;
	  //     });
	  //     this.state = {
	  //       text: selectedOption[0].text,
	  //       selected: selectedOption[0].value,
	  //     };
	  //   } else {
	  //     this.state = {
	  //       text: props.placeholder,
	  //     };
	  //   }
	  // }
	
	  (0, _createClass3.default)(SelectPeople, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          homeStyle = _props.homeStyle,
	          noIcon = _props.noIcon,
	          error = _props.error,
	          plusEnabled = _props.plusEnabled;
	
	      var personIcon = __webpack_require__(128);
	      var personOrangeIcon = __webpack_require__(129);
	      var options = this.props.options;
	      if (options.length > 0 && options.length < 8 && plusEnabled) {
	        options = [].concat((0, _toConsumableArray3.default)(options), [options[options.length - 1] + 1 + '+']);
	      }
	      return _react3.default.createElement(
	        'div',
	        { styleName: homeStyle ? 'dropdown-home' : 'dropdown', style: error ? { border: '1px solid #d0021b' } : null },
	        _react3.default.createElement(
	          'span',
	          { styleName: homeStyle ? 'text-left-home' : 'text-left' },
	          value
	        ),
	        homeStyle && !noIcon && _react3.default.createElement('div', { styleName: 'icon-home', style: { 'background': 'url(' + personOrangeIcon + ') no-repeat 50% 50%', 'backgroundSize': 'contain' } }),
	        !homeStyle && !noIcon && _react3.default.createElement('div', { styleName: 'icon', style: { 'background': 'url(' + personIcon + ') no-repeat 50% 50%', 'backgroundSize': 'contain' } }),
	        _react3.default.createElement(
	          'select',
	          { 'data-tmt': 'select-qty', onChange: this.onChange, value: value },
	          options.map(function (option) {
	            return _react3.default.createElement(
	              'option',
	              { key: option, value: option },
	              option
	            );
	          })
	        ),
	        _react3.default.createElement('div', { styleName: homeStyle ? 'dropdown-arrow-home' : 'dropdown-arrow' })
	      );
	    }
	  }]);
	  return SelectPeople;
	}(_react2.Component), _class2.propTypes = {
	  options: _react2.PropTypes.array,
	  placeholder: _react2.PropTypes.string,
	  value: _react2.PropTypes.number,
	  onChange: _react2.PropTypes.func,
	  fieldName: _react2.PropTypes.string,
	  homeStyle: _react2.PropTypes.bool,
	  error: _react2.PropTypes.bool,
	  noIcon: _react2.PropTypes.bool,
	  plusEnabled: _react2.PropTypes.bool
	}, _class2.defaultProps = {
	  placeholder: 'Please select',
	  options: [1, 2, 3, 4, 5, 6, 7, 8],
	  homeStyle: false,
	  error: false
	}, _temp2)) || _class));
	
	exports.default = SelectPeople;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(757);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _eventListsGoogleMapEventList = __webpack_require__(1941);
	
	var _eventListsGoogleMapEventList2 = _interopRequireDefault(_eventListsGoogleMapEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var mapControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	  center: _react.PropTypes.object,
	  heading: _react.PropTypes.number,
	  mapTypeId: _react.PropTypes.any,
	  options: _react.PropTypes.object,
	  streetView: _react.PropTypes.any,
	  tilt: _react.PropTypes.number,
	  zoom: _react.PropTypes.number
	};
	
	exports.mapControlledPropTypes = mapControlledPropTypes;
	var mapDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(mapControlledPropTypes);
	
	exports.mapDefaultPropTypes = mapDefaultPropTypes;
	var mapUpdaters = {
	  center: function center(_center, component) {
	    component.getMap().setCenter(_center);
	  },
	  heading: function heading(_heading, component) {
	    component.getMap().setHeading(_heading);
	  },
	  mapTypeId: function mapTypeId(_mapTypeId, component) {
	    component.getMap().setMapTypeId(_mapTypeId);
	  },
	  options: function options(_options, component) {
	    component.getMap().setOptions(_options);
	  },
	  streetView: function streetView(_streetView, component) {
	    component.getMap().setStreetView(_streetView);
	  },
	  tilt: function tilt(_tilt, component) {
	    component.getMap().setTilt(_tilt);
	  },
	  zoom: function zoom(_zoom, component) {
	    component.getMap().setZoom(_zoom);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsGoogleMapEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var mapEventPropTypes = eventPropTypes;
	
	exports.mapEventPropTypes = mapEventPropTypes;
	
	var GoogleMapHolder = (function (_Component) {
	  _inherits(GoogleMapHolder, _Component);
	
	  function GoogleMapHolder() {
	    _classCallCheck(this, _GoogleMapHolder);
	
	    _get(Object.getPrototypeOf(_GoogleMapHolder.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(GoogleMapHolder, [{
	    key: "getMap",
	    value: function getMap() {
	      return this.props.map;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      return _react2["default"].createElement(
	        "div",
	        null,
	        _react.Children.map(this.props.children, function (childElement) {
	          if (_react2["default"].isValidElement(childElement)) {
	            return _react2["default"].cloneElement(childElement, {
	              mapHolderRef: _this
	            });
	          } else {
	            return childElement;
	          }
	        })
	      );
	    }
	  }], [{
	    key: "_createMap",
	    value: function _createMap(domEl, mapProps) {
	      (0, _warning2["default"])("undefined" !== typeof google, "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168");
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	      return new google.maps.Map(domEl, (0, _utilsComposeOptions2["default"])(mapProps, mapControlledPropTypes));
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      map: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _GoogleMapHolder = GoogleMapHolder;
	  GoogleMapHolder = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getMap",
	    updaters: mapUpdaters
	  })(GoogleMapHolder) || GoogleMapHolder;
	  return GoogleMapHolder;
	})(_react.Component);
	
	exports["default"] = GoogleMapHolder;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Button = React.createClass({
	  render: function () {
	    return React.DOM.input(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Button);


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Element = React.createClass({
	  render: function () {
	    return React.DOM.div(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Element(Element);


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	var Helpers = __webpack_require__(36);
	
	var Link = React.createClass({
	  render: function () {
	    return React.DOM.a(this.props, this.props.children);
	  }
	});
	
	module.exports = Helpers.Scroll(Link);


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	var addPassiveEventListener = __webpack_require__(67);
	
	var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown']
	
	module.exports = {
		register : function(cancelEvent) {
			if (typeof document === 'undefined') {
				return;
			}
	
			for(var i = 0; i < events.length; i = i + 1) {
				addPassiveEventListener(document, events[i], cancelEvent);
			}
		}
	};


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {
	 /*
	  * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
	  */
	  defaultEasing : function (x) {
	    'use strict';
	
	    if(x < 0.5) {
	      return Math.pow(x*2, 2)/2;
	    }
	    return 1-Math.pow((1-x)*2, 2)/2;
	  }
	}

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = composeOptions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _controlledOrDefault = __webpack_require__(1950);
	
	var _controlledOrDefault2 = _interopRequireDefault(_controlledOrDefault);
	
	function composeOptions(props, controlledPropTypes) {
	  var optionNameList = Object.keys(controlledPropTypes);
	  var getter = (0, _controlledOrDefault2["default"])(props);
	
	  // props from arguments may contain unknow props.
	  // We only interested those in optionNameList
	  return optionNameList.reduce(function (acc, optionName) {
	    if ("options" !== optionName) {
	      var value = getter(optionName);
	      if ("undefined" !== typeof value) {
	        acc[optionName] = value;
	      }
	    }
	    return acc;
	  }, _extends({}, getter("options")));
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = defaultPropsCreator;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _addDefaultPrefix = __webpack_require__(756);
	
	var _addDefaultPrefix2 = _interopRequireDefault(_addDefaultPrefix);
	
	function defaultPropsCreator(propTypes) {
	  return Object.keys(propTypes).reduce(function (acc, name) {
	    acc[(0, _addDefaultPrefix2["default"])(name)] = propTypes[name];
	    return acc;
	  }, {});
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dropdown":"_2-HtFwz4pptRIqoT12Bokj","dropdown-home":"VxVFb_3yUWdpmttU77sPG _2-HtFwz4pptRIqoT12Bokj","text-left":"_3tECoTnfuqL__OtOcoUG6H","text-left-home":"zt-iux5LGVqG06Ykf2EVW _3tECoTnfuqL__OtOcoUG6H","text-middle":"_284mheti6NLTZyQENEWKLw","icon":"wLZHUZlwC9t8kh4gSQnbg","icon-home":"_1jIdcYtZBc4PVclc45M5DM wLZHUZlwC9t8kh4gSQnbg","dropdown-arrow":"_1zPGVYVMoK-3vwGW-9ouHA","dropdown-arrow-home":"qAYw4lc_Pkck4wKQICywm"};

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eca9d0015f6222ebfe373fad51a89da7.png";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "301d693c135ef359da5f1489c32c5d81.png";

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = componentLifecycleDecorator;
	
	function componentLifecycleDecorator(_ref) {
	  var registerEvents = _ref.registerEvents;
	  var instanceMethodName = _ref.instanceMethodName;
	  var updaters = _ref.updaters;
	
	  // This modify the Component.prototype directly
	  return function (Component) {
	    function register() {
	      this._unregisterEvents = registerEvents(google.maps.event, this.props, this[instanceMethodName]());
	    }
	
	    function unregister() {
	      if (this._unregisterEvents) {
	        this._unregisterEvents();
	        this._unregisterEvents = null;
	      }
	    }
	
	    function noop() {}
	
	    // Stash component's own lifecycle methods to be invoked later
	    var componentDidMount = Component.prototype.hasOwnProperty("componentDidMount") ? Component.prototype.componentDidMount : noop;
	    var componentDidUpdate = Component.prototype.hasOwnProperty("componentDidUpdate") ? Component.prototype.componentDidUpdate : noop;
	    var componentWillUnmount = Component.prototype.hasOwnProperty("componentWillUnmount") ? Component.prototype.componentWillUnmount : noop;
	
	    Object.defineProperty(Component.prototype, "componentDidMount", {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: function value() {
	        // Hook into client's implementation, if it has any
	        componentDidMount.call(this);
	
	        register.call(this);
	      }
	    });
	
	    Object.defineProperty(Component.prototype, "componentDidUpdate", {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: function value(prevProps) {
	        unregister.call(this);
	
	        for (var _name in updaters) {
	          if (Object.prototype.hasOwnProperty.call(this.props, _name)) {
	            updaters[_name](this.props[_name], this);
	          }
	        }
	
	        // Hook into client's implementation, if it has any
	        componentDidUpdate.call(this, prevProps);
	
	        register.call(this);
	      }
	    });
	
	    Object.defineProperty(Component.prototype, "componentWillUnmount", {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: function value() {
	        // Hook into client's implementation, if it has any
	        componentWillUnmount.call(this);
	
	        unregister.call(this);
	        var instance = this[instanceMethodName]();
	        if ("setMap" in instance) {
	          instance.setMap(null);
	        }
	      }
	    });
	
	    return Component;
	  };
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventHandlerCreator;
	
	var _react = __webpack_require__(1);
	
	function groupToUpperCase(match, group) {
	  return group.toUpperCase();
	}
	
	function toOnEventName(rawName) {
	  return "on" + rawName.replace(/^(.)/, groupToUpperCase).replace(/_(.)/g, groupToUpperCase);
	}
	
	function eventHandlerCreator(rawNameList) {
	  var eventPropTypes = {};
	  var onEventNameByRawName = {};
	
	  rawNameList.forEach(function (rawName) {
	    var onEventName = toOnEventName(rawName);
	    eventPropTypes[onEventName] = _react.PropTypes.func;
	    onEventNameByRawName[rawName] = onEventName;
	  });
	
	  function registerEvents(event, props, googleMapInstance) {
	    var registered = rawNameList.reduce(function (acc, rawName) {
	      var onEventName = onEventNameByRawName[rawName];
	
	      if (Object.prototype.hasOwnProperty.call(props, onEventName)) {
	        acc.push(event.addListener(googleMapInstance, rawName, props[onEventName]));
	      }
	      return acc;
	    }, []);
	
	    return registered.forEach.bind(registered, event.removeListener, event);
	  }
	
	  return {
	    eventPropTypes: eventPropTypes,
	    registerEvents: registerEvents
	  };
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Tokens are an exact match.
	    if (word === token) return token;
	
	    // Upper cased words. E.g. "HELLO".
	    if (word === word.toUpperCase()) return token.toUpperCase();
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Replace a word using a rule.
	   *
	   * @param  {string} word
	   * @param  {Array}  rule
	   * @return {string}
	   */
	  function replace (word, rule) {
	    return word.replace(rule[0], function (match, index) {
	      var result = interpolate(rule[1], arguments);
	
	      if (match === '') {
	        return restoreCase(word[index - 1], result);
	      }
	
	      return restoreCase(match, result);
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {string}   token
	   * @param  {string}   word
	   * @param  {Array}    rules
	   * @return {string}
	   */
	  function sanitizeWord (token, word, rules) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = rules.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = rules[len];
	
	      if (rule[0].test(word)) return replace(word, rule);
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Check if a word is part of the map.
	   */
	  function checkWord (replaceMap, keepMap, rules, bool) {
	    return function (word) {
	      var token = word.toLowerCase();
	
	      if (keepMap.hasOwnProperty(token)) return true;
	      if (replaceMap.hasOwnProperty(token)) return false;
	
	      return sanitizeWord(token, token, rules) === token;
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {string}  word
	   * @param  {number}  count
	   * @param  {boolean} inclusive
	   * @return {string}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Check if a word is plural.
	   *
	   * @type {Function}
	   */
	  pluralize.isPlural = checkWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Check if a word is singular.
	   *
	   * @type {Function}
	   */
	  pluralize.isSingular = checkWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {string} single
	   * @param {string} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['was', 'were'],
	    ['has', 'have'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['looey', 'looies'],
	    ['thief', 'thieves'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['whiskey', 'whiskies']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/[^\u0000-\u007F]$/i, '$0'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/ies$/i, 'y'],
	    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
	    [/\b(mon|smil)ies$/i, '$1ey'],
	    [/(m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
	    [/(analy|ba|diagno|parenthe|progno|synop|the|empha|cri)(?:sis|ses)$/i, '$1sis'],
	    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
	    [/(test)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'adulthood',
	    'advice',
	    'agenda',
	    'aid',
	    'alcohol',
	    'ammo',
	    'anime',
	    'athletics',
	    'audio',
	    'bison',
	    'blood',
	    'bream',
	    'buffalo',
	    'butter',
	    'carp',
	    'cash',
	    'chassis',
	    'chess',
	    'clothing',
	    'cod',
	    'commerce',
	    'cooperation',
	    'corps',
	    'debris',
	    'diabetes',
	    'digestion',
	    'elk',
	    'energy',
	    'equipment',
	    'excretion',
	    'expertise',
	    'flounder',
	    'fun',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'housework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'literature',
	    'machinery',
	    'mackerel',
	    'mail',
	    'media',
	    'mews',
	    'moose',
	    'music',
	    'manga',
	    'news',
	    'pike',
	    'plankton',
	    'pliers',
	    'pollution',
	    'premises',
	    'rain',
	    'research',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'species',
	    'staff',
	    'swine',
	    'tennis',
	    'traffic',
	    'transporation',
	    'trout',
	    'tuna',
	    'wealth',
	    'welfare',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    // Regexes.
	    /[^aeiou]ese$/i, // "chinese", "japanese"
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /measles$/i,
	    /o[iu]s$/i, // "carnivorous"
	    /pox$/i, // "chickpox", "smallpox"
	    /sheep$/i
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(246);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(57);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(70);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(536);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(538);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(533);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(535);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(534);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(537);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(541);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(542);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(540);
	
	var _nodeListToArray = __webpack_require__(543);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(539);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: props.place || 'top', // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: 'mouseOnToolTip',
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	        return this.tooltipRef.matches(':hover');
	      }
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff,
	          isCapture = _props2.isCapture;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // Make sure the correct place is set
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = (0, _getPosition2.default)(e, e.currentTarget, _reactDom2.default.findDOMNode(this), desiredPlace, desiredPlace, effect, offset);
	      var place = result.isNewState ? result.newState.place : desiredPlace;
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      var target = e.currentTarget;
	
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border || false,
	          extraClass: target.getAttribute('data-class') || self.props.class || self.props.className || '',
	          disable: target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	
	                var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      };
	
	      // If there is no delay call immediately, don't allow events to get in first.
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target;
	
	      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /*
	    * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: 'listenForTooltipExit',
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: 'removeListenerForTooltipExit',
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show;
	        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	          return;
	        }
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          desiredPlace = _state3.desiredPlace,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        /* eslint-disable */
	        if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	          tag.setAttribute('nonce', __webpack_nonce__);
	        }
	        /* eslint-enable */
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' }, { 'allow_hover': this.props.delayUpdate }, { 'allow_click': this.props.clickable });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass,
	            id: this.props.id
	          }, ariaProps, {
	            ref: function ref(_ref2) {
	              return _this8.tooltipRef = _ref2;
	            },
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayUpdate: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_2PKqkoUyyWO2RIC16q3je6","box-picture-container":"LTBgtK7r1nOvC5NICnHeh","box-content-container":"_1xGcQZJGuDqCot7tMQ23Ln","box-picture-bg":"wnG3AHFwEKg_kMMtNpLV1","triangle":"_1hna0Dm7dVtfukMimmqjmX","btn-container":"qWdi_RM_Lekp7IG2btZLU","btn-chat":"_2zbcyP5tujs_kXBoscklhO","free":"SYfMc1hjk-a0DO_9Crzjt"};

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"reply-submit-container":"_3cTkPud6xdbdw3V-0MtmFx","replier":"F2wYEnyhOAQMvJJhQd1SX","replier-pic":"_8E7KbDX7v42x0fqDh-P8l","replier-user-name":"_3YBWq0couzI9-2KDIBfyof","date":"hltMKG2aeWkFax_hPoQzh","reply-box-container":"_2Pr49W0FkE7JX2g50H93in","textbox-container":"_3v2X1iOf51ODrGiziH-kZ-","textbox":"cltGV8KeaXgP2HqV9_e-K","btn-reply-submit":"_1XLpOZfQfKrV_zHlg34COR _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-reply-loading":"_2ob-OfdAohV12otU68xi2S _1XLpOZfQfKrV_zHlg34COR _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-reply-disable":"_3HJN4JCG5TWA4e81-Lfa7P _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C"};

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"review-container":"_1JeonwlKeAJ0EgLobQ5rGN","reviewer":"_3fukzptnfhaXhpsm1e5KjJ","reviewer-pic":"_3Dso1LcvPd6-N-GstWg6SQ","review-user-name":"_1WoSPUbp0-oQwHNeHi2PYp","review-content":"HePMV2QwdAnCc7FMzSAbD","trip-link":"_3jcMF06F6BkUAtMEihkQSj","point-date":"_3OFMfTMsAVbB3srWgW9irP","btn-reply":"itBmByK3WMIp6VcbM6lQT","btn-reply-mobile":"tqoOZ18zGqF66Pe4IxEuL"};

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"reply-container":"_1pfpcaqCuBUQjSwVdj51KS","replier":"vxVJVX_KNraG3WOg5EzCH","replier-pic":"_3dH56iiynjHqicDkpc2n7w","replier-user-name":"_1h3pISwhe3DMVWAN6U0FbA","reply-content":"_1dADrJcr0FX7D9LFPbTWqE","date":"_3Lxo7_Ac_N63WoQRUz7txl"};

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"review-container":"_2IiB1rs7iE5xgS7mH3yoYX","reviewer":"_1_7EkspJ0zpHLVIZQF7EKD","reviewer-pic":"_2hVlwpnWPWcDmH0eLFNFWr","review-content":"_2E3yKFWx7nWeIg0N7QCD_Z","reviewer-name":"HWEdO6G63DkzuWswvV46o","review-p":"_25YGmKP4AysX6oEIRMJSFY"};

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _CustomizeBox = __webpack_require__(248);
	
	var _CustomizeBox2 = _interopRequireDefault(_CustomizeBox);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _customize = __webpack_require__(64);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  CustomizeBox: {
	    displayName: 'CustomizeBox'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Customize/CustomizeBox.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	} /* global $zopim */
	
	
	var CustomizeBox = _wrapComponent('CustomizeBox')((_dec = (0, _reactRedux.connect)(function () {
	  return {};
	}, { logCustomizeTrip: _customize.logCustomizeTrip, push: _reactRouterRedux.push }), _dec2 = (0, _reactCssModules2.default)(_CustomizeBox2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(CustomizeBox, _Component);
	
	  function CustomizeBox(props) {
	    (0, _classCallCheck3.default)(this, CustomizeBox);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomizeBox.__proto__ || (0, _getPrototypeOf2.default)(CustomizeBox)).call(this, props));
	
	    _this.click = _this.click.bind(_this);
	
	    if (!(typeof _this.click === 'function')) {
	      throw new TypeError('Value of "this.click" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.click));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(CustomizeBox, [{
	    key: 'click',
	    value: function click() {
	      // $zopim(() => {
	      //   $zopim.livechat.window.show();
	      // });
	      this.props.logCustomizeTrip();
	      this.props.push('/customize');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'a',
	        { onClick: this.click },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'box-picture-container' },
	            _react3.default.createElement('div', { styleName: 'box-picture-bg' })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'box-content-container' },
	            _react3.default.createElement(
	              'h3',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'customize.box.header' })
	            ),
	            _react3.default.createElement(
	              'p',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'customize.box.description' }),
	              ' ',
	              _react3.default.createElement(
	                'span',
	                { styleName: 'free' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'customize.box.free_advise' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'btn-container' },
	              _react3.default.createElement(
	                'span',
	                { styleName: 'btn-chat' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'customize.box.request' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return CustomizeBox;
	}(_react2.Component), _class2.propTypes = {
	  logCustomizeTrip: _react2.PropTypes.func,
	  push: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = CustomizeBox;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ReplySubmit = __webpack_require__(250);
	
	var _ReplySubmit2 = _interopRequireDefault(_ReplySubmit);
	
	var _media = __webpack_require__(21);
	
	var _reactRedux = __webpack_require__(11);
	
	var _actions = __webpack_require__(78);
	
	var _reactIntl = __webpack_require__(10);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ReplySubmit: {
	    displayName: 'ReplySubmit'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReplySubmit.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var ReplySubmit = _wrapComponent('ReplySubmit')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sending: state.booking.sending
	  };
	}, { replyReview: _actions.replyReview }), _dec2 = (0, _reactCssModules2.default)(_ReplySubmit2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ReplySubmit, _Component);
	
	  function ReplySubmit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ReplySubmit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReplySubmit.__proto__ || (0, _getPrototypeOf2.default)(ReplySubmit)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      text: ''
	    }, _this.onChange = function (event) {
	      _this.setState({ text: event.target.value });
	    }, _this.submit = function () {
	      _this.props.replyReview(_this.props.review._id, _this.state.text).then(function () {
	        return _this.props.onSubmit(_this.state.text);
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ReplySubmit, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var text = this.state.text;
	      var _props = this.props,
	          replier = _props.replier,
	          sending = _props.sending;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'reply-submit-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'replier' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'replier-pic' },
	            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'replier-user-name', styleName: 'replier-user-name' },
	            replier && replier.name && '' + replier.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reply-box-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'textbox-container' },
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('textarea', { styleName: 'textbox', value: text, onChange: this.onChange }),
	              function () {
	                if (text) {
	                  if (sending) {
	                    return _react3.default.createElement(
	                      'a',
	                      { styleName: 'btn-reply-loading' },
	                      _react3.default.createElement(_LoadingButton2.default, null),
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.loading.button' })
	                    );
	                  }
	                  return _react3.default.createElement(
	                    'a',
	                    { styleName: 'btn-reply-submit', onMouseDown: _this2.submit },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.submit.button' })
	                  );
	                }
	                return _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-reply-disable' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.disable.button' })
	                );
	              }()
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ReplySubmit;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object,
	  replier: _react2.PropTypes.object,
	  sending: _react2.PropTypes.bool,
	  replyReview: _react2.PropTypes.func,
	  onSubmit: _react2.PropTypes.func
	}, _temp2)) || _class) || _class));
	
	exports.default = ReplySubmit;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Review = __webpack_require__(251);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ZHReview = __webpack_require__(264);
	
	var _ZHReview2 = _interopRequireDefault(_ZHReview);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _ReviewReply = __webpack_require__(263);
	
	var _ReviewReply2 = _interopRequireDefault(_ReviewReply);
	
	var _ReplySubmit = __webpack_require__(261);
	
	var _ReplySubmit2 = _interopRequireDefault(_ReplySubmit);
	
	var _reactIntl = __webpack_require__(10);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Review: {
	    displayName: 'Review'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/Review.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var Review = _wrapComponent('Review')((_dec = (0, _reactCssModules2.default)(_Review2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Review, _Component);
	
	  function Review(props) {
	    (0, _classCallCheck3.default)(this, Review);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Review.__proto__ || (0, _getPrototypeOf2.default)(Review)).call(this, props));
	
	    _this.state = {
	      openReply: false,
	      isSubmitted: false,
	      replyText: '',
	      createdAt: null
	    };
	
	    _this.openReplyBox = _this.openReplyBox.bind(_this);
	
	    if (!(typeof _this.openReplyBox === 'function')) {
	      throw new TypeError('Value of "this.openReplyBox" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openReplyBox));
	    }
	
	    _this.onReplyReview = _this.onReplyReview.bind(_this);
	
	    if (!(typeof _this.onReplyReview === 'function')) {
	      throw new TypeError('Value of "this.onReplyReview" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onReplyReview));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Review, [{
	    key: 'onReplyReview',
	    value: function onReplyReview(text) {
	      this.setState({ replyText: text });
	      this.setState({ isSubmitted: true });
	      this.setState({ createdAt: (0, _momentTimezone2.default)() });
	    }
	  }, {
	    key: 'openReplyBox',
	    value: function openReplyBox() {
	      if (this.state.openReply === false) {
	        this.setState({ openReply: true });
	      } else {
	        this.setState({ openReply: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const {review, locale} = this.props;
	      var _props = this.props,
	          review = _props.review,
	          forceLocale = _props.forceLocale,
	          user = _props.user;
	      var _state = this.state,
	          openReply = _state.openReply,
	          replyText = _state.replyText,
	          isSubmitted = _state.isSubmitted,
	          createdAt = _state.createdAt;
	
	      var defaultImage = __webpack_require__(48);
	      if (forceLocale === 'zh') {
	        return _react3.default.createElement(_ZHReview2.default, { review: review });
	      }
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'review-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reviewer' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'reviewer-pic' },
	            _react3.default.createElement('img', { src: review.user_id && review.user_id.avatar_image ? (0, _media.path)(review.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'review-user-name', styleName: 'review-user-name' },
	            review.user_id && review.user_id.name && '' + review.user_id.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'review-content' },
	          review.trip_id && _react3.default.createElement(
	            'h3',
	            { style: { marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	            _react3.default.createElement(
	              _Link2.default,
	              { className: 'review-trip-name', to: '/trip/' + review.trip_id.slug, styleName: 'trip-link' },
	              review.trip_id.name
	            ),
	            review.local_expert_id._id === user._id && !review.reply && !isSubmitted && _react3.default.createElement(
	              'a',
	              { styleName: 'btn-reply', onClick: this.openReplyBox },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.button' })
	            )
	          ),
	          _react3.default.createElement(
	            'h3',
	            { className: 'review-title' },
	            review.header
	          ),
	          _react3.default.createElement(
	            'p',
	            null,
	            review && review.text && review.text.split('\n').map(function (line, index) {
	              if (index + 1 < review.text.split('\n').length) {
	                return [_react3.default.createElement(
	                  'span',
	                  { key: 'text-' + index },
	                  line
	                ), _react3.default.createElement('br', { key: 'break-' + index })];
	              }
	              return _react3.default.createElement(
	                'span',
	                { key: 'text-' + index },
	                line
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'point-date' },
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(_RatingPoint2.default, { point: review.score })
	            ),
	            _react3.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	              _react3.default.createElement(
	                'span',
	                null,
	                (0, _momentTimezone2.default)(review.created_at).format('MMMM DD, YYYY')
	              ),
	              review.local_expert_id._id === user._id && !review.reply && !isSubmitted && _react3.default.createElement(
	                'a',
	                { styleName: 'btn-reply-mobile', onClick: this.openReplyBox },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'review.reply.button' })
	              )
	            )
	          ),
	          review.reply && _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(_ReviewReply2.default, { reply: review.reply, replier: review.local_expert_id })
	          ),
	          isSubmitted && _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(_ReviewReply2.default, { reply: { text: replyText, created_at: createdAt }, replier: review.local_expert_id })
	          ),
	          !isSubmitted && _react3.default.createElement(
	            'div',
	            { style: openReply ? null : { display: 'none' } },
	            _react3.default.createElement(_ReplySubmit2.default, { review: review, replier: review.local_expert_id, onSubmit: this.onReplyReview })
	          )
	        )
	      );
	    }
	  }]);
	  return Review;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object,
	  forceLocale: _react2.PropTypes.string,
	  user: _react2.PropTypes.object
	  // locale: PropTypes.string,
	}, _class2.defaultProps = {
	  forceLocale: null
	}, _temp)) || _class));
	
	exports.default = Review;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ReviewReply = __webpack_require__(252);
	
	var _ReviewReply2 = _interopRequireDefault(_ReviewReply);
	
	var _media = __webpack_require__(21);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ReviewReply: {
	    displayName: 'ReviewReply'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReviewReply.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var ReviewReply = _wrapComponent('ReviewReply')((_dec = (0, _reactCssModules2.default)(_ReviewReply2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ReviewReply, _Component);
	
	  function ReviewReply() {
	    (0, _classCallCheck3.default)(this, ReviewReply);
	    return (0, _possibleConstructorReturn3.default)(this, (ReviewReply.__proto__ || (0, _getPrototypeOf2.default)(ReviewReply)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ReviewReply, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          reply = _props.reply,
	          replier = _props.replier;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'reply-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'replier' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'replier-pic' },
	            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
	          ),
	          _react3.default.createElement(
	            'span',
	            { className: 'replier-user-name', styleName: 'replier-user-name' },
	            replier && replier.name && '' + replier.name.first
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reply-content' },
	          _react3.default.createElement(
	            'p',
	            null,
	            reply.text.split('\n').map(function (line, index) {
	              if (index + 1 < reply.text.split('\n').length) {
	                return [_react3.default.createElement(
	                  'span',
	                  { key: 'text-' + index },
	                  line
	                ), _react3.default.createElement('br', { key: 'break-' + index })];
	              }
	              return _react3.default.createElement(
	                'span',
	                { key: 'text-' + index },
	                line
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'date' },
	            _react3.default.createElement(
	              'span',
	              null,
	              (0, _momentTimezone2.default)(reply.created_at).format('MMMM DD, YYYY')
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ReviewReply;
	}(_react2.Component), _class2.propTypes = {
	  reply: _react2.PropTypes.object,
	  replier: _react2.PropTypes.object
	}, _class2.defaultProps = {
	  reply: {}
	}, _temp)) || _class));
	
	exports.default = ReviewReply;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ZHReview = __webpack_require__(253);
	
	var _ZHReview2 = _interopRequireDefault(_ZHReview);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ZHReview: {
	    displayName: 'ZHReview'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ZHReview.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ZHReview = _wrapComponent('ZHReview')((_dec = (0, _reactCssModules2.default)(_ZHReview2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ZHReview, _Component);
	
	  function ZHReview() {
	    (0, _classCallCheck3.default)(this, ZHReview);
	    return (0, _possibleConstructorReturn3.default)(this, (ZHReview.__proto__ || (0, _getPrototypeOf2.default)(ZHReview)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ZHReview, [{
	    key: 'render',
	    value: function render() {
	      var review = this.props.review;
	
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'review-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'reviewer' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'reviewer-pic' },
	            _react3.default.createElement('img', { src: review.user_id && review.user_id.avatar_image ? (0, _media.path)(review.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: review.user_id.name.first + '\'s avatar' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'review-content' },
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'reviewer-name' },
	            review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last
	          ),
	          _react3.default.createElement(
	            'p',
	            { styleName: 'review-p' },
	            review.text
	          )
	        )
	      );
	    }
	  }]);
	  return ZHReview;
	}(_react2.Component), _class2.propTypes = {
	  review: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = ZHReview;
	module.exports = exports['default'];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;;(function (root, factory) {
	  if (typeof module !== "undefined" && module.exports) {
	    module.exports = factory(__webpack_require__(1), __webpack_require__(166), __webpack_require__(24));
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    root.ReactSocial = factory(root.React, root.React.createClass, root.React.PropTypes);
	  }
	})(this, function (React, createClass, PropTypes) {
	  "use strict";
	
	  var isBrowser = function () {
	    return !(typeof document === "undefined" || typeof window === "undefined");
	  };
	
	  var assign = function(dest, src) {
	    for (var key in src) {
	      dest[key] = src[key];
	    }
	
	    return dest;
	  };
	
	  var spread = function (obj, omit) {
	    var clone = assign({}, obj);
	
	    omit.forEach(function (key) {
	      delete clone[key];
	    });
	
	    return clone;
	  };
	
	  var jsonp = function (url, cb) {
	    cb = cb || function () { };
	    var called = false;
	    var now = +new Date(),
	      id = now + "_" + Math.floor(Math.random()*1000);
	
	    var script = document.createElement("script"),
	      callback = "jsonp_" + id,
	      query = url.replace("@", callback);
	
	    script.setAttribute("type", "text/javascript");
	    script.setAttribute("src", query);
	    document.body.appendChild(script);
	
	    setTimeout(function () {
	      if (!called) {
	        called = true;
	        cb(new Error("jsonp timeout"));
	      }
	    }, 10000);
	
	    window[callback] = function () {
	      var args = Array.prototype.slice.call(arguments, 0);
	      args.unshift(null);
	      if (!called) {
	        called = true;
	        cb.apply(this, args);
	      }
	    };
	  };
	
	
	  /* Caputre VKontake callbacks */
	  var vkCallbacks = {};
	
	  var hookVKCallback = function () {
	    if (!isBrowser()) { return; }
	
	    if (!window.VK) {
	      window.VK = {};
	    }
	
	    if (!window.VK.Share) {
	      window.VK.Share = {};
	    }
	
	    var oldCount = window.VK.Share.count;
	
	    window.VK.Share.count = function (index, count) {
	      if (typeof vkCallbacks[index] === "function") {
	        return vkCallbacks[index](count);
	      }
	
	      if (typeof oldCount === "function") {
	        oldCount(index, count);
	      }
	    };
	  };
	
	  var captureVKCallback = function (index, cb) {
	    vkCallbacks[index] = cb;
	  };
	
	  hookVKCallback();
	
	  var exports = {};
	
	  var Count = {
	    displayName: "Count"
	
	    , propTypes: {
	      element: PropTypes.string
	      , url: PropTypes.string
	      , token: PropTypes.string
	    }
	
	    , getDefaultProps: function () {
	      var location = "";
	
	      if (isBrowser()) {
	        location = window.location.href;
	      }
	
	      return {
	        url: location
	        , token: ""
	        , element: "span"
	        , onCount: function () { }
	      };
	    }
	
	    , getInitialState: function () {
	      return {
	        count: 0
	      };
	    }
	
	    , componentDidMount: function () {
	      this.updateCount();
	    }
	
	    , componentWillReceiveProps: function (nextProps) {
	      if (this.props.url !== nextProps.url) {
	        this.setState({
	          count: 0
	        }, function () {
	          this.updateCount();
	        });
	      }
	    }
	
	    , componentDidUpdate: function () {
	      this.props.onCount(this.state.count);
	    }
	
	    , updateCount: function () {
	      if (!isBrowser()) {
	        return ;
	      }
	
	      if (typeof this.fetchCount === "function") {
	        return this.fetchCount(function (count) {
	          this.setState({ count: count });
	        }.bind(this));
	      }
	
	      var url = this.constructUrl();
	
	      jsonp(url, function (err, data) {
	        if (err) {
	          console.warn("react-social: jsonp timeout for url " + url);
	          return this.setState({count: 0});
	        }
	
	        this.setState({
	          count: this.extractCount(data)
	        });
	      }.bind(this));
	    }
	
	    , getCount: function () {
	      return this.state.count;
	    }
	
	    , render: function () {
	      return React.createElement(
	        this.props.element
	        , spread(this.props, ["element", "url", "onCount", "token"])
	        , this.state.count
	      );
	    }
	  };
	
	  var Button = {
	    displayName: "Button"
	
	    , propTypes: {
	      element: PropTypes.oneOfType([
	        PropTypes.string
	      , PropTypes.func
	      ])
	      , media: PropTypes.string
	      , message: PropTypes.string
	      , onClick: PropTypes.func
	      , sharer: PropTypes.bool
	      , target: PropTypes.string
	      , title: PropTypes.string
	      , url: PropTypes.string
	      , windowOptions: PropTypes.array
	      , _open: PropTypes.bool
	    }
	
	    , getDefaultProps: function () {
	      var location = "";
	
	      if (isBrowser()) {
	        location = window.location.href;
	      }
	
	      return {
	        element: "button"
	        , url: location
	        , media: ""
	        , message: ""
	        , onClick: function () { }
	        , windowOptions: []
	        , _open: true
	        , sharer: false
	      };
	    }
	
	    , click: function (e) {
	      var url = this.constructUrl();
	      var target = this.props.target;
	      var options = this.props.windowOptions.join(',');
	      this.props.onClick(e, url, target);
	      if (isBrowser() && this.props._open) {
	        window.open(url, target, options);
	      }
	    }
	
	    , render: function () {
	      var other = spread(this.props, [
	        "_open",
	        "appId",
	        "element",
	        "media",
	        "message",
	        "onClick",
	        "sharer",
	        "title",
	        "url",
	        "windowOptions"
	      ]);
	
	      return React.createElement(
	        this.props.element
	        , assign({ "onClick": this.click }, other)
	      );
	    }
	  };
	
	  var DefaultBlankTarget = {
	    getDefaultProps: function () {
	      return {target: "_blank"};
	    }
	  };
	
	  /* Counts */
	  exports.FacebookCount = createClass({
	    displayName: "FacebookCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      var url = "";
	
	      if (!this.props.token) {
	        url = "https://graph.facebook.com/?callback=@&id=" + encodeURIComponent(this.props.url);
	      } else {
	        url = "https://graph.facebook.com/v2.8/?callback=@"
	                + "&id=" + encodeURIComponent(this.props.url)
	                + "&access_token=" + encodeURIComponent(this.props.token);
	      }
	
	      return url;
	    }
	
	    , extractCount: function (data) {
	      if (!data || !data.share || !data.share.share_count) {
	        return 0;
	      }
	
	      return data.share.share_count;
	    }
	  });
	
	  exports.TwitterCount = createClass({
	    displayName: "TwitterCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://count.donreach.com/?callback=@&url=" + encodeURIComponent(this.props.url) + "&providers=all";
	    }
	
	    , extractCount: function (data) {
	      return data.shares.twitter || 0;
	    }
	  });
	
	  exports.GooglePlusCount = createClass({
	    displayName: "GooglePlusCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://count.donreach.com/?callback=@&url=" + encodeURIComponent(this.props.url) + "&providers=google";
	    }
	
	    , extractCount: function (data) {
	      return data.shares.google || 0;
	    }
	  });
	
	  exports.PinterestCount = createClass({
	    displayName: "PinterestCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://api.pinterest.com/v1/urls/count.json?callback=@&url="
	             + encodeURIComponent(this.props.url);
	    }
	
	    , extractCount: function (data) {
	      return data.count || 0;
	    }
	  });
	
	  exports.LinkedInCount = createClass({
	    displayName: "LinkedInCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://www.linkedin.com/countserv/count/share?url=" + encodeURIComponent(this.props.url) + "&callback=@&format=jsonp";
	    }
	
	    , extractCount: function (data) {
	      return data.count || 0;
	    }
	  });
	
	  exports.RedditCount = createClass({
	    displayName: "RedditCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://www.reddit.com/api/info.json?jsonp=@&url=" + encodeURIComponent(this.props.url);
	    }
	
	    , extractCount: function (data) {
	      var count = 0;
	      var chs = data.data.children;
	
	      for (var i = 0; i < chs.length; i++) {
	        count += chs[i].data.score;
	      }
	
	      return count;
	    }
	  });
	
	  exports.VKontakteCount = createClass({
	    displayName: "VKontakteCount"
	
	    , mixins: [Count]
	
	    , fetchCount: function (cb) {
	      var index = Math.floor(Math.random() * 10000)
	      var url = "https://vkontakte.ru/share.php?act=count&index=" + index + "&url=" + encodeURIComponent(this.props.url);
	      captureVKCallback(index, cb);
	      jsonp(url);
	    }
	  });
	
	
	  exports.TumblrCount = createClass({
	    displayName: "TumblrCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "http://api.tumblr.com/v2/share/stats?url="
	             + encodeURIComponent(this.props.url) + "&callback=@";
	    }
	
	    , extractCount: function (data) {
	      return data.response.note_count || 0;
	    }
	  });
	
	  exports.PocketCount = createClass({
	    displayName: "PocketCount"
	
	    , mixins: [Count]
	
	    , constructUrl: function () {
	      return "https://count.donreach.com/?callback=@&url=" + encodeURIComponent(this.props.url) + "&providers=pocket";
	    }
	
	    , extractCount: function (data) {
	      return data.shares.pocket || 0;
	    }
	  });
	
	  /* Buttons */
	  exports.FacebookButton = createClass({
	    displayName: "FacebookButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , propTypes: {
	      appId: PropTypes.oneOfType([
	        PropTypes.string,
	        PropTypes.number
	      ]).isRequired,
	      sharer: PropTypes.bool
	    }
	
	    , constructUrl: function () {
	      if (this.props.sharer) {
	        return "https://www.facebook.com/dialog/share?"
	             + "app_id=" + encodeURIComponent(this.props.appId)
	             + "&display=popup&caption=" + encodeURIComponent(this.props.message)
	             + "&href=" + encodeURIComponent(this.props.url)
	             + "&redirect_uri=" + encodeURIComponent("https://www.facebook.com/")
	      }
	
	      return "https://www.facebook.com/dialog/feed?"
	             + "app_id=" + encodeURIComponent(this.props.appId)
	             + "&display=popup&caption=" + encodeURIComponent(this.props.message)
	             + "&link=" + encodeURIComponent(this.props.url)
	             + "&picture=" + encodeURIComponent(this.props.media)
	             + "&redirect_uri=" + encodeURIComponent("https://www.facebook.com/")
	    }
	  });
	
	  exports.OdnoklassnikiButton = createClass({
	    displayName: "OdnoklassnikiButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , propTypes: {
	      message: PropTypes.string.isRequired,
	      media: PropTypes.string.isRequired,
	      title: PropTypes.string.isRequired
	    }
	
	    , constructUrl: function () {
	      var share_location = 'https://connect.ok.ru/offer',
	          url = this.props.url,
	          media = encodeURIComponent(this.props.media),
	          title = encodeURIComponent(this.props.title),
	          message = encodeURIComponent(this.props.message);
	      var search_keys = { url: url, media: media, title: title, description: message };
	      var search = Object.keys(search_keys).map(function (search_key) {
	        return search_key + '=' + search_keys[search_key];
	      }).join('&');
	      return [share_location, search].join('?');
	    }
	  });
	
	  exports.MyMailRuButton = createClass({
	    displayName: "MyMailRuButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , propTypes: {
	      message: PropTypes.string.isRequired,
	      media: PropTypes.string.isRequired,
	      title: PropTypes.string.isRequired
	    }
	
	    , constructUrl: function () {
	      var share_location = 'http://connect.mail.ru/share',
	          url = this.props.url,
	          media = encodeURIComponent(this.props.media),
	          title = encodeURIComponent(this.props.title),
	          message = encodeURIComponent(this.props.message);
	      var search_keys = { url: url, image_url: media, title: title, description: message };
	      var search = Object.keys(search_keys).map(function (search_key) {
	        return search_key + '=' + search_keys[search_key];
	      }).join('&');
	      return [share_location, search].join('?');
	    }
	  });
	
	  exports.TwitterButton = createClass({
	    displayName: "TwitterButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      var msg = this.props.message === "" ?
	        this.props.url : this.props.message + " " + this.props.url;
	      return "https://twitter.com/intent/tweet?text=" + encodeURIComponent(msg);
	    }
	  });
	
	  exports.EmailButton = createClass({
	    displayName: "EmailButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      return "mailto:?subject=" + encodeURIComponent(this.props.message) + "&body=" + encodeURIComponent(this.props.url);
	    }
	  });
	
	  exports.PinterestButton = createClass({
	    displayName: "PinterestButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , propTypes: {
	      media: PropTypes.string.isRequired
	    }
	
	    , constructUrl: function () {
	      var url = "https://pinterest.com/pin/create/button/?url="
	                + encodeURIComponent(this.props.url) + "&media="
	                + encodeURIComponent(this.props.media) + "&description="
	                + encodeURIComponent(this.props.message);
	      return url;
	    }
	  });
	
	  exports.VKontakteButton = createClass({
	    displayName: "VKontakteButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	        return "http://vk.com/share.php?url="
	                + encodeURIComponent(this.props.url) + "&title="
	                + encodeURIComponent(this.props.title) + "&description="
	                + encodeURIComponent(this.props.message);
	    }
	  });
	
	  exports.GooglePlusButton = createClass({
	    displayName: "GooglePlusButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	        return "https://plus.google.com/share?url=" + encodeURIComponent(this.props.url);
	    }
	  });
	
	  exports.RedditButton = createClass({
	    displayName: "RedditButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	        return "https://www.reddit.com/submit?url="
	        + encodeURIComponent(this.props.url) + '&title='
	        + encodeURIComponent(this.props.title);
	    }
	  });
	
	  exports.LinkedInButton = createClass({
	    displayName: "LinkedInButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      return "https://www.linkedin.com/shareArticle?url="
	        + encodeURIComponent(this.props.url) + '&title='
	        + encodeURIComponent(this.props.title);
	    }
	  });
	
	  exports.XingButton = createClass({
	    displayName: "XingButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      return "https://www.xing.com/app/user?op=share;url=" + encodeURIComponent(this.props.url) + ";title=" + encodeURIComponent(this.props.message);
	    }
	  });
	
	  exports.TumblrButton = createClass({
	    displayName: "TumblrButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      return "https://www.tumblr.com/widgets/share/tool?posttype=link&title=" + encodeURIComponent(this.props.message) + "&content=" + encodeURIComponent(this.props.url) + "&canonicalUrl=" + encodeURIComponent(this.props.url) + "&shareSource=tumblr_share_button";
	    }
	  });
	
	  exports.PocketButton = createClass({
	    displayName: "PocketButton"
	
	    , mixins: [Button, DefaultBlankTarget]
	
	    , constructUrl: function () {
	      return "https://getpocket.com/save?url=" + encodeURIComponent(this.props.url) + "&title=" + encodeURIComponent(this.props.message);
	    }
	  });
	
	  return exports;
	});


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(552);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // avoid screen readers from reading out loud the text
	    mark.ariaHidden = "true"
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(407));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(247));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(173);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(247));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gray-bg":"_10F1IVPp2ku8OIuuu1TS5b","inner":"_1vYhIqRFJgJdqDdus33z4A _41i8Pp6PmcXzDbgWssrnp","reviews-header":"_1uNV8jl_a1F48ykdZvHQ0i","no-review-header":"GawCKSudw2fxrezso6CEj _1uNV8jl_a1F48ykdZvHQ0i","reviews-filter":"_3jQMzZTdBDrB2XKAa3Okk6 _13UyNN6lRQaIE4nGDzE2-d","reviews-container":"TaojeO2GkHWH_Huq3DGcn","no-review":"_3mF_bRcuEYDWxHWRTngkyU","no-review-icon":"_2z6dckT3-ZqgmqQa6Gc_S2","load-more":"_2RNK2HFF8l6e07k79ucU2A OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","center":"_1wDb-5Yqdq4ZtBzUQ5PUg6","circle":"_3YOxDpC77Si554SLwD2hHn","circle-1":"_3dVTxCez1Z1fdO2B4De8XA _3YOxDpC77Si554SLwD2hHn","circle-2":"_3EdtxjUT_9EkC8ilRZzfYl _3YOxDpC77Si554SLwD2hHn","circle-3":"_1kGuohgObT51IFiDBJXvHJ _3YOxDpC77Si554SLwD2hHn","circle-4":"_3MMr2NcVN2d_BWCZWfi4-0 _3YOxDpC77Si554SLwD2hHn","circle-5":"_1uMUXxVgjFP9rlzkyBPK5u _3YOxDpC77Si554SLwD2hHn","circle-6":"_1SGgPvDfekMZl9hLIgbPwp _3YOxDpC77Si554SLwD2hHn","wo":"MrJiXR_o7a5mRcjOMBDW9"};

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9768ba13770b5b3ce9a749893d493464.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00b7d6b298ad30005f0513fffe4fc1df.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5e6f06c28c8f6f9d1dae87fbce3af7fa.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54a94f7bcc21d6265fe71cdc94843043.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "578b3fe07e3c83dc947429bcb337fee7.jpg";

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(502);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Reviews = __webpack_require__(428);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _Review = __webpack_require__(262);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Reviews: {
	    displayName: 'Reviews'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/Reviews.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	// import RadioReview from './RadioReview';
	var img1 = __webpack_require__(48);
	var img2 = __webpack_require__(433);
	var img3 = __webpack_require__(434);
	var img4 = __webpack_require__(435);
	var img5 = __webpack_require__(436);
	var img6 = __webpack_require__(437);
	
	var Reviews = _wrapComponent('Reviews')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.session.user
	  };
	}, {}), _dec2 = (0, _reactCssModules2.default)(_Reviews2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Reviews, _Component);
	
	  function Reviews(props) {
	    (0, _classCallCheck3.default)(this, Reviews);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Reviews.__proto__ || (0, _getPrototypeOf2.default)(Reviews)).call(this, props));
	
	    _this.loadmore = _this.loadmore.bind(_this);
	
	    if (!(typeof _this.loadmore === 'function')) {
	      throw new TypeError('Value of "this.loadmore" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.loadmore));
	    }
	
	    _this.state = {
	      reviewType: 'recent',
	      show: 3
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Reviews, [{
	    key: 'onChange',
	    value: function onChange(type) {
	      this.setState({ reviewType: type });
	    }
	  }, {
	    key: 'loadmore',
	    value: function loadmore() {
	      this.setState({ show: this.state.show + 3 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var show = this.state.show;
	      var _props = this.props,
	          user = _props.user,
	          reviews = _props.reviews,
	          woReview = _props.woReview,
	          lxName = _props.lxName;
	
	      var count = reviews.length + woReview;
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'div',
	          { styleName: 'gray-bg' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'inner' },
	            _react3.default.createElement(
	              'div',
	              { styleName: count > 0 ? 'reviews-header' : 'no-review-header' },
	              _react3.default.createElement(
	                'h2',
	                null,
	                'Booking & Review'
	              ),
	              count > 0 ? _react3.default.createElement(
	                'span',
	                null,
	                '\xA0',
	                '(',
	                count,
	                ')'
	              ) : _react3.default.createElement(
	                'span',
	                null,
	                '\xA0'
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          count > 0 ? _react3.default.createElement(
	            'div',
	            { styleName: 'reviews-container' },
	            _react3.default.createElement(
	              _reactAddonsCssTransitionGroup2.default,
	              {
	                transitionName: 'modal-transition',
	                transitionEnterTimeout: 200,
	                transitionLeaveTimeout: 200
	              },
	
	              // this.props.reviews.filter((obj)=> {
	              //   if (reviewType === 'positive') {
	              //     if (obj.score >= 4) {
	              //       return true;
	              //     }
	              //     return false;
	              //   } else if (reviewType === 'negative') {
	              //     if (obj.score <= 2) {
	              //       return true;
	              //     }
	              //     return false;
	              //   }
	              //   return true;
	              // })
	              this.props.reviews.map(function (review, index) {
	                if (index < show) {
	                  return _react3.default.createElement(_Review2.default, { key: review._id, review: review, user: user });
	                }
	                return null;
	              })
	            ),
	            woReview > 0 && _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(
	                'div',
	                { styleName: 'center' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-1' },
	                  _react3.default.createElement('img', { src: img1, alt: '1st traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-2' },
	                  _react3.default.createElement('img', { src: img2, alt: '2nd traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-3' },
	                  _react3.default.createElement('img', { src: img3, alt: '3rd traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-4' },
	                  _react3.default.createElement('img', { src: img4, alt: '4th traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-5' },
	                  _react3.default.createElement('img', { src: img5, alt: '5th traveler' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'circle-6' },
	                  _react3.default.createElement('img', { src: img6, alt: '6th traveler' })
	                )
	              ),
	              _react3.default.createElement(
	                'h3',
	                { styleName: 'wo' },
	                '+ ',
	                woReview,
	                ' more travelers have enjoyed the local experience with ',
	                lxName
	              )
	            ),
	            show < this.props.reviews.length && _react3.default.createElement(
	              'a',
	              { styleName: 'load-more', onClick: this.loadmore },
	              'Load more'
	            )
	          ) : _react3.default.createElement(
	            'div',
	            { styleName: 'no-review' },
	            _react3.default.createElement('div', { styleName: 'no-review-icon' }),
	            _react3.default.createElement(
	              'p',
	              null,
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews.no_review', values: { lineBreak: _react3.default.createElement('br', null), name: lxName } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Reviews;
	}(_react2.Component), _class2.propTypes = {
	  woReview: _react2.PropTypes.number,
	  lxName: _react2.PropTypes.string,
	  user: _react2.PropTypes.object,
	  reviews: _react2.PropTypes.array
	}, _class2.defaultProps = {
	  woReview: 0,
	  reviews: []
	}, _temp)) || _class) || _class));
	
	exports.default = Reviews;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Product: {
	    displayName: "Product"
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: "/home/runner/work/redux-frontend/redux-frontend/src/components/StructuredData/Product.js",
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Product = _wrapComponent("Product")((_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Product, _Component);
	
	  function Product() {
	    (0, _classCallCheck3.default)(this, Product);
	    return (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Product, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          ratingValue = _props.ratingValue,
	          reviewCount = _props.reviewCount,
	          price = _props.price;
	
	      return _react3.default.createElement(
	        "div",
	        { itemScope: true, itemType: "http://schema.org/Product" },
	        _react3.default.createElement("div", { itemProp: "name", content: name }),
	        (reviewCount || 0) > 0 && _react3.default.createElement(
	          "div",
	          { itemScope: true, itemProp: "aggregateRating", itemType: "http://schema.org/AggregateRating" },
	          _react3.default.createElement("meta", { itemProp: "ratingValue", content: ratingValue || 0 }),
	          _react3.default.createElement("meta", { itemProp: "reviewCount", content: reviewCount || 0 })
	        ),
	        price && _react3.default.createElement(
	          "div",
	          { itemScope: true, itemProp: "offers", itemType: "http://schema.org/Offer" },
	          _react3.default.createElement("meta", { itemProp: "priceCurrency", content: "THB" }),
	          _react3.default.createElement("meta", { itemProp: "price", content: price })
	        )
	      );
	    }
	  }]);
	  return Product;
	}(_react2.Component), _class.propTypes = {
	  name: _react2.PropTypes.string,
	  ratingValue: _react2.PropTypes.number,
	  reviewCount: _react2.PropTypes.number,
	  price: _react2.PropTypes.number
	}, _temp));
	
	exports.default = Product;
	module.exports = exports["default"];

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(544);


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CopyToClipboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(166);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _copyToClipboard = __webpack_require__(360);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CopyToClipboard = exports.CopyToClipboard = (0, _createReactClass2.default)({
	  propTypes: {
	    text: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.element.isRequired,
	    onCopy: _propTypes2.default.func,
	    options: _propTypes2.default.shape({
	      debug: _propTypes2.default.bool,
	      message: _propTypes2.default.string
	    })
	  },
	
	  onClick: function onClick(event) {
	    var _props = this.props,
	        text = _props.text,
	        onCopy = _props.onCopy,
	        children = _props.children,
	        options = _props.options;
	
	
	    var elem = _react2.default.Children.only(children);
	
	    var result = (0, _copyToClipboard2.default)(text, options);
	
	    if (onCopy) {
	      onCopy(text, result);
	    }
	
	    // Bypass onClick if it was present
	    if (elem && elem.props && typeof elem.props.onClick === 'function') {
	      elem.props.onClick(event);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props,
	        _text = _props2.text,
	        _onCopy = _props2.onCopy,
	        _options = _props2.options,
	        children = _props2.children,
	        props = _objectWithoutProperties(_props2, ['text', 'onCopy', 'options', 'children']);
	
	    var elem = _react2.default.Children.only(children);
	
	    return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
	  }
	});
	//# sourceMappingURL=Component.js.map

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(503),
	    CopyToClipboard = _require.CopyToClipboard;
	
	module.exports = CopyToClipboard;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	};

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(281);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(281);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  };
	
	  // Check whether the tooltip with orientation p is completely inside the client window
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ['top', 'bottom', 'left', 'right'];
	  var insideList = [];
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace = void 0;
	  if (inside(desiredPlace) && desiredPlace !== place) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: { place: newPlace }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(546);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(545);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(406);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(408);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(410);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(409);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(57);
	
	var _PropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(359);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(24);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(554);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),

/***/ 554:
148,

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(26);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _TripDetail = __webpack_require__(1282);
	
	var _TripDetail2 = _interopRequireDefault(_TripDetail);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reduxAsyncConnect = __webpack_require__(34);
	
	var _trip = __webpack_require__(47);
	
	var tripDetailAction = _interopRequireWildcard(_trip);
	
	var _search = __webpack_require__(80);
	
	var _redirect = __webpack_require__(326);
	
	var _Main = __webpack_require__(1635);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Product = __webpack_require__(474);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Gallery = __webpack_require__(1526);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Modal = __webpack_require__(55);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ShareSocialsModal = __webpack_require__(1644);
	
	var _ShareSocialsModal2 = _interopRequireDefault(_ShareSocialsModal);
	
	var _customize = __webpack_require__(64);
	
	var _media = __webpack_require__(21);
	
	var _initialLoadSuccess = __webpack_require__(98);
	
	var _gallery = __webpack_require__(218);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  TripDetail: {
	    displayName: 'TripDetail'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/TripDetail/TripDetail.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import Scroll from 'react-scroll';
	// const Element = Scroll.Element;
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var TripDetail = _wrapComponent('TripDetail')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var dispatch = _ref.store.dispatch,
	        slug = _ref.params.slug;
	
	    return dispatch((0, _trip.load)(slug)).then(function (res) {
	      if (res.is_redirect && res.slug) {
	        return dispatch((0, _redirect.setRedirectedPath)('/trip/' + res.slug));
	      }
	      if (res.is_redirect && res.location) {
	        return dispatch((0, _redirect.setRedirectedPath)('/to/' + res.location, 302));
	      }
	      return dispatch((0, _search.setLastTripId)(res._id));
	    }).catch(function () {
	      return dispatch((0, _initialLoadSuccess.loadFailed)());
	    });
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    trip: state.trip.data,
	    isOpenShare: state.trip.openShare,
	    peerReview: state.routing.locationBeforeTransitions.query.peerReview === 'true'
	  };
	}, (0, _extends3.default)({}, tripDetailAction, { openGallery: _gallery.openGallery, logCustomizeTrip: _customize.logCustomizeTrip })), _dec3 = (0, _reactCssModules2.default)(_TripDetail2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(TripDetail, _Component);
	
	  function TripDetail(props) {
	    (0, _classCallCheck3.default)(this, TripDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TripDetail.__proto__ || (0, _getPrototypeOf2.default)(TripDetail)).call(this, props));
	
	    _this.closeShare = _this.closeShare.bind(_this);
	    // this.handleScroll = this.handleScroll.bind(this);
	    // this.state = {
	    //   hideMobileAction: false,
	    // };
	
	    if (!(typeof _this.closeShare === 'function')) {
	      throw new TypeError('Value of "this.closeShare" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.closeShare));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(TripDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.peerReview) this.props.loadPeerReview(this.props.trip.slug);
	      if (window.hj) window.hj('tagRecording', ['trip-detail']);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.openShare(false);
	      this.props.openGallery(false);
	      this.props.openChat(false);
	      // if (this.props.peerReview) window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'closeShare',
	    value: function closeShare() {
	      this.props.openShare(false);
	    }
	
	    // handleScroll() {
	    //   if (this.props.peerReview && this.refs.peerReview) {
	    //     const rect = this.refs.peerReview.getBoundingClientRect();
	    //     const elemCenter = (rect.top + rect.bottom * 2) / 3;
	    //     if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
	    //       this.setState({ hideMobileAction: true });
	    //     } else {
	    //       this.setState({ hideMobileAction: false });
	    //     }
	    //   }
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          peerReview = _props.peerReview;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(_reactHelmet2.default, {
	          title: trip.title || trip.name,
	          meta: [{ 'property': 'og:image', 'content': (0, _media.path)(trip.cover_image) }, { 'property': 'og:description', 'content': trip.meta_description || trip.introduction }, { 'property': 'og:site_name', 'content': 'TakeMeTour - ' + (trip.title || trip.name) }, { 'property': 'description', 'content': trip.meta_description || trip.introduction }, { 'property': 'keywords', 'content': trip.keywords || [trip.destination_location].concat((0, _toConsumableArray3.default)(trip.activities)).join(',') }]
	        }),
	        _react3.default.createElement(_Product2.default, { name: trip.name, ratingValue: trip.user_id.rating.average_rating, reviewCount: trip.reviews.length, price: trip.full_prices[1] ? trip.full_prices[1].perPerson : trip.full_prices[0].perPerson }),
	        _react3.default.createElement(_Main2.default, { peerReview: peerReview }),
	        _react3.default.createElement(_Gallery2.default, { defaultAlt: trip.name, images: trip.images, video: trip.video_url }),
	        _react3.default.createElement(
	          _Modal2.default,
	          { isOpen: this.props.isOpenShare, onClose: this.closeShare, centerVertical: true, style: { 'maxWidth': '600px', 'padding': '0', 'margin': '0 auto' }, id: 'trip-share' },
	          _react3.default.createElement(_ShareSocialsModal2.default, { slug: trip.slug })
	        )
	      );
	    }
	  }]);
	  return TripDetail;
	}(_react2.Component), _class2.propTypes = {
	  peerReview: _react2.PropTypes.bool,
	  trip: _react2.PropTypes.object,
	  openShare: _react2.PropTypes.func,
	  isOpenShare: _react2.PropTypes.bool,
	  openGallery: _react2.PropTypes.func,
	  openChat: _react2.PropTypes.func,
	  loadPeerReview: _react2.PropTypes.func
	}, _temp)) || _class) || _class) || _class));
	
	exports.default = TripDetail;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _creatorsGoogleMapHolder = __webpack_require__(99);
	
	var _creatorsGoogleMapHolder2 = _interopRequireDefault(_creatorsGoogleMapHolder);
	
	var USE_NEW_BEHAVIOR_TAG_NAME = "__new_behavior__"; /* CIRCULAR_DEPENDENCY */
	
	var GoogleMapLoader = (function (_Component) {
	  _inherits(GoogleMapLoader, _Component);
	
	  function GoogleMapLoader() {
	    _classCallCheck(this, GoogleMapLoader);
	
	    _get(Object.getPrototypeOf(GoogleMapLoader.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {
	      map: null
	    };
	  }
	
	  _createClass(GoogleMapLoader, [{
	    key: "mountGoogleMap",
	    value: function mountGoogleMap(domEl) {
	      if (this.state.map || domEl === null) {
	        return;
	      }
	      var _props$googleMapElement$props = this.props.googleMapElement.props;
	      var children = _props$googleMapElement$props.children;
	
	      var mapProps = _objectWithoutProperties(_props$googleMapElement$props, ["children"]);
	
	      //
	      // Create google.maps.Map instance so that dom is initialized before
	      // React's children creators.
	      //
	      var map = _creatorsGoogleMapHolder2["default"]._createMap(domEl, mapProps);
	      this.setState({ map: map });
	    }
	  }, {
	    key: "renderChild",
	    value: function renderChild() {
	      if (this.state.map) {
	        // Notice: implementation details
	        //
	        // In this state, the DOM of google.maps.Map is already initialized in
	        // my innerHTML. Adding extra React components will not clean it
	        // in current version*. It will use prepend to add DOM of
	        // GoogleMapHolder and become a sibling of the DOM of google.maps.Map
	        // Not sure this is subject to change
	        //
	        // *current version: 0.13.3, 0.14.2
	        //
	        return _react2["default"].cloneElement(this.props.googleMapElement, {
	          map: this.state.map,
	          // ------------ Deprecated ------------
	          containerTagName: USE_NEW_BEHAVIOR_TAG_NAME
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].cloneElement(this.props.containerElement, {
	        ref: this.mountGoogleMap.bind(this)
	      }, this.renderChild());
	    }
	  }], [{
	    key: "propTypes",
	    value: {
	      containerElement: _react.PropTypes.node.isRequired,
	      googleMapElement: _react.PropTypes.element.isRequired },
	    enumerable: true
	  }, {
	    key: "defaultProps",
	    /* CIRCULAR_DEPENDENCY. Uncomment when 5.0.0 comes: propTypesElementOfType(GoogleMap).isRequired, */
	    value: {
	      containerElement: _react2["default"].createElement("div", null)
	    },
	    enumerable: true
	  }]);
	
	  return GoogleMapLoader;
	})(_react.Component);
	
	exports["default"] = GoogleMapLoader;
	module.exports = exports["default"];

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addDefaultPrefix;
	
	function addDefaultPrefix(name) {
	  return "default" + (name[0].toUpperCase() + name.slice(1));
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 757:
148,

/***/ 1162:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gallery":"_1SfjSSuz4oVi8KNW8SPpoi","gallery-open":"_3gpoLC2l9_zpK9yzkX7Kqm _1SfjSSuz4oVi8KNW8SPpoi","caption-container":"_28qTNr5c9PJ8X4l8o-ImN5","gallery-content":"_1Q2dagadnlCuc9s0P4WXbX","btn-close":"_1iBlILfKJBKYbqkcmH_jDG","slide-show":"_3ricYEgnHObub6uWNhOrAh","image":"_2xAbtviXg-GrZZaw2wBRNC _3jblqlydyeJqpKzpSv89pq","mobile-slide-show":"_1WXLr8dmB8e61-LEtt3wgR","left-arrow":"_3o5xHuD44Pi1MlwNsEyfxH","right-arrow":"_2UPWLlp2HqGXHUOF5ep7OM","mobile-left-arrow":"_2FaNLZ_Q7QQPhcDegiPheH _3o5xHuD44Pi1MlwNsEyfxH","mobile-right-arrow":"_3xIZBVJ3Om6vpkw18UjDbx _2UPWLlp2HqGXHUOF5ep7OM","image-container":"_32EG8Eppt__DK9F2kJW-U3","caption":"XPtAp9MuWR_JRUi_6zdN4","index":"_2p9JqWg2jI4cnSfB4HfZ8T","images-container":"_1IkdmF5bYvIMziR-VUS7yQ _13UyNN6lRQaIE4nGDzE2-d","thumbnail-container":"_2PMFSmkoMIN9iq5bYdFFau","thumbnail":"_3Z-HaSdvc5Ffsti8fdZKXD","shadow":"_1ppFSHKpsKoNhIwrxDZ-23","social-container":"PGdRkMh-pdVBy6_Rw2qXk","socials":"_2TPNPwRpeDDuvhqq2bvEJY","video-container":"_3T1K-uzkuBL7PBKtDf8NKI","play":"SLTz7Lik3NN4P9PwZwxGV"};

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"social-flex":"_1QY1Mtv6u-zXxsbtBBbwMa","social-link":"AP0yK4g6l7Y0ZkhZbVP4e","button-group":"_3CYK4WMnXIKFasVGQTTDfg","button":"_3k2Nv3PlRxzx_pKYIv9Dgh _3z4hgu4l-VC5FW-cdBc-3C"};

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cover-container":"_1MxpIOm79gQPQXD6qojnF4","cover-picture":"_33RcrGTUdBJhGa_dXTGtoy","cover-left":"_2jGRDbBzj8jEja1MfwTkXc","cover-right":"_3Pg1HkHAA0XHyjc11oZaQ5","cover-inner":"_3WCv64qRa0EKxJeMc3m5za","cover-shadow-filter":"_23p5WkA-bDsrKZJuc2vOl","cover-blur":"_2LWWFf6MxQLN1KFuJINNtz","cover-aspect-ratio":"_3KxHzMYSOLEeVheskrvW_A","cover-picture-img":"_14DACtaXmAXFLZlCjIbyXY","cover-shadow":"berhXRWusDqAfEth9dF0c _3jblqlydyeJqpKzpSv89pq","mobile-price-container":"_3G-a4WJ9aWmlDPkSSpGG8g","mobile-discount":"_1e1qyB8g7i2yVGOU-Wshqc","mobile-price":"_2gem5UJzr8RzVgj1J_Sh6u","mobile-best-price":"_3D6LWhKGwhM1nqbi5pJCZx","mobile-cross-price":"_1FEJskdj65lx6uhilQKaVG","mobile-sale-price":"_3wQSxiN6B3JJet-F_vtvhy","mobile-wishlist":"LiYAuAIdzN5vJjAqpEEgi","mobile-share":"_1jy7NloxMTDRsFQ31DtaR4","share-button":"_3Gn4nl9PTfWMctIw1B-L3H","play-banner":"NEWNgoJD1agq9_yrwjXZF"};

/***/ }),

/***/ 1228:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"chat-container":"_26iwuHzSEmTjUSgnOgPlFQ","mobile-label":"iyhe4vHdWLR9dU5EUCxFU _3jblqlydyeJqpKzpSv89pq","chat-info":"_2prIOtqhNyOyFEwNxDzNaf _13UyNN6lRQaIE4nGDzE2-d","lx-pic":"_3QtJO2uXqiLIT0oXqvpuGn","lx-name":"_3GPk48URIe8UluxzXpdflx","city":"_3sgtOM-2bSOBcbDhxyYlkn","topic":"_3KbHlxmhJpT5yCDBAf62mX","bullet":"_-3N84kDTURLsrGydWAKDC","topic-content":"_3EppH3bacQjocbT4Bdpjem","chat-content":"_1OwVnHaZRsJ1gt_0EJ8zwp","mobile-scrollable":"_20ODh12azWUMv71Og5kPnT","float-parent":"_1M018ZJvcZl_GdQ06QSUGx","options":"_2jas_uTS9SWw5_UcFX3cRo","option":"_26oz3Ak5yJnlOCdZn1NkMv","label":"AcVia0FIkS42zKEe54P2E","icon-template":"_5OZc6fZdANrSepXsNlkCg","calendar-icon":"lbOfoH-GrfFIId3gAm0iK _5OZc6fZdANrSepXsNlkCg","guest-icon":"_3XgwAXBfOERquK-BftNAsM _5OZc6fZdANrSepXsNlkCg","label-text":"_1_eTvzb5wwWS03jKPuOoCa","input-container":"_1QuvAKxAfJZakK8HSh-lvk","custom-input":"_3Pobx6s0TypSY2-pGAXlMk rHLXxVOx3RK6JEEL0S_nO","custom-input-error":"_3kp1JuVqJgqUb5JkSMdvOj _3Pobx6s0TypSY2-pGAXlMk rHLXxVOx3RK6JEEL0S_nO","chat-box-container":"_1GxS_B8OjFNMc5YEijhe6o","custom-textarea":"_1eQTvcd5pU9pDXIowH-ifh _12vtPHiMW9qKcsnFOTiZqJ","btn-container":"f3FoSwjbRWYpnNEnP-EjD _13UyNN6lRQaIE4nGDzE2-d","btn-container-mobile":"ttViIIQPiLh3_hb-ugGCf _3jblqlydyeJqpKzpSv89pq","btn-send-msg":"_3EVhebyevtA7RPT4kCFa3R _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-send-msg-loading":"_10bOuBa2QN8O2arlgVzgZv _3EVhebyevtA7RPT4kCFa3R _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-send-msg-disable":"_3J5I5GSHO1_mR0wGJkgYMK _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","btn-close":"wH2JlSIdsSG9eCUyCza2d OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","date-picker":"_2Ms8OAgRt-uEFDYo5imSLl _13UyNN6lRQaIE4nGDzE2-d","date-picker-mobile":"_1XJLDlo8SuA6gg71HqvKIN _3jblqlydyeJqpKzpSv89pq","chat-info-mobile":"_1ppTdGb-d78VVSxDX6DjeX _3jblqlydyeJqpKzpSv89pq","lx-profile-mobile":"_1O6D1WggQtj8dKtYRhrnkI","checkbox-container":"_77Xr8gqnknyidW11W0vHO","checkbox":"_2ClByzWlhJ_E8HTjvVNkCj","checkbox-checked":"_2_ZEdN0wZqlLP75rM4gkmY _2ClByzWlhJ_E8HTjvVNkCj","checkbox-label":"_1AKpuewwqAy_SzcDg0pkP6","checkbox-error":"_387f3tlSDHsKFx5zsrh5ba _2ClByzWlhJ_E8HTjvVNkCj","checkbox-error-checked":"_1DO3s10pJ1n2VaUcqcrr8i _2_ZEdN0wZqlLP75rM4gkmY _2ClByzWlhJ_E8HTjvVNkCj","checkbox-label-checked":"_2FzML5rRpyDRH4wYvw0xtJ _1AKpuewwqAy_SzcDg0pkP6","checkbox-label-error":"BVLv8vw6ZnzCrob3rXdbH _1AKpuewwqAy_SzcDg0pkP6","checkbox-label-error-checked":"_2G5jP3_-5ScApAvEQsN6EX _2FzML5rRpyDRH4wYvw0xtJ _1AKpuewwqAy_SzcDg0pkP6"};

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sub-header":"_3mlstcy4RPlDngMSWDVd6Y","activities":"_2uJ9cUU8YLV_Pbv4_WS_D8","activities-condition":"_2dSxvjR_vXSPcibf-1rdCl _2uJ9cUU8YLV_Pbv4_WS_D8","activities-label":"_3tiqCNNDaEn6t6YoSITV0G","activities-condition-label":"_3dnC91p_FP2vAcA5Rugyj1","activities-detail":"_15aZfLLddqSewkYFqoxGMD","activity-icon-template":"U1xwLZgXP4YVoDgZAX1tp","location-icon":"_3OZpuIIzPesKjG4ztYR26G U1xwLZgXP4YVoDgZAX1tp","stop-icon":"_6sDEmc_Oqfrii0Ow-RYlz U1xwLZgXP4YVoDgZAX1tp","max-travelers-icon":"_2AvvVg3bh3kj8JpLm3ojf U1xwLZgXP4YVoDgZAX1tp","transportation-icon":"_1gA7pRcNhD7wb44eLol-kM U1xwLZgXP4YVoDgZAX1tp","language-icon":"_1PEXls1PzjgBBCpUTYnXdT U1xwLZgXP4YVoDgZAX1tp","condition-icon":"jPzqGmRRQ1v8WGwZoOGmv U1xwLZgXP4YVoDgZAX1tp","activity-icon-template-condition":"_1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","smart-casual":"Gz-hj-t_Am_tJsILcL5dl _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","physical-strength":"_3aJAsXT58tkrKtvOBXN2gq _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","vegeterian-food":"_3rmpzfCj29hIcQGFn7fHBE _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","children-friendly":"_4otoKa3nX73Og-06tQ8ng _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","flexible-plan":"_1cB-KsCvdIGDYiPB2CdN4L _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp","seasonal-activity":"_1EdlzyyK6yQ-L8YQZibs1V _1EjOQqtuo2pysqyEIYWxt4 U1xwLZgXP4YVoDgZAX1tp"};

/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sub-header":"_2qbc2UYqtrWLOf_hilSEX5","faq":"_1audRqONxSDTy1KyBkS6xk","faq-detail-container":"_18vb6RXiuLjXdCQXTTHoM_","faq-label-container":"_1JDZsNwVnCLcSUc-_1SWhl"};

/***/ }),

/***/ 1231:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"trip-images":"_1fQvWFpOmV4CcS_lAlsSlh","image-container":"_2GbWgi53dX-5KiKPE_CVQJ","image-container-preload":"xvgndx_ABLLbTGlID06NK _2GbWgi53dX-5KiKPE_CVQJ","image":"_3sEss_ndlGkxKHgBt7HTLK","image-img":"_22zidSEMx7jxO8zxgMTJ_9","play-gallery":"_10wPspThRe1P5JL9Iq-bZh","image-shadow-template":"_2BP_koFNJ9FQHphZRzfsKk","image-shadow":"CmGk_fB8I_aO056OOI-U3 _2BP_koFNJ9FQHphZRzfsKk _13UyNN6lRQaIE4nGDzE2-d","image-shadow-mobile":"_1NTpTBfXeR2kCJ90aqxRe2 _2BP_koFNJ9FQHphZRzfsKk _3jblqlydyeJqpKzpSv89pq"};

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_1VeGdvVyTtLheB1uVQrWZc","share-wishlist-container":"_1yhFymZaGmBsJgZV-H6lE6 _13UyNN6lRQaIE4nGDzE2-d","share-container":"_3TKflFmp7PqT3VIruWq9qU","share-button":"_3iUZucoeNLvBK6r4mtQU6B","tags":"_1dgBgGgMWFz8iE9Z4IdQjB","tag-container":"achAQZT0e8lsLgi5JOuG4","tag-icon-template":"_1oUqfx8u5IAVfYYR7pW7nR","tag-band-template":"_2b4uIeCR0ep4y2Z_DHP6zP","tag-arrow-top-template":"_1y2FB_V8hdsJRtkNa42suT","tag-arrow-bottom-template":"_1a1RYAS80UPZbi8U3Mjlsq","tmt-tag-icon":"_2HgZPeOul5TcioAmuXLKOg _1oUqfx8u5IAVfYYR7pW7nR","tmt-tag-band":"svug-LVl03J8--c8EeCds _2b4uIeCR0ep4y2Z_DHP6zP","tmt-tag-arrow-top":"_4mRgtuXcZ7jCoVSM9LCUt _1y2FB_V8hdsJRtkNa42suT","tmt-tag-arrow-bottom":"_17p-kfTDkc3huq4wCPSiBE _1a1RYAS80UPZbi8U3Mjlsq","instant-tag-icon":"_3T4v77Uk4d3PWeGxjvgqCI _1oUqfx8u5IAVfYYR7pW7nR","instant-tag-band":"_1nw6d6t8o0xonE40ZEGO3D _2b4uIeCR0ep4y2Z_DHP6zP","instant-tag-arrow-top":"_2KClzAtfDfnGK2PGKMxXN6 _1y2FB_V8hdsJRtkNa42suT","instant-tag-arrow-bottom":"_3xgKeWtcZ6tutJETiCPNpH _1a1RYAS80UPZbi8U3Mjlsq","trip-title-with-tag":"LNkBTz0FkQqFlHjZOCHv5","trip-title":"rXgxBk1z4zd771QrCYQIt","trip-location":"_1rNxA8CyHXfZRhxShXbXrp","point-container":"MV6LjFwemSkg4OOMmkB2c","details-container":"_1e8g0LDO8StdPPEs7zFe3w","detail-item-row":"_13Xc9tYj6z62xEL1yYJxI_","detail-item":"_2V_vWYrigwOwTHFbCwNqU7","detail-item-activity":"_3BOAZ47JJQsvR7BEeeuiMF _2V_vWYrigwOwTHFbCwNqU7","icon-detail-template":"_12sBJp4qIeRbCcmioAPq8J","icon-detail-template-main":"_3fSjrVRMGxx1vNrqStgaJt _12sBJp4qIeRbCcmioAPq8J","icon-caption":"_1YAo_Qrp1sSCLayZMmu4R5","popular-icon":"_2FtUK3MDsjvAR4lbtxQAZ8 _3fSjrVRMGxx1vNrqStgaJt _12sBJp4qIeRbCcmioAPq8J","private-car-icon":"_3NeHKJzakSJxqcjIFZ7vN0 _3fSjrVRMGxx1vNrqStgaJt _12sBJp4qIeRbCcmioAPq8J","public-transportation-icon":"_2gM2uWVqX1kgkJ-7y6GuEV _3fSjrVRMGxx1vNrqStgaJt _12sBJp4qIeRbCcmioAPq8J","duration-icon":"_1b951vwVkfF8lTw7e9fvEt _3fSjrVRMGxx1vNrqStgaJt _12sBJp4qIeRbCcmioAPq8J","bazaar":"_2WOLcZ8TEbY8Cg15Mnq9T2 _12sBJp4qIeRbCcmioAPq8J","floating-market":"_1jdV2gGu9zdUMJlICVWK-P _12sBJp4qIeRbCcmioAPq8J","fresh-market":"_1k9Be2KrZ2Z6-zU55hCgmk _12sBJp4qIeRbCcmioAPq8J","flea-market":"_3NBEVaLpqcVDD05UKwHEC9 _12sBJp4qIeRbCcmioAPq8J","cafe":"_3zM_S8yF9hLqJpHuY9sB26 _12sBJp4qIeRbCcmioAPq8J","cooking-class":"_3JsuDFZIBB21d79NEDkWQN _12sBJp4qIeRbCcmioAPq8J","restaurants":"_1SQP44CSi3lSx2-P11rEU_ _12sBJp4qIeRbCcmioAPq8J","street-food":"_1izSI5l69gvJz6JcEjjrt3 _12sBJp4qIeRbCcmioAPq8J","adventure":"_2I8V_Of-vpUu18eH1LOHel _12sBJp4qIeRbCcmioAPq8J","boating":"e1L3OxT90d6CEobm0Jkgb _12sBJp4qIeRbCcmioAPq8J","boxing":"_1tTSefHrSRNHP_sqhfbuuG _12sBJp4qIeRbCcmioAPq8J","city-tour":"_2l5NXBb-9fRnOJ5YXw4osu _12sBJp4qIeRbCcmioAPq8J","cycling":"_1RNl1adWQFLeL_aMntqXhh _12sBJp4qIeRbCcmioAPq8J","beach-n-island":"PlJ823rmV7MWM5paEbhVz _12sBJp4qIeRbCcmioAPq8J","botanic-garden":"_3tSm9Osktc7iHe9ivyDtBP _12sBJp4qIeRbCcmioAPq8J","safari":"_32MH4wRF7UIPcEd0H2XF6l _12sBJp4qIeRbCcmioAPq8J","trekking-n-hiking":"_1ch1xmI4VEbqloNc23l4bP _12sBJp4qIeRbCcmioAPq8J","waterfall":"_3Xn4U7ZKZm4DPjVGCzQtnn _12sBJp4qIeRbCcmioAPq8J","water-activities":"_1yYnXVigtHtDm_uZHjfhLo _12sBJp4qIeRbCcmioAPq8J","local-wisdom-n-living":"UQjJag0VDpkCCfzuZYAVY _12sBJp4qIeRbCcmioAPq8J","volunteering":"FzoxNwROOkqBfZdIscFDC _12sBJp4qIeRbCcmioAPq8J","art-exhibition":"sTodp-q-MXPFZHYkPr4FR _12sBJp4qIeRbCcmioAPq8J","crafting":"_1q33czN1phNudD1VnTZXu_ _12sBJp4qIeRbCcmioAPq8J","drinking":"_1x5QhMaQXnyHQzbTUwBsOJ _12sBJp4qIeRbCcmioAPq8J","history-n-culture":"_2u6QS0uv44XrwPjGgHo6n1 _12sBJp4qIeRbCcmioAPq8J","massage-n-spa":"_8Dv-ciefhTEdPvSu5HPQC _12sBJp4qIeRbCcmioAPq8J","spiritual":"Z7qorI8BbIMssWWrNt88U _12sBJp4qIeRbCcmioAPq8J","farming":"_3FFf7KDm_WyTc2bfQE7BDI _12sBJp4qIeRbCcmioAPq8J","lx-profile":"_16ltvdcTjqM_bU7nnaNNYs","extra-infos":"f7f3okP_xvPwz_2UVPNGG","extra-info":"_3svGPQEuUKqjcXJnWMZlnO","lx-profile-pic":"_3UDrIk0sd37OhpRubphRYf","lx-lx":"qrrMo1vpcWQzqU4RdWq4a","lx-name":"_2Ib9PENDSMjhyiiVXcrxGA","lx-hosted-by":"ykA306VHuNvU-UW_1Bw5i","lx-text":"_1k7jiua-8wcHqSFzvHnD1U","desktop-only":"_1CZ7uVpGUzcV0GIJqOIjOq _13UyNN6lRQaIE4nGDzE2-d","mobile-only":"_2AYvXJv26eEj2TsJ01MmCh _3jblqlydyeJqpKzpSv89pq"};

/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sub-header":"_3j6zRmESeWEpatkzY6lbC1","itinerary":"_2c8iMr-uonrlg6Yrc6Ti6B","time-container":"_1QnwxRdZ7DTheLIAuJFhbk","activity-container":"D3UXEBDHCb8ZeAET5EuZU"};

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_3nbNZack4ZUuNz0MCKTW2w","modal-img":"_3Jv7K2_pFiGNwxg-B8TGv9","outer":"_2wpQzNxL8_VB6Sc-I1mIoV _41i8Pp6PmcXzDbgWssrnp","breadcrumb":"_3PRaZewLVepw0XGkuMsG6I","inner":"_26a5L6e1yGR-GREW6uIz79 _41i8Pp6PmcXzDbgWssrnp","inner-peer":"_2AVa3oY5O7A_Amz9b9eLoE _41i8Pp6PmcXzDbgWssrnp","big-column":"_1D23EI5v9XZx1C_VjiPc-r","desktop-show":"_21iBQqgRR3milBNvimIuN8","inner-calendar":"_9kwZcY5VpxjTROG6oDRC4 _13UyNN6lRQaIE4nGDzE2-d","calendar-slider":"_3aZG9JPdONmY3t-kwNkhJW","slider-item-container":"_2JyaUr5BC1W-4ABuVMBJXO","bg-gray":"_2RBM-AW7F3AcrtAOeXC82Y","inner-similar":"_29-J5zCR-Px0h72OuL8YgI _41i8Pp6PmcXzDbgWssrnp","inner-reviews":"_1-s-IaFjng_lQVvumBNxs","inner-customize":"E816CREQc68YpuuObhiOk _41i8Pp6PmcXzDbgWssrnp","inner-lx":"_1tQonZkqbJkgk9iUToixgY _41i8Pp6PmcXzDbgWssrnp","mobile-only":"YzlNtP02NMdjBZ0EyA3Wx _3jblqlydyeJqpKzpSv89pq","desktop-only":"_1xv8bzPVD5n0pfqQaO1kJs _13UyNN6lRQaIE4nGDzE2-d"};

/***/ }),

/***/ 1235:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_2Jm46-vmsrH1u0M7i6-t4H","map":"DwjWNy_w8pa_IPjdCecU9","meeting-point":"_3gQyp7-pCFM4EubTeB7mfg","header":"_34gxBXoCvvxzEF2JGGjbjc _2F-JnOTAU3pAH0PO-2EJ0i","meeting-points":"JbJ4DsyTT8GsFx5uDe7yz","meeting-point-container":"on6Uw_0minXenG1yhYgui","meeting-point-label":"_3VC_85kKpDf4AvIYNoXyU2","meeting-point-detail":"_2GGYzh8Vf7b7Ht8EnRYKiI","icon-template":"_1kNwTblTvjW4oBgTYPe1S8","location-icon":"_13Lc0uzJTnO_43tt9RbUeI _1kNwTblTvjW4oBgTYPe1S8","airport-icon":"YFQei9XfxHxnBRChO1u55 _1kNwTblTvjW4oBgTYPe1S8","arl-icon":"_3VRufahqwUHGh7-oJEpA8L _1kNwTblTvjW4oBgTYPe1S8","pier-icon":"_3-zePD_m1MsCSV-zASXJAu _1kNwTblTvjW4oBgTYPe1S8","mrt-icon":"Cf_6ZU1WdjaUIMzxz_JVf _1kNwTblTvjW4oBgTYPe1S8","bts-icon":"_100mNq_V6wjSkpiwmQQGl3 _1kNwTblTvjW4oBgTYPe1S8","bus-icon":"_3utklipnYJc-VUteLhrHCK _1kNwTblTvjW4oBgTYPe1S8","hotel-icon":"YnMnuVA9hEH20lLg2CY80 _1kNwTblTvjW4oBgTYPe1S8","train-icon":"_3KlgWsX5NaFfNUHDQn_HN8 _1kNwTblTvjW4oBgTYPe1S8"};

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobile-request-toggle-show":"_1ZFkqQ1pmIPNMZ_9wYRMZq","mobile-request-toggle-hide":"fTa_9Dg9NkTBWAh_Qjx4c _1ZFkqQ1pmIPNMZ_9wYRMZq","mobile-request-action":"Ti5stxkLa72UbzJ0ciuPy","mobile-request-price":"_2idXWLtAL3PzcfSt9bZIxE","mobile-request-price-yellow":"zytbRmqddVPLWUxBvWmHp","btn-request-mobile":"_3Bxmeh0LIqy7-j3gOteskx _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-review":"_1FD9jFhc5IWQqfzX3qCRAq _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-request-mobile-loading":"_3zuIifowycv-_zIM6jGCD7 udGFO9cWSVBcN7dGnMEfN _3z4hgu4l-VC5FW-cdBc-3C","btn-request-first-mobile":"_3zm4yB0BXPUwOITNt-1PKt _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-mobile":"_17FYicRyKDjALpS7m1_Z_x OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-mobile-loading":"_2oLyS-xV4VP5CmS3ry50FB udGFO9cWSVBcN7dGnMEfN _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-facebook":"_1_bVpxhW1xVlJZZPvM0H5n OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-line":"_1whzSGbX0qEP9g2ipq_ORg OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C"};

/***/ }),

/***/ 1237:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_3T08reOKGISprrR9DPpgdd","tabs":"_2gSsP8udYdJIOk2fY_9B1N","tab":"_22gpN_n1sT0hcflJe2uhOM","active":"_2SZKz9tFB6WIVjLe8ELml _22gpN_n1sT0hcflJe2uhOM","non-active":"y95IrdjSw0hmHnvVZPwhf _22gpN_n1sT0hcflJe2uhOM"};

/***/ }),

/***/ 1238:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader-container":"z9R76qt-9obXYd56Q-6S1","main-container":"_28d1XszjLZVh2uex1Yr0-m","header":"TIHBD8Qs2xXKc5Honh8cn","description":"_1cD9CV-_tT9ueyCsda8kRQ","rating":"_3J1E5IM3Son5RfIvfgkMTZ","star-template":"_2jxsMqFNYzhdHlnTgBDltQ","star":"_3PtcXwxvKhhUJQHiWqF2FP _2jxsMqFNYzhdHlnTgBDltQ","star-o":"_1RByxv-bCU2LF904T84X42 _2jxsMqFNYzhdHlnTgBDltQ","score-text":"_3A7QsHKiQqgagDqxhXsUI7 _1cD9CV-_tT9ueyCsda8kRQ","btn-disable":"_12QfG6KRumLLy2QqTfentO _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","btn-loading":"_1YtN4QckouRG7c4QMU1i9B _3bodqrqvroPHAgaOVPUjqb _3z4hgu4l-VC5FW-cdBc-3C","btn-submit":"_2Co5PoT8wBgyUC8rNSpnIE _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","custom-checkbox":"_1oPRk6YOiQ3ZKfY9IMwhog _1tj-Eypyou-ILgeBZCUDYH"};

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_24j2AeaRLZja1FtLwMXRv1","link":"_3b7eGJC85vpHzY1F-zd8HO _3jblqlydyeJqpKzpSv89pq","header":"_4SHuVo592ZQSJmlprzOsz _2F-JnOTAU3pAH0PO-2EJ0i","counter":"_2XrXsI-qyxA1ZY4U8V_Hyf UiOtkwjAwJvCk7RAufbT2","current":"_2StDYyaEkN1tbTlc4OKw9h"};

/***/ }),

/***/ 1240:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sub-header":"n4X_wb-Hm5yQLpRQJVH_q","price-container":"_1vBABDyy-uaL7aGlwBW8Oa","price-cond-label":"_2gBOR9XzDeAhc0K5mxDqb","price-cond-detail":"_1SVxQrgnEBLRASjotMi5so","price-cond-icon":"sHPjFkB3SOwRSqDyJBDFz","inc-food":"i0RIggKZLKrAPx4feSGjd sHPjFkB3SOwRSqDyJBDFz","inc-transport":"_1y4HHQb_t9vjj9fk-OlWXE sHPjFkB3SOwRSqDyJBDFz","inc-ticket":"_3svmFZ2Gc7mrZ0BX9t2Fqx sHPjFkB3SOwRSqDyJBDFz","exc-food":"_3RZk8rP5HVsuJoDl1QFMAk sHPjFkB3SOwRSqDyJBDFz","exc-transport":"_27ykzpgPkLJy0iMYTBTEX6 sHPjFkB3SOwRSqDyJBDFz","exc-ticket":"_1csIkkU9J7ld2iy8Ky_rDN sHPjFkB3SOwRSqDyJBDFz","price-cond-details":"_3fNVKlKPO9LS7Q7w2U8mHc","price-cond-check":"_1o5ORj_DYPKIxkmJPvWLIg","price-cond-uncheck":"_3qAZjLVbqE3efCDoHsPPJB","price-extra":"_3IqASl19GzuHGfWTnwENBA"};

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_6gQJ1GVbahfogApTJKL_0","mobile-label":"_2k3J9_Bj2bzWTQKfW9sZdf _3jblqlydyeJqpKzpSv89pq","calendar-action-container":"_3eEJLo0D_IUw-7o4P-D0Jr","max-travelers-container":"_2BVBGsde5cKcs8AtALb1Vg","max-travelers-icon":"BUKt0fHZsSxog8MLfo-7f","input-container":"_1TKpjAQJAhB7Hs4nHlU1wT","price-container":"_3UAM-zh_ALzT38FeUJQ4Rw","price-label":"_32wdnZAyn_IcOZz1CxmF92","price-icon":"_2qU6OmFQnRpswDt8NsR2wd","price-per-person-icon":"_1xAXsWeQxwOTh_oWldQL9r _2qU6OmFQnRpswDt8NsR2wd","price-detail":"_298nlUR5e9r5j_YHlBQUS7","percent-off":"-P9rM5zdfyjpashcLdZ2P","price":"_2nZ8wQSz7TOOMFbPwLq3-g","cross-price":"_3RjW3sQ1muwtkYnKUrLidc","btn-review":"_2fhk9sLbS0SSJj3m8YKZrm _10gXunHHbkdD6D8cc58EW_ _3z4hgu4l-VC5FW-cdBc-3C","btn-request":"_358JxyjMkiFZZxul3BE0mz _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-request-disable":"_1DsIhK1VbtetDUT9TpYGw1 _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","btn-request-loading":"_3DSIEPf1nLox9rx2XN1l6v _358JxyjMkiFZZxul3BE0mz _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","btn-close":"_3pyGYchZBG-OIPkdh6Yil4 OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat":"_35Y_lIIhEQEYnK-obMf2rf OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-facebook":"_2XWd6HlAsLFzaT53E2AlFb OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-line":"_6EGkyXM-Q01ZHPLI66V-l OobMZDuSoBdAPNuYanGv5 _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-facebook-disabled":"_2uXUCVKsqF-C2dpTw1ZVoH _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-line-disabled":"_2OxUMtTrspMYXphYhJazg0 _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","btn-chat-disable":"_2rIpUrC2EpylAFSapcLGOI _24IPHs-oZrYRMHaz-cR32D _3z4hgu4l-VC5FW-cdBc-3C","action-container":"_3bdn5WRegdWMx5mHoJlWys _13UyNN6lRQaIE4nGDzE2-d","mobile-action-container":"wRuMpdg55bCn8aMtlrNhr _3jblqlydyeJqpKzpSv89pq","guarantee":"_213aYZ4slDREiD9dkAEHD1","question-mark":"_1BvIFxVHI9o2jez_5EsyJK","tooltip-header-container":"_3DkdbG8W2D6QY96Gu2A3uq","inspiration-icon":"_3hlapNRHDM-EIqorr7Mwq_","tooltip-header":"_1UXc0hi32gUUBBrwzAd-Nb","tooltip-content":"S0NABDosWDYcHwIC0R51p","mobile-guarantee-show":"_2TeagjQZkgdXVGj2tQl5Fs","mobile-guarantee-hide":"_2lfviv2vF8AaQnXKYvF7lU","checkbox-container":"_3nFwjqPEEcrMRbeHFQFmiK","checkbox":"_3gyE2pQN_Bh3LLQ2YiuGBL","checkbox-checked":"_3rdmKDtIP_1RgxzMprKuQV _3gyE2pQN_Bh3LLQ2YiuGBL","checkbox-label":"_1uPk-f_JFMqAOwmBC9LTUR","checkbox-label-checked":"yyOszrtMq6ppUdsGq0D2I _1uPk-f_JFMqAOwmBC9LTUR","bold":"_194N9bjjlP_1RDgedStDZ-"};

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"social":"u8AiHiCAZSoyUR-HUAZUg","social-head":"_6YT-69wxVKrB-P6JkAdgQ","inner":"H-Q0h26TX22PRWxBFVBvy"};

/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sub-header":"_3WOobXzWh93mDQgZ8P9S_i","group":"B8zsGxiLdH__2Kf2KIil","similar-container":"aPqShsYJTnKlZxz6aslkY"};

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"wJX3UvwMhpUXTClLB8b6A"};

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "913adea3970af5d89087a1879078ad9e.png";

/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "67a848bf363c3651151993419cb19034.png";

/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "55a455e6c5fce4c7ee65194bb8cc4e4c.png";

/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Gallery = __webpack_require__(1162);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _reactRedux = __webpack_require__(11);
	
	var _gallery = __webpack_require__(218);
	
	var galleryActions = _interopRequireWildcard(_gallery);
	
	var _lockscreen = __webpack_require__(154);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Gallery: {
	    displayName: 'Gallery'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/Gallery/Gallery.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Gallery = _wrapComponent('Gallery')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    isOpen: state.gallery.isOpen,
	    activeIndex: state.gallery.activeIndex,
	    items: state.gallery.items
	  };
	}, (0, _extends3.default)({}, galleryActions, { addId: _lockscreen.addId, removeId: _lockscreen.removeId })), _dec2 = (0, _reactCssModules2.default)(_Gallery2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(Gallery, _Component);
	
	  function Gallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Gallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call.apply(_ref, [this].concat(args))), _this), _this.onPrev = function () {
	      _this.props.prev();
	    }, _this.onNext = function () {
	      _this.props.next();
	    }, _this.getThumbnails = function () {
	      var _this$props = _this.props,
	          activeIndex = _this$props.activeIndex,
	          items = _this$props.items;
	
	      var length = items.length;
	      var limit = 7;
	      var half = Math.floor(limit / 2);
	      if (length < limit) {
	        return items;
	      }
	      return _lodash2.default.fill(new Array(limit), '').map(function (num, index) {
	        return items[(activeIndex + index - half + items.length) % items.length];
	      });
	    }, _this.handleKeyUp = function (event) {
	      if (event.keyCode === 37) {
	        _this.onPrev();
	      } else if (event.keyCode === 39) {
	        _this.onNext();
	      } else if (event.keyCode === 27) {
	        _this.close();
	      }
	    }, _this.close = function () {
	      _this.props.openGallery(false);
	    }, _this.innerClick = function (event) {
	      event.stopPropagation();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Gallery, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setItems(this.props.images, this.props.video);
	      window.addEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(props) {
	      if (!_lodash2.default.isEqual(this.props.images, props.images)) {
	        this.props.setItems(props.images, props.video);
	      }
	      if (this.props.isOpen === false && props.isOpen === true) {
	        this.props.addId('gallery');
	      } else if (this.props.isOpen === true && props.isOpen === false) {
	        this.props.removeId('gallery');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.removeId('gallery');
	      window.removeEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'onIndex',
	    value: function onIndex(index) {
	      this.props.goTo(index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeIndex = _props.activeIndex,
	          items = _props.items,
	          defaultAlt = _props.defaultAlt;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: this.props.isOpen ? 'gallery-open' : 'gallery', onClick: this.close },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'gallery-content', onClick: this.innerClick },
	          _react3.default.createElement('a', { styleName: 'btn-close', onClick: this.close }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'slide-show', style: items.length > activeIndex && !items[activeIndex].video ? items[activeIndex].style : null },
	            _react3.default.createElement('div', { styleName: 'mobile-left-arrow', onClick: this.onPrev }),
	            this.props.isOpen && items[activeIndex].video ? _react3.default.createElement(
	              'div',
	              { styleName: 'video-container' },
	              _react3.default.createElement('iframe', { width: '1031', height: '580', src: items[activeIndex].video, frameBorder: '0', allowFullScreen: true })
	            ) : _react3.default.createElement('img', { styleName: 'image', src: items.length > activeIndex && items[activeIndex].url, alt: defaultAlt, key: 'img-' + activeIndex }),
	            _react3.default.createElement('div', { styleName: 'mobile-right-arrow', onClick: this.onNext })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'caption-container' },
	            _react3.default.createElement(
	              'p',
	              { styleName: 'caption' },
	              '(',
	              activeIndex + 1,
	              '/',
	              items.length,
	              ')'
	            ),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'caption' },
	              items.length > activeIndex && ' ' + items[activeIndex].caption
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'images-container' },
	            this.getThumbnails().map(function (image, index) {
	              return _react3.default.createElement(
	                'div',
	                { key: 'trip-image-' + index, styleName: 'thumbnail-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'thumbnail', onClick: _this2.onIndex.bind(_this2, image.index), style: image.thumbnailStyle },
	                  image.index !== activeIndex && _react3.default.createElement('div', { styleName: 'shadow' }),
	                  image.video && _react3.default.createElement('div', { styleName: 'play' })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return Gallery;
	}(_react2.Component), _class2.propTypes = {
	  images: _react2.PropTypes.array,
	  video: _react2.PropTypes.string,
	  defaultAlt: _react2.PropTypes.string,
	  items: _react2.PropTypes.array,
	  isOpen: _react2.PropTypes.bool,
	  activeIndex: _react2.PropTypes.number,
	  openGallery: _react2.PropTypes.func,
	  setItems: _react2.PropTypes.func,
	  goTo: _react2.PropTypes.func,
	  prev: _react2.PropTypes.func,
	  next: _react2.PropTypes.func,
	  addId: _react2.PropTypes.func,
	  removeId: _react2.PropTypes.func
	}, _class2.defaultProps = {
	  images: [],
	  video: ''
	}, _temp2)) || _class) || _class));
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ShareSocials = __webpack_require__(1165);
	
	var _ShareSocials2 = _interopRequireDefault(_ShareSocials);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	var _reactSocial = __webpack_require__(280);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactCopyToClipboard = __webpack_require__(504);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ShareSocials: {
	    displayName: 'ShareSocials'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/ShareSocials/ShareSocials.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ShareSocials = _wrapComponent('ShareSocials')((_dec = (0, _reactRedux.connect)(null, { copyLink: _trip.copyLink }), _dec2 = (0, _reactCssModules2.default)(_ShareSocials2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ShareSocials, _Component);
	
	  function ShareSocials() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareSocials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareSocials.__proto__ || (0, _getPrototypeOf2.default)(ShareSocials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      mounted: false
	    }, _this.copyLink = function () {
	      _this.props.copyLink();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareSocials, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ mounted: true }); // eslint-disable-line
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var facebookImage = __webpack_require__(657);
	      var twitterImage = __webpack_require__(1461);
	      var pintarestImage = __webpack_require__(1460);
	      var googleImage = __webpack_require__(1459);
	      if (this.state.mounted) {
	        // bug "window" variable for server-side rendering
	        return _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement(
	            'div',
	            { styleName: 'social-flex' },
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(
	                _reactSocial.FacebookButton,
	                { appId: '512381822169849', styleName: 'social-link', url: window.location.toString() },
	                _react3.default.createElement('img', { src: facebookImage, alt: 'facebook' }),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  'Facebook'
	                )
	              ),
	              _react3.default.createElement(
	                _reactSocial.TwitterButton,
	                { styleName: 'social-link', url: window.location.toString() },
	                _react3.default.createElement('img', { src: twitterImage, alt: 'twitter' }),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  'Twitter'
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement(
	                _reactSocial.PinterestButton,
	                { styleName: 'social-link', url: window.location.toString() },
	                _react3.default.createElement('img', { src: pintarestImage, alt: 'pinterest' }),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  'Pinterest'
	                )
	              ),
	              _react3.default.createElement(
	                _reactSocial.GooglePlusButton,
	                { styleName: 'social-link', url: window.location.toString() },
	                _react3.default.createElement('img', { src: googleImage, alt: 'google' }),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  'Google plus'
	                )
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'button-group' },
	            _react3.default.createElement(
	              _reactCopyToClipboard2.default,
	              { text: 'https://www.takemetour.com/trip/' + this.props.slug },
	              _react3.default.createElement(
	                'a',
	                { styleName: 'button', onClick: this.copyLink },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.copy_link.button' })
	              )
	            ),
	            _react3.default.createElement(
	              'a',
	              { styleName: 'button', href: 'mailto:someone@example.com' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.send_email.button' })
	            )
	          )
	        );
	      }
	      return _react3.default.createElement('div', null);
	    }
	  }]);
	  return ShareSocials;
	}(_react2.Component), _class2.propTypes = {
	  slug: _react2.PropTypes.string,
	  copyLink: _react2.PropTypes.func
	}, _temp2)) || _class) || _class));
	
	exports.default = ShareSocials;
	module.exports = exports['default'];

/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Banner = __webpack_require__(1227);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _gallery = __webpack_require__(218);
	
	var _trip = __webpack_require__(47);
	
	var _WishlistButton = __webpack_require__(146);
	
	var _WishlistButton2 = _interopRequireDefault(_WishlistButton);
	
	var _media = __webpack_require__(21);
	
	var _helpers = __webpack_require__(19);
	
	var _price = __webpack_require__(60);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Banner: {
	    displayName: 'Banner'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Banner.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Banner = _wrapComponent('Banner')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sessionData: state.session.data,
	    rates: state.info.exchangeRates,
	    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
	    // omitBookingFee: state.info.userConfig.omitBookingFee,
	    siteConfigs: state.info.siteConfigs
	  };
	}, { openAndGoTo: _gallery.openAndGoTo, openShare: _trip.openShare }), _dec2 = (0, _reactCssModules2.default)(_Banner2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Banner, _Component);
	
	  function Banner(props) {
	    (0, _classCallCheck3.default)(this, Banner);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Banner.__proto__ || (0, _getPrototypeOf2.default)(Banner)).call(this, props));
	
	    _this.getQuantity = function () {
	      var _this$props = _this.props,
	          trip = _this$props.trip,
	          sessionData = _this$props.sessionData;
	
	      if (trip.is_per_day !== true) {
	        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
	      }
	      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
	    };
	
	    _this.renderSalePrice = _this.renderSalePrice.bind(_this);
	
	    if (!(typeof _this.renderSalePrice === 'function')) {
	      throw new TypeError('Value of "this.renderSalePrice" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderSalePrice));
	    }
	
	    _this.renderBasePrice = _this.renderBasePrice.bind(_this);
	
	    if (!(typeof _this.renderBasePrice === 'function')) {
	      throw new TypeError('Value of "this.renderBasePrice" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderBasePrice));
	    }
	
	    _this.openCoverImage = _this.openCoverImage.bind(_this);
	
	    if (!(typeof _this.openCoverImage === 'function')) {
	      throw new TypeError('Value of "this.openCoverImage" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openCoverImage));
	    }
	
	    _this.openShare = _this.openShare.bind(_this);
	
	    if (!(typeof _this.openShare === 'function')) {
	      throw new TypeError('Value of "this.openShare" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.openShare));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Banner, [{
	    key: 'openShare',
	    value: function openShare(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.props.openShare();
	    }
	  }, {
	    key: 'openCoverImage',
	    value: function openCoverImage() {
	      var trip = this.props.trip;
	
	      var coverIndex = 0;
	      if (_lodash2.default.findIndex(trip.images, { image: trip.cover_image }) >= 0 && !trip.video_url) {
	        coverIndex = _lodash2.default.findIndex(trip.images, { image: trip.cover_image });
	      }
	      this.props.openAndGoTo(coverIndex);
	    }
	  }, {
	    key: 'renderSalePrice',
	    value: function renderSalePrice() {
	      var currency = this.props.sessionData.currency;
	      var _props = this.props,
	          trip = _props.trip,
	          rates = _props.rates,
	          siteConfigs = _props.siteConfigs;
	
	      var quantity = this.getQuantity();
	      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
	      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
	      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
	      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates);
	      return _react3.default.createElement(
	        'span',
	        { styleName: 'mobile-sale-price' },
	        (0, _helpers.commaizeInt)((0, _price.ceil)(isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates), currency, rates, !isUsedForeignPrices)),
	        ' ',
	        siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency,
	        '/',
	        trip.is_per_day === true ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.day' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.person' })
	      );
	    }
	  }, {
	    key: 'renderBasePrice',
	    value: function renderBasePrice() {
	      var currency = this.props.sessionData.currency;
	      var _props2 = this.props,
	          trip = _props2.trip,
	          rates = _props2.rates,
	          siteConfigs = _props2.siteConfigs;
	
	      var quantity = this.getQuantity();
	      var isUsedForeignPrices = trip.foreign_full_prices !== undefined && trip.foreign_full_prices[currency] !== undefined;
	      var prices = isUsedForeignPrices ? trip.foreign_full_prices[currency] : trip.full_prices;
	      var displayPrice = (0, _helpers.getDisplayPrice)(quantity, prices, true);
	      displayPrice = isUsedForeignPrices ? displayPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displayPrice, rates);
	      var displaySeasonedPrice = (0, _helpers.getDisplaySeasonedPrice)(quantity, prices, true);
	      if (trip.discount_percentage > 0) {
	        return _react3.default.createElement(
	          'span',
	          { styleName: 'mobile-cross-price' },
	          (0, _helpers.commaizeInt)((0, _price.ceil)(isUsedForeignPrices ? displaySeasonedPrice : (0, _price.convertUnit)(trip.lx_currency, 'THB', displaySeasonedPrice, rates), currency, rates, !isUsedForeignPrices)),
	          ' ',
	          siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          trip = _props3.trip,
	          isWishlisted = _props3.isWishlisted;
	      // const {currency, quantity} = this.props.sessionData;
	
	      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'cover-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'cover-left' },
	          _react3.default.createElement('div', { styleName: 'cover-shadow-filter' }),
	          _react3.default.createElement('div', {
	            styleName: 'cover-blur',
	            style: { backgroundImage: 'url(' + (0, _media.path)(trip.cover_image, 'tripCover') + ')' }
	          })
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'cover-right' },
	          _react3.default.createElement('div', { styleName: 'cover-shadow-filter' }),
	          _react3.default.createElement('div', {
	            styleName: 'cover-blur',
	            style: { backgroundImage: 'url(' + (0, _media.path)(trip.cover_image, 'tripCover') + ')' }
	          })
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'cover-inner', onClick: this.openCoverImage },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'cover-aspect-ratio' },
	            _react3.default.createElement('img', {
	              src: (0, _media.path)(trip.cover_image, 'tripCover'),
	              alt: trip.name,
	              styleName: 'cover-picture-img'
	            }),
	            trip.video_url && _react3.default.createElement('div', { styleName: 'play-banner' }),
	            trip.product_type !== 'ticket' && _react3.default.createElement(
	              'div',
	              { styleName: 'cover-shadow' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'mobile-price-container' },
	                trip.discount_percentage > 0 && _react3.default.createElement(
	                  'div',
	                  { styleName: 'mobile-discount' },
	                  _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, {
	                      id: 'trip.item.discount',
	                      values: {
	                        percent: trip.discount_percentage * 100 + '%',
	                        lineBreak: _react3.default.createElement('br', null)
	                      }
	                    })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'mobile-price' },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'mobile-best-price' },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.best_price_guaranteed' })
	                  ),
	                  this.renderSalePrice(),
	                  this.renderBasePrice()
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'mobile-share' },
	                  _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement('a', { styleName: 'share-button', onClick: this.openShare })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'mobile-wishlist' },
	                  _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(_WishlistButton2.default, { label: true, active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Banner;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  // omitBookingFee: PropTypes.bool,
	  rates: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  openAndGoTo: _react2.PropTypes.func,
	  openShare: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = Banner;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Chat = __webpack_require__(1228);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _session = __webpack_require__(22);
	
	var _actions = __webpack_require__(78);
	
	var _payment = __webpack_require__(46);
	
	var _trip = __webpack_require__(47);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _SelectPeople = __webpack_require__(97);
	
	var _SelectPeople2 = _interopRequireDefault(_SelectPeople);
	
	var _Calendar = __webpack_require__(89);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _pluralize = __webpack_require__(158);
	
	var _pluralize2 = _interopRequireDefault(_pluralize);
	
	var _media = __webpack_require__(21);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Chat: {
	    displayName: 'Chat'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Chat.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	// import CustomSelect from '../General/FormElements/CustomSelect';
	
	// import LoginSignup from 'components/Nav/LoginSignup';
	
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var Chat = _wrapComponent('Chat')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    isLoggedIn: state.session.isLoggedIn,
	    // selectedDate: state.calendar.selected.day,
	    tripDate: state.payment.date,
	    paymentError: state.payment.error,
	    acceptSwap: state.payment.acceptSwap,
	    tripDateStatus: state.payment.dateStatus,
	    sessionData: state.session.data,
	    user: state.session.user,
	    sending: state.booking.sending,
	    creating: state.booking.creating,
	    requestId: state.payment.requestId,
	    messages: state.language.messages
	  };
	}, {
	  setSessionData: _session.setSessionData,
	  setLocalSessionData: _session.setLocalSessionData,
	  createBooking: _actions.createBooking,
	  sendMessage: _actions.sendMessage,
	  activateBooking: _actions.activateBooking,
	  push: _reactRouterRedux.push,
	  openLoginSignup: _session.openLoginSignup,
	  setLoginSignupCallback: _session.setLoginSignupCallback,
	  openChat: _trip.openChat,
	  clickSendMessage: _payment.clickSendMessage,
	  paymentOpenLoginSignup: _payment.paymentOpenLoginSignup,
	  setPaymentField: _payment.setField,
	  setPaymentError: _payment.setError,
	  logAcceptSwap: _payment.logAcceptSwap,
	  logSetDate: _payment.logSetDate
	}), _dec2 = (0, _reactCssModules2.default)(_Chat2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(Chat, _Component);
	
	  function Chat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chat.__proto__ || (0, _getPrototypeOf2.default)(Chat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      openDatePicker: false,
	      message: ''
	    }, _this.onChangeMessage = function (event) {
	      _this.setState({ message: event.target.value });
	    }, _this.onSendMessage = function () {
	      if (_this.validateForm()) {
	        _this.props.clickSendMessage(_this.props.requestId);
	        if (_this.props.isLoggedIn) {
	          _this.sendMessage();
	        } else {
	          // this.setState({openLoginSignup: true});
	          _this.props.openLoginSignup();
	          _this.props.paymentOpenLoginSignup(); // for logging
	          _this.props.setLoginSignupCallback(_this.sendMessage);
	        }
	      }
	    }, _this.getMaxTravelerOption = function () {
	      var max_travelers = _this.props.trip.max_travelers;
	
	      return _lodash2.default.fill(Array(max_travelers)).map(function (item, index) {
	        return index + 1;
	      });
	    }, _this.getQuantity = function () {
	      var _this$props = _this.props,
	          trip = _this$props.trip,
	          sessionData = _this$props.sessionData;
	
	      return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
	    }, _this.getPredefineText = function () {
	      var _this$props2 = _this.props,
	          trip = _this$props2.trip,
	          tripDate = _this$props2.tripDate;
	
	      var quantity = _this.getQuantity();
	      var text = 'Hi';
	      if (trip && trip.user_id && trip.user_id.name && trip.user_id.name.first) {
	        text += ' ' + trip.user_id.name.first;
	      }
	      if (tripDate) {
	        text += ', I\'m interested in your trip on ' + (0, _momentTimezone2.default)(tripDate).format('Do MMMM YYYY') + ' ';
	      } else {
	        text += ', I\'m interested in your trip on ... ';
	      }
	      if (quantity) {
	        text += 'with ' + (0, _pluralize2.default)('guest', quantity, true) + '.';
	      } else {
	        text += 'with ... guest(s).';
	      }
	      text += ' Please confirm if you are available so I can make the online payment on the website.';
	      return text;
	    }, _this.setDate = function (date, status) {
	      _this.props.setPaymentField('date', date);
	      _this.props.setPaymentField('dateStatus', status);
	      _this.props.setPaymentError((0, _extends3.default)({}, _this.props.paymentError, { date: false }));
	      _this.props.logSetDate(date, status);
	      _this.closeDatePicker();
	    }, _this.validateForm = function () {
	      var pass = true;
	      var error = {};
	      if (!_this.props.tripDate) {
	        error.date = true;
	        pass = false;
	      }
	      if (_this.props.tripDateStatus === 'n/a' && !_this.props.acceptSwap) {
	        error.acceptSwap = true;
	        pass = false;
	      }
	      _this.props.setPaymentError(error);
	      return pass;
	    }, _this.sendMessage = function () {
	      var bookingData = {
	        trip_id: _this.props.trip._id,
	        trip_date: _this.props.tripDate,
	        quantity: _this.getQuantity(),
	        source: 'message',
	        id: _this.props.requestId
	      };
	      _this.props.createBooking(bookingData).then(function (result) {
	        var id = result._id;
	        if (_this.refs.message.value) {
	          _this.props.sendMessage(id, _this.refs.message.value).then(function () {
	            _this.props.openChat(false);
	            _this.props.push('/dashboard/booking/' + id);
	          });
	        } else {
	          // this.props.activateBooking(id)
	          _this.props.sendMessage(id, _this.getPredefineText()).then(function () {
	            _this.props.openChat(false);
	            _this.props.push('/dashboard/booking/' + id);
	          });
	        }
	      });
	    }, _this.openDatePicker = function () {
	      _this.setState({ openDatePicker: true });
	    }, _this.closeDatePicker = function () {
	      _this.setState({ openDatePicker: false });
	    }, _this.toggleAcceptSwap = function () {
	      _this.props.setPaymentField('acceptSwap', !_this.props.acceptSwap);
	      _this.props.setPaymentError((0, _extends3.default)({}, _this.props.paymentError, { acceptSwap: false }));
	      _this.props.logAcceptSwap(!_this.props.acceptSwap);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chat, [{
	    key: 'onChange',
	    value: function onChange(name, value, a) {
	      this.props.setLocalSessionData({ 'quantity': a });
	      this.props.setSessionData({ 'quantity': a });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          openDatePicker = _state.openDatePicker,
	          message = _state.message;
	      var _props = this.props,
	          trip = _props.trip,
	          tripDate = _props.tripDate,
	          sending = _props.sending,
	          creating = _props.creating,
	          messages = _props.messages,
	          paymentError = _props.paymentError,
	          tripDateStatus = _props.tripDateStatus,
	          acceptSwap = _props.acceptSwap;
	
	      var lx = trip.user_id;
	      var quantity = this.getQuantity();
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'chat-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'mobile-label' },
	          _react3.default.createElement(
	            'p',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'chat-info' },
	          _react3.default.createElement('div', { styleName: 'lx-pic', style: (0, _media.path)(lx.avatar_image, 'profileAvatar', true) }),
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'lx-name' },
	            lx.name.first,
	            ' ',
	            lx.name.last
	          ),
	          _react3.default.createElement(
	            'p',
	            { styleName: 'city' },
	            trip.desination_location
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'topic' },
	            _react3.default.createElement('i', { styleName: 'bullet' }),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'topic-content' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q1' })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'topic' },
	            _react3.default.createElement('i', { styleName: 'bullet' }),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'topic-content' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q2' })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'topic' },
	            _react3.default.createElement('i', { styleName: 'bullet' }),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'topic-content' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.q3' })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'chat-content' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'mobile-scrollable' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'options' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'float-parent' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'option' },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'label' },
	                    _react3.default.createElement('i', { styleName: 'calendar-icon' }),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'label-text' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.date' }),
	                      ':'
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'input-container', onFocus: this.openDatePicker },
	                    _react3.default.createElement('input', { type: 'text', styleName: paymentError.date ? 'custom-input-error' : 'custom-input', readOnly: true, value: tripDate ? (0, _momentTimezone2.default)(tripDate).format('LL') : messages['trip.detail.desktop.chat.date.placeholder'] }),
	                    _react3.default.createElement(
	                      'div',
	                      { styleName: 'date-picker', style: openDatePicker ? null : { 'display': 'none' } },
	                      _react3.default.createElement(_Calendar2.default, { tripAvailability: true, trip: this.props.trip, onChange: this.setDate, initialDate: tripDate, offsetDay: 1, allowBookOnNA: this.props.trip.is_replaceable })
	                    )
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'option' },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'label' },
	                    _react3.default.createElement('i', { styleName: 'guest-icon' }),
	                    _react3.default.createElement(
	                      'p',
	                      { styleName: 'label-text' },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.chat.guest' })
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'input-container' },
	                    _react3.default.createElement(_SelectPeople2.default, { options: this.getMaxTravelerOption(), value: quantity > trip.max_travelers ? trip.max_travelers : quantity, onChange: this.onChange.bind(this), fieldName: 'quantity' })
	                  )
	                )
	              ),
	              paymentError.acceptSwap ? _react3.default.createElement(
	                'div',
	                { styleName: 'checkbox-container', style: tripDateStatus === 'n/a' ? null : { display: 'none' } },
	                _react3.default.createElement('div', { className: 'summary-check', styleName: acceptSwap ? 'checkbox-error-checked' : 'checkbox-error', onClick: this.toggleAcceptSwap }),
	                _react3.default.createElement(
	                  'span',
	                  { className: 'payment-agree', styleName: acceptSwap ? 'checkbox-label-error-checked' : 'checkbox-label-error', onClick: this.toggleAcceptSwap },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
	                )
	              ) : _react3.default.createElement(
	                'div',
	                { styleName: 'checkbox-container', style: tripDateStatus === 'n/a' ? null : { display: 'none' } },
	                _react3.default.createElement('div', { className: 'summary-check', styleName: acceptSwap ? 'checkbox-checked' : 'checkbox', onClick: this.toggleAcceptSwap }),
	                _react3.default.createElement(
	                  'span',
	                  { className: 'payment-agree', styleName: acceptSwap ? 'checkbox-label-checked' : 'checkbox-label', onClick: this.toggleAcceptSwap },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'chat-box-container' },
	              _react3.default.createElement('textarea', { styleName: 'custom-textarea', value: message, readOnly: sending || creating, onChange: this.onChangeMessage, ref: 'message', placeholder: this.getPredefineText() })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'btn-container' },
	            sending || creating ? _react3.default.createElement(
	              'a',
	              { styleName: 'btn-send-msg-loading' },
	              _react3.default.createElement(_LoadingButton2.default, null),
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.sending' })
	            ) : _react3.default.createElement(
	              'a',
	              { styleName: 'btn-send-msg', onClick: this.onSendMessage },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Chat;
	}(_react2.Component), _class2.propTypes = {
	  onClose: _react2.PropTypes.func,
	  trip: _react2.PropTypes.object,
	  isLoggedIn: _react2.PropTypes.bool,
	  setPaymentField: _react2.PropTypes.func,
	  setPaymentError: _react2.PropTypes.func,
	  acceptSwap: _react2.PropTypes.bool,
	  paymentError: _react2.PropTypes.object,
	  // selectedDate: PropTypes.object,
	  tripDate: _react2.PropTypes.any,
	  tripDateStatus: _react2.PropTypes.string,
	  sessionData: _react2.PropTypes.object,
	  setSessionData: _react2.PropTypes.func,
	  setLocalSessionData: _react2.PropTypes.func,
	  createBooking: _react2.PropTypes.func,
	  sendMessage: _react2.PropTypes.func,
	  activateBooking: _react2.PropTypes.func,
	  push: _react2.PropTypes.func,
	  user: _react2.PropTypes.object,
	  openLoginSignup: _react2.PropTypes.func,
	  setLoginSignupCallback: _react2.PropTypes.func,
	  clickSendMessage: _react2.PropTypes.func,
	  sending: _react2.PropTypes.bool,
	  creating: _react2.PropTypes.bool,
	  openChat: _react2.PropTypes.func,
	  requestId: _react2.PropTypes.string,
	  paymentOpenLoginSignup: _react2.PropTypes.func,
	  logAcceptSwap: _react2.PropTypes.func,
	  logSetDate: _react2.PropTypes.func,
	  messages: _react2.PropTypes.object
	}, _temp2)) || _class) || _class));
	
	exports.default = Chat;
	module.exports = exports['default'];

/***/ }),

/***/ 1630:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Detail = __webpack_require__(1229);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _reactIntl = __webpack_require__(10);
	
	var _trip = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Detail: {
	    displayName: 'Detail'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Detail.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Detail = _wrapComponent('Detail')((_dec = (0, _reactCssModules2.default)(_Detail2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Detail, _Component);
	
	  function Detail() {
	    (0, _classCallCheck3.default)(this, Detail);
	    return (0, _possibleConstructorReturn3.default)(this, (Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Detail, [{
	    key: 'render',
	    value: function render() {
	      var trip = this.props.trip;
	
	      var transportation = (0, _trip.getTransportation)(trip.transportation);
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'sub-header' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.label' })
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'activities' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-label' },
	            _react3.default.createElement('i', { styleName: 'transportation-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.transportation.label' }),
	              ' :'
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-detail' },
	            _react3.default.createElement(
	              'p',
	              null,
	              transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'activities' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-label' },
	            _react3.default.createElement('i', { styleName: 'max-travelers-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.max_tr.label' }),
	              ' :'
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-detail' },
	            _react3.default.createElement(
	              'p',
	              null,
	              trip.max_travelers
	            )
	          )
	        ),
	        trip.intermediate_locations && trip.intermediate_locations.length > 0 && _react3.default.createElement(
	          'div',
	          { styleName: 'activities' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-label' },
	            _react3.default.createElement('i', { styleName: 'stop-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.stopped_by.label' }),
	              ' :'
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-detail' },
	            _react3.default.createElement(
	              'p',
	              null,
	              trip.intermediate_locations.join(', ')
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'activities' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-label' },
	            _react3.default.createElement('i', { styleName: 'language-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.language.label' }),
	              ' :'
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-detail' },
	            _react3.default.createElement(
	              'p',
	              null,
	              trip.languages.join(', ')
	            )
	          )
	        ),
	        trip.conditions && trip.conditions.length > 0 && _react3.default.createElement(
	          'div',
	          { styleName: 'activities-condition' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'activities-label', style: { width: '100%' } },
	            _react3.default.createElement('i', { styleName: 'condition-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.condition.label' })
	            )
	          ),
	          trip.conditions.map(function (condition, i) {
	            return _react3.default.createElement(
	              'div',
	              { styleName: 'activities-condition-label', key: i },
	              _react3.default.createElement('i', { styleName: (0, _trip.getCondition)(condition).icon }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.' + condition + '.label' })
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return Detail;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Detail;
	module.exports = exports['default'];

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Faq = __webpack_require__(1230);
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Faq: {
	    displayName: 'Faq'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Faq.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Faq = _wrapComponent('Faq')((_dec = (0, _reactCssModules2.default)(_Faq2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Faq, _Component);
	
	  function Faq() {
	    (0, _classCallCheck3.default)(this, Faq);
	    return (0, _possibleConstructorReturn3.default)(this, (Faq.__proto__ || (0, _getPrototypeOf2.default)(Faq)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Faq, [{
	    key: 'render',
	    value: function render() {
	      var trip = this.props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'sub-header' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.faq.label' })
	        ),
	        _react3.default.createElement(
	          'div',
	          null,
	          trip.faqs.filter(function (f) {
	            return f.question && f.answer;
	          }).map(function (faq) {
	            return _react3.default.createElement(
	              'div',
	              { styleName: 'faq', key: faq._id },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'faq-label-container' },
	                _react3.default.createElement(
	                  'p',
	                  null,
	                  faq.question
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'faq-detail-container' },
	                _react3.default.createElement(
	                  'p',
	                  null,
	                  faq.answer
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return Faq;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Faq;
	module.exports = exports['default'];

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _toConsumableArray2 = __webpack_require__(26);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Images = __webpack_require__(1231);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _reactRedux = __webpack_require__(11);
	
	var _gallery = __webpack_require__(218);
	
	var _reactIntl = __webpack_require__(10);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Images: {
	    displayName: 'Images'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Images.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Images = _wrapComponent('Images')((_dec = (0, _reactRedux.connect)(function () {
	  return {};
	}, { openAndGoTo: _gallery.openAndGoTo }), _dec2 = (0, _reactCssModules2.default)(_Images2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Images, _Component);
	
	  function Images(props) {
	    (0, _classCallCheck3.default)(this, Images);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Images.__proto__ || (0, _getPrototypeOf2.default)(Images)).call(this, props));
	
	    _this.getImages = _this.getImages.bind(_this);
	
	    if (!(typeof _this.getImages === 'function')) {
	      throw new TypeError('Value of "this.getImages" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.getImages));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Images, [{
	    key: 'getImages',
	    value: function getImages() {
	      var trip = this.props.trip;
	
	      if (trip.video_url) {
	        // return [{video: {backgroundImage: `url(https://img.youtube.com/vi/${trip.video_url}/0.jpg)`}}, ...trip.images];
	        return [{ video: 'https://img.youtube.com/vi/' + trip.video_url + '/0.jpg' }].concat((0, _toConsumableArray3.default)(trip.images));
	      }
	      return trip.images;
	    }
	  }, {
	    key: 'openGallery',
	    value: function openGallery(index) {
	      this.props.openAndGoTo(index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var trip = this.props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'trip-images' },
	        this.getImages().map(function (image, index) {
	          return _react3.default.createElement(
	            'div',
	            { key: 'gallery-' + index, styleName: index <= 4 ? 'image-container' : 'image-container-preload' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'image', onClick: _this2.openGallery.bind(_this2, index) },
	              _react3.default.createElement('img', { src: image.video ? image.video : (0, _media.path)(image.image, 'thumbnail'), styleName: 'image-img', alt: image.caption || trip.name }),
	              index === 0 && trip.video_url && _react3.default.createElement('div', { styleName: 'play-gallery' }),
	              (index === 3 || index === 4) && _react3.default.createElement(
	                'div',
	                { styleName: index === 3 ? 'image-shadow-mobile' : 'image-shadow' },
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.images.see_all', values: { images: trip.images.length } })
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return Images;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  openAndGoTo: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = Images;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Introduction = __webpack_require__(1232);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactScroll = __webpack_require__(82);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	var _WishlistButton = __webpack_require__(146);
	
	var _WishlistButton2 = _interopRequireDefault(_WishlistButton);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _media = __webpack_require__(21);
	
	var _trip2 = __webpack_require__(38);
	
	var _helpers = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Introduction: {
	    displayName: 'Introduction'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Introduction.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ScrollLink = _reactScroll2.default.Link;
	
	var Introduction = _wrapComponent('Introduction')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
	    siteConfigs: state.info.siteConfigs,
	    locale: state.language.locale
	  };
	}, { openShare: _trip.openShare, changeTab: _trip.changeTab }), _dec2 = (0, _reactCssModules2.default)(_Introduction2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Introduction, _Component);
	
	  function Introduction(props) {
	    (0, _classCallCheck3.default)(this, Introduction);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Introduction.__proto__ || (0, _getPrototypeOf2.default)(Introduction)).call(this, props));
	
	    _this.openShare = _this.openShare.bind(_this);
	
	    if (!(typeof _this.openShare === 'function')) {
	      throw new TypeError('Value of "this.openShare" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openShare));
	    }
	
	    _this.changeToReview = _this.changeToReview.bind(_this);
	
	    if (!(typeof _this.changeToReview === 'function')) {
	      throw new TypeError('Value of "this.changeToReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.changeToReview));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Introduction, [{
	    key: 'openShare',
	    value: function openShare() {
	      this.props.openShare();
	    }
	  }, {
	    key: 'changeToReview',
	    value: function changeToReview() {
	      var bannerH = 240;
	      var priceH = 80;
	      this.props.changeTab('review');
	      window.scrollTo(0, bannerH - priceH);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          isWishlisted = _props.isWishlisted,
	          siteConfigs = _props.siteConfigs,
	          locale = _props.locale,
	          peerReview = _props.peerReview;
	
	      var reviews = trip.reviews || [];
	      var wo = trip.travelers_without_review || 0;
	      var count = reviews.length + wo;
	      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
	      var transportation = (0, _trip2.getTransportation)(trip.transportation);
	      var defaultImage = __webpack_require__(48);
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'share-wishlist-container' },
	          _react3.default.createElement(
	            'a',
	            { styleName: 'share-container', onClick: this.openShare },
	            _react3.default.createElement('div', { styleName: 'share-button' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.button' })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(_WishlistButton2.default, { label: true, active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	          )
	        ),
	        ((0, _helpers.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip || trip.tmt_tag) && !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'tags' },
	          (0, _helpers.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip && _react3.default.createElement(
	            'div',
	            { styleName: 'tag-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'instant-tag-band' },
	              _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.available_tomorrow' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
	              _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
	            )
	          ),
	          trip.tmt_tag && _react3.default.createElement(
	            'div',
	            { styleName: 'tag-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'tmt-tag-band' },
	              _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.exclusive' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-top' }),
	              _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-bottom' })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'h1',
	          { styleName: (trip.tmt_tag || (0, _helpers.isServiceTime)()) && !peerReview ? 'trip-title-with-tag' : 'trip-title' },
	          trip.name
	        ),
	        _react3.default.createElement(
	          'p',
	          { styleName: 'trip-location' },
	          trip.destination_location
	        ),
	        count > 0 && _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement(
	            ScrollLink,
	            { to: 'review', smooth: true, offset: -80, duration: 500 },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'point-container' },
	              trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating }),
	              _react3.default.createElement(
	                'span',
	                null,
	                '(',
	                count,
	                ')'
	              )
	            )
	          )
	        ),
	        !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'extra-infos' },
	          trip.tags && trip.tags.indexOf('tour_shared') < 0 && locale === 'en' && _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.private_n_personal' })
	          ),
	          locale === 'en' && _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.tip_included' })
	          ),
	          locale === 'th' && _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(
	              'span',
	              null,
	              '\u0E21\u0E35\u0E25\u0E48\u0E32\u0E21\u0E04\u0E19\u0E44\u0E17\u0E22\u0E41\u0E1B\u0E25\u0E20\u0E32\u0E29\u0E32'
	            )
	          ),
	          locale === 'th' && _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(
	              'span',
	              null,
	              '\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E0A\u0E35\u0E27\u0E34\u0E15'
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.satisfaction_guaranteed' })
	          ),
	          trip.search_information && trip.search_information.is_hotel_pickup && _react3.default.createElement(
	            'div',
	            { styleName: 'extra-info' },
	            _react3.default.createElement('i', null),
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.free_hotel_pickup' })
	          )
	        ),
	        _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: trip && trip.introduction } }),
	        !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'details-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'detail-item-row' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'detail-item' },
	              _react3.default.createElement('i', { styleName: trip.transportation === 'Public Transportation' ? 'public-transportation-icon' : 'private-car-icon' }),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'icon-caption' },
	                transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'detail-item' },
	              _react3.default.createElement('i', { styleName: 'duration-icon' }),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'icon-caption' },
	                (0, _trip2.getHour)(trip.duration),
	                ' ',
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.hour' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'detail-item' },
	              _react3.default.createElement('i', { styleName: 'popular-icon' }),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'icon-caption' },
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.commaizeInt)(trip.view_count)
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.popular' })
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'detail-item-row' },
	            trip.activities.map(function (act, index) {
	              return _react3.default.createElement(
	                'div',
	                { styleName: 'detail-item-activity', key: 'activity-' + index },
	                _react3.default.createElement('i', { styleName: (0, _trip2.getActivityIcon)(act) }),
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'icon-caption' },
	                  act
	                )
	              );
	            })
	          )
	        ),
	        !siteConfigs.tripHideLx && !(trip.tags && trip.tags.indexOf('tour_shared') >= 0) && !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'lx-profile' },
	          _react3.default.createElement(
	            _Link2.default,
	            { to: '/local-expert/' + trip.user_id.slug },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'lx-profile-pic' },
	              _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(
	              'p',
	              { styleName: 'lx-lx' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.lx.hosted_by' })
	            ),
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'lx-name' },
	              _react3.default.createElement(
	                _Link2.default,
	                { to: '/local-expert/' + trip.user_id.slug },
	                trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Introduction;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  locale: _react2.PropTypes.string,
	  peerReview: _react2.PropTypes.bool,
	  // isOneTab: PropTypes.bool,
	  openShare: _react2.PropTypes.func,
	  changeTab: _react2.PropTypes.func
	  // isMobile: PropTypes.bool,
	}, _temp)) || _class) || _class));
	
	exports.default = Introduction;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Itinerary = __webpack_require__(1233);
	
	var _Itinerary2 = _interopRequireDefault(_Itinerary);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Itinerary: {
	    displayName: 'Itinerary'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Itinerary.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Itinerary = _wrapComponent('Itinerary')((_dec = (0, _reactCssModules2.default)(_Itinerary2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Itinerary, _Component);
	
	  function Itinerary() {
	    (0, _classCallCheck3.default)(this, Itinerary);
	    return (0, _possibleConstructorReturn3.default)(this, (Itinerary.__proto__ || (0, _getPrototypeOf2.default)(Itinerary)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Itinerary, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          locale = _props.locale;
	
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'sub-header' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.itinerary.label' })
	        ),
	        trip.itinerary.map(function (it) {
	          return _react3.default.createElement(
	            'div',
	            { key: it._id, styleName: 'itinerary' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'time-container' },
	              _react3.default.createElement(
	                'p',
	                null,
	                it.time
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'activity-container' },
	              _react3.default.createElement(
	                'p',
	                null,
	                locale !== 'th' && it.text && it.text.split('\n').map(function (line, index) {
	                  if (index + 1 < it.text.split('\n').length) {
	                    return [_react3.default.createElement('span', { key: 'text-' + index, dangerouslySetInnerHTML: { __html: line } }), _react3.default.createElement('br', { key: 'break-' + index })];
	                  }
	                  return _react3.default.createElement('span', { key: 'text-' + index, dangerouslySetInnerHTML: { __html: line } });
	                }),
	                locale === 'th' && _react3.default.createElement('span', { dangerouslySetInnerHTML: { __html: it.text } })
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return Itinerary;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  locale: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = Itinerary;
	module.exports = exports['default'];

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Main = __webpack_require__(1234);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _reactScroll = __webpack_require__(82);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	var tripDetailAction = _interopRequireWildcard(_trip);
	
	var _payment = __webpack_require__(46);
	
	var _Reviews = __webpack_require__(473);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _CustomizeBox = __webpack_require__(258);
	
	var _CustomizeBox2 = _interopRequireDefault(_CustomizeBox);
	
	var _RequestBook = __webpack_require__(1643);
	
	var _RequestBook2 = _interopRequireDefault(_RequestBook);
	
	var _Modal = __webpack_require__(55);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Chat = __webpack_require__(1629);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Breadcrumbs = __webpack_require__(63);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _WeChat = __webpack_require__(673);
	
	var _WeChat2 = _interopRequireDefault(_WeChat);
	
	var _Banner = __webpack_require__(1628);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _PeerReviewHeader = __webpack_require__(1640);
	
	var _PeerReviewHeader2 = _interopRequireDefault(_PeerReviewHeader);
	
	var _Introduction = __webpack_require__(1633);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _Itinerary = __webpack_require__(1634);
	
	var _Itinerary2 = _interopRequireDefault(_Itinerary);
	
	var _Detail = __webpack_require__(1630);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _PriceCondition = __webpack_require__(1642);
	
	var _PriceCondition2 = _interopRequireDefault(_PriceCondition);
	
	var _Faq = __webpack_require__(1631);
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _MeetingPoint = __webpack_require__(1636);
	
	var _MeetingPoint2 = _interopRequireDefault(_MeetingPoint);
	
	var _Images = __webpack_require__(1632);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _SimilarTrips = __webpack_require__(1645);
	
	var _SimilarTrips2 = _interopRequireDefault(_SimilarTrips);
	
	var _PeerReviewForm = __webpack_require__(1639);
	
	var _PeerReviewForm2 = _interopRequireDefault(_PeerReviewForm);
	
	var _MobileAction = __webpack_require__(1637);
	
	var _MobileAction2 = _interopRequireDefault(_MobileAction);
	
	var _MobileTab = __webpack_require__(1638);
	
	var _MobileTab2 = _interopRequireDefault(_MobileTab);
	
	var _PriceBar = __webpack_require__(1641);
	
	var _PriceBar2 = _interopRequireDefault(_PriceBar);
	
	var _customize = __webpack_require__(64);
	
	var _momentTimezone = __webpack_require__(18);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Main: {
	    displayName: 'Main'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Main.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Element = _reactScroll2.default.Element;
	// import MobileContent from 'components/TripDetail/MobileContent';
	
	_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
	
	var Main = _wrapComponent('Main')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    trip: state.trip.data,
	    sessionData: state.session.data,
	    isOpenChat: state.trip.openChat,
	    user: state.session.user,
	    locale: state.language.locale,
	    tab: state.trip.mobileTab,
	    isOpenPeerReview: state.trip.isOpenPeerReview,
	    //
	    weChatEveryLink: state.info.siteConfigs.weChatEveryLink
	  };
	}, (0, _extends3.default)({}, tripDetailAction, { logCustomizeTrip: _customize.logCustomizeTrip, requestBooking: _payment.requestBooking })), _dec2 = (0, _reactCssModules2.default)(_Main2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Main, _Component);
	
	  function Main(props) {
	    (0, _classCallCheck3.default)(this, Main);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props));
	
	    _this.getQuantity = function () {
	      return _this.props.sessionData.quantity > _this.props.trip.max_travelers ? _this.props.trip.max_travelers : _this.props.sessionData.quantity;
	    };
	
	    _this.openChat = function () {
	      _this.props.openChat();
	      _this.props.requestBooking('message', 'desktop', _this.props.trip._id, null, _this.getQuantity());
	    };
	
	    _this.closeChat = function () {
	      _this.props.openChat(false);
	    };
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	
	    if (!(typeof _this.handleScroll === 'function')) {
	      throw new TypeError('Value of "this.handleScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleScroll));
	    }
	
	    _this.desktopScroll = _this.desktopScroll.bind(_this);
	
	    if (!(typeof _this.desktopScroll === 'function')) {
	      throw new TypeError('Value of "this.desktopScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.desktopScroll));
	    }
	
	    _this.mobileScroll = _this.mobileScroll.bind(_this);
	
	    if (!(typeof _this.mobileScroll === 'function')) {
	      throw new TypeError('Value of "this.mobileScroll" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.mobileScroll));
	    }
	
	    _this.onClosePeerReview = _this.onClosePeerReview.bind(_this);
	
	    if (!(typeof _this.onClosePeerReview === 'function')) {
	      throw new TypeError('Value of "this.onClosePeerReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onClosePeerReview));
	    }
	
	    _this.state = {
	      stickyStyle: { 'alignSelf': 'flex-start' },
	      mounted: false,
	      tabStyle: { alignSelf: 'flex-start' },
	      // mounted: false,
	      // lastScrollTop: 0,
	      showPrice: false
	    };
	    _this.lastScrollTop = 0;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Main, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScroll);
	      this.setState({ mounted: true }); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'onClosePeerReview',
	    value: function onClosePeerReview() {
	      this.props.openPeerReview(false);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      this.desktopScroll();
	      this.mobileScroll();
	    }
	  }, {
	    key: 'desktopScroll',
	    value: function desktopScroll() {
	      var offset = 66;
	      var top = this.refs.stickyContainer.getBoundingClientRect().top;
	      var elmHeight = this.refs.stickyElement.offsetHeight;
	      var contHeight = this.refs.stickyContainer.offsetHeight;
	      if (top >= offset) {
	        if (this.state.stickyState === 'top') return;
	        this.setState({
	          stickyState: 'top',
	          stickyStyle: { 'alignSelf': 'flex-start' }
	        });
	      } else if (Math.abs(top) + elmHeight + offset >= contHeight) {
	        // Care case container is too short
	        if (this.state.stickyState === 'bottom') return;
	        this.setState({
	          stickyState: 'bottom',
	          stickyStyle: { 'alignSelf': 'flex-end' }
	        });
	      } else if (this.state.stickyState !== 'fixed') {
	        if (this.state.stickyState === 'fixed') return;
	        this.setState({
	          stickyState: 'fixed',
	          stickyStyle: { 'position': 'fixed', 'width': '300px', 'top': offset + 'px' }
	        });
	      }
	    }
	  }, {
	    key: 'mobileScroll',
	    value: function mobileScroll() {
	      var offset = 55;
	      var bannerH = 240;
	      // const { lastScrollTop } = this.state;
	      var lastScrollTop = this.lastScrollTop;
	      var tabType = this.state.tabType;
	
	      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
	      if (st > lastScrollTop) {
	        // downscroll code
	        if (st > bannerH && tabType !== 'hiding') {
	          this.setState({
	            tabStyle: {
	              width: '100%',
	              background: 'white',
	              position: 'fixed',
	              top: '-30px',
	              transition: 'top 0.4s ease-out',
	              zIndex: '100'
	            },
	            showPrice: true,
	            tabType: 'hiding'
	          });
	        }
	      } else {
	        // upscroll code
	        if (st > bannerH && tabType !== 'showing') {
	          // eslint-disable-line
	          this.setState({
	            tabStyle: {
	              position: 'fixed',
	              top: offset + 'px',
	              transition: 'top 0.4s ease-in',
	              width: '100%',
	              background: 'white',
	              zIndex: '100'
	            },
	            showPrice: true,
	            tabType: 'showing'
	          });
	        } else if (st <= bannerH && tabType !== 'default') {
	          this.setState({
	            tabStyle: {
	              alignSelf: 'flex-start'
	            },
	            showPrice: false,
	            tabType: 'default'
	          });
	        }
	      }
	      // this.setState({ lastScrollTop: st });
	      this.lastScrollTop = st;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          trip = _props.trip,
	          isOpenChat = _props.isOpenChat,
	          locale = _props.locale,
	          peerReview = _props.peerReview,
	          isOpenPeerReview = _props.isOpenPeerReview,
	          user = _props.user,
	          weChatEveryLink = _props.weChatEveryLink;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'desktop-show' },
	        !peerReview && _react3.default.createElement(_Banner2.default, { trip: trip }),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'outer' },
	          !peerReview && _react3.default.createElement(_Breadcrumbs2.default, {
	            customStyle: { padding: '20px 2.5% 0' },
	            type: 'TripDetail',
	            trip: trip
	          }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'mobile-only' },
	            _react3.default.createElement(
	              'div',
	              { ref: 'mobileTab', style: this.state.tabStyle },
	              this.state.showPrice && !peerReview && _react3.default.createElement(_PriceBar2.default, { trip: trip }),
	              !peerReview && _react3.default.createElement(_MobileTab2.default, null)
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: peerReview ? 'inner-peer' : 'inner' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'big-column' },
	              peerReview && _react3.default.createElement(_PeerReviewHeader2.default, null),
	              _react3.default.createElement(Element, { name: 'overview' }),
	              _react3.default.createElement(_Introduction2.default, { trip: trip, peerReview: peerReview }),
	              !peerReview && _react3.default.createElement(_Faq2.default, { trip: trip }),
	              _react3.default.createElement(_Images2.default, { trip: trip }),
	              _react3.default.createElement(Element, { name: 'detail' }),
	              trip.is_per_day !== true && _react3.default.createElement(_Itinerary2.default, { trip: trip, locale: locale }),
	              !peerReview && _react3.default.createElement(_Detail2.default, { trip: trip }),
	              !peerReview && _react3.default.createElement(_PriceCondition2.default, { trip: trip }),
	              !peerReview && _react3.default.createElement(_MeetingPoint2.default, { trip: trip })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'inner-calendar', ref: 'stickyContainer', id: 'thisContainer' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'calendar-slider', ref: 'stickyElement', style: this.state.stickyStyle },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'slider-item-container' },
	                  function () {
	                    if (peerReview) {
	                      return _react3.default.createElement(_PeerReviewForm2.default, null);
	                    }
	                    if (weChatEveryLink) {
	                      return _react3.default.createElement(_WeChat2.default, { isShowPrice: true, trip: trip });
	                    }
	                    return _react3.default.createElement(_RequestBook2.default, { onOpenChat: _this2.openChat, trip: trip });
	                  }()
	                )
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(Element, { name: 'review' }),
	        _react3.default.createElement(
	          'div',
	          null,
	          !peerReview && !weChatEveryLink && _react3.default.createElement(
	            'div',
	            { ref: 'reviewsContainer', styleName: 'inner-reviews' },
	            _react3.default.createElement(_Reviews2.default, { reviews: trip.reviews, lxName: trip.user_id.name.first, woReview: trip.travelers_without_review })
	          ),
	          !trip.is_similar_hidden && trip.similarTrips && trip.similarTrips.length > 0 && !peerReview && !weChatEveryLink && _react3.default.createElement(
	            'div',
	            { styleName: 'inner-similar' },
	            _react3.default.createElement(_SimilarTrips2.default, { trip: trip })
	          )
	        ),
	        !peerReview && _react3.default.createElement(
	          'div',
	          { styleName: 'inner-customize' },
	          _react3.default.createElement(_CustomizeBox2.default, null)
	        ),
	        !(user && user._id === trip.user_id._id) && _react3.default.createElement(
	          'div',
	          { styleName: 'mobile-only' },
	          _react3.default.createElement(_MobileAction2.default, { trip: trip, peerReview: peerReview })
	        ),
	        peerReview && _react3.default.createElement(
	          _Modal2.default,
	          { isOpen: isOpenPeerReview, centerVertical: true, onClose: this.onClosePeerReview, id: 'peerReview' },
	          _react3.default.createElement(_PeerReviewForm2.default, null)
	        ),
	        _react3.default.createElement(
	          _Modal2.default,
	          { isOpen: isOpenChat, onClose: this.closeChat, centerVertical: true, style: { 'maxWidth': '600px', 'padding': '0', 'margin': '0 auto' }, noClose: true, id: 'trip-chat' },
	          _react3.default.createElement(_Chat2.default, { trip: trip })
	        )
	      );
	    }
	  }]);
	  return Main;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  isOpenChat: _react2.PropTypes.bool,
	  peerReview: _react2.PropTypes.bool,
	  openChat: _react2.PropTypes.func,
	  openPeerReview: _react2.PropTypes.func,
	  user: _react2.PropTypes.object,
	  logCustomizeTrip: _react2.PropTypes.func,
	  requestBooking: _react2.PropTypes.func,
	  locale: _react2.PropTypes.string,
	  tab: _react2.PropTypes.string,
	  isOpenPeerReview: _react2.PropTypes.bool,
	  //
	  weChatEveryLink: _react2.PropTypes.bool
	}, _temp)) || _class) || _class));
	
	exports.default = Main;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _MeetingPoint = __webpack_require__(1235);
	
	var _MeetingPoint2 = _interopRequireDefault(_MeetingPoint);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactGoogleMaps = __webpack_require__(1949);
	
	var _trip = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  MeetingPoint: {
	    displayName: 'MeetingPoint'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MeetingPoint.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var MeetingPoint = _wrapComponent('MeetingPoint')((_dec = (0, _reactCssModules2.default)(_MeetingPoint2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MeetingPoint, _Component);
	
	  function MeetingPoint(props) {
	    (0, _classCallCheck3.default)(this, MeetingPoint);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MeetingPoint.__proto__ || (0, _getPrototypeOf2.default)(MeetingPoint)).call(this, props));
	
	    _this.handleMapClick = _this.handleMapClick.bind(_this);
	
	    if (!(typeof _this.handleMapClick === 'function')) {
	      throw new TypeError('Value of "this.handleMapClick" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleMapClick));
	    }
	
	    _this.fitBounds = _this.fitBounds.bind(_this);
	
	    if (!(typeof _this.fitBounds === 'function')) {
	      throw new TypeError('Value of "this.fitBounds" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.fitBounds));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(MeetingPoint, [{
	    key: 'handleMapClick',
	    value: function handleMapClick() {}
	  }, {
	    key: 'fitBounds',
	    value: function fitBounds() {
	      if (!this._googleMapComponent) return;
	      var map = this._googleMapComponent;
	      var locations = this.props.trip.meeting_points.filter(function (point) {
	        return point.location && point.location.lat && point.location.lon;
	      }).map(function (point) {
	        return new window.google.maps.LatLng(point.location.lat, point.location.lon);
	      });
	      var bounds = new window.google.maps.LatLngBounds();
	      locations.map(function (location) {
	        return bounds.extend(location);
	      });
	      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
	        var extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
	        var extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
	        bounds.extend(extendPoint1);
	        bounds.extend(extendPoint2);
	      }
	      map.fitBounds(bounds);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var trip = this.props.trip;
	
	      var hasCustomLocations = trip.custom_locations && trip.custom_locations.length > 0;
	      var meetingPoints = (0, _trip.getMeetingPoints)(hasCustomLocations ? trip.custom_locations : trip.meeting_points);
	      var markers = hasCustomLocations ? trip.custom_locations.filter(function (loc) {
	        return loc.location && loc.location.lat && loc.location.lon;
	      }) : trip.meeting_points.filter(function (point) {
	        return point.location && point.location.lat && point.location.lon;
	      });
	      // if (markers.length <= 0) {
	      //   return false;
	      // }
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'meeting-point' },
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'header' },
	            hasCustomLocations ? _react3.default.createElement(
	              'span',
	              null,
	              'Location'
	            ) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.meeting_point.label' })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'meeting-points' },
	            meetingPoints.map(function (mp, index) {
	              return _react3.default.createElement(
	                'div',
	                { key: 'mp-' + index, styleName: 'meeting-point-container' },
	                !hasCustomLocations && _react3.default.createElement(
	                  'div',
	                  { styleName: 'meeting-point-label' },
	                  mp.icon_name && _react3.default.createElement('i', { styleName: mp.icon_name + '-icon' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    mp.type
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'meeting-point-detail' },
	                  mp.text.split(', ').map(function (location, i) {
	                    return _react3.default.createElement(
	                      'p',
	                      { key: 'mp-detail-' + i },
	                      '- ',
	                      location,
	                      _react3.default.createElement('br', null)
	                    );
	                  }),
	                  _react3.default.createElement('br', null)
	                )
	              );
	            })
	          )
	        ),
	        markers.length > 0 && _react3.default.createElement(
	          'div',
	          { styleName: 'map' },
	          _react3.default.createElement(_reactGoogleMaps.GoogleMapLoader, { key: 'AIzaSyDSRKzeQtBsSxJP-lsxOXxajCjaATYMbaw',
	            containerElement: _react3.default.createElement('div', {
	              // {...this.props}
	              style: {
	                height: '100%'
	              }
	            }),
	            googleMapElement: _react3.default.createElement(
	              _reactGoogleMaps.GoogleMap,
	              {
	                ref: function ref(map) {
	                  _this2._googleMapComponent = map;
	                  _this2.fitBounds();
	                },
	                defaultZoom: 3,
	                defaultCenter: { lat: -25.363882, lng: 131.044922 },
	                options: { scrollwheel: false },
	                onClick: this.handleMapClick
	              },
	              markers.map(function (marker, index) {
	                return _react3.default.createElement(_reactGoogleMaps.Marker, { key: 'marker-' + index, position: { lat: marker.location.lat, lng: marker.location.lon } });
	              })
	            )
	          })
	        )
	      );
	    }
	  }]);
	  return MeetingPoint;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = MeetingPoint;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _MobileAction = __webpack_require__(1236);
	
	var _MobileAction2 = _interopRequireDefault(_MobileAction);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _payment = __webpack_require__(46);
	
	var _popup = __webpack_require__(266);
	
	var _trip = __webpack_require__(47);
	
	var _customize = __webpack_require__(64);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _payment2 = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  MobileAction: {
	    displayName: 'MobileAction'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MobileAction.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import Scroll from 'react-scroll';
	// const ScrollLink = Scroll.Link;
	
	// import { commaizeInt, getDisplayPrice } from 'utils/helpers';
	// import { ceil } from 'utils/price';
	
	
	var MobileAction = _wrapComponent('MobileAction')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sessionData: state.session.data,
	    rates: state.info.exchangeRates,
	    omitBookingFee: state.info.userConfig.omitBookingFee,
	    isOpenPeerReview: state.trip.isOpenPeerReview,
	    requesting: state.payment.requesting,
	    siteConfigs: state.info.siteConfigs,
	    //
	    weChatEveryLink: state.info.siteConfigs.weChatEveryLink
	  };
	}, {
	  setPaymentData: _payment.setPaymentData,
	  logCustomizeTrip: _customize.logCustomizeTrip,
	  push: _reactRouterRedux.push,
	  openPeerReview: _trip.openPeerReview,
	  logRequest: _payment.logRequest,
	  openWeChatPopup: _popup.openWeChatPopup
	}), _dec2 = (0, _reactCssModules2.default)(_MobileAction2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MobileAction, _Component);
	
	  function MobileAction(props) {
	    (0, _classCallCheck3.default)(this, MobileAction);
	
	    // this.renderSalePrice = this.renderSalePrice.bind(this);
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileAction.__proto__ || (0, _getPrototypeOf2.default)(MobileAction)).call(this, props));
	
	    _this.requestForm = _this.requestForm.bind(_this);
	
	    if (!(typeof _this.requestForm === 'function')) {
	      throw new TypeError('Value of "this.requestForm" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.requestForm));
	    }
	
	    _this.openPeerReview = _this.openPeerReview.bind(_this);
	
	    if (!(typeof _this.openPeerReview === 'function')) {
	      throw new TypeError('Value of "this.openPeerReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openPeerReview));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(MobileAction, [{
	    key: 'getQuantity',
	    value: function getQuantity() {
	      return this.props.sessionData.quantity > this.props.trip.max_travelers ? this.props.trip.max_travelers : this.props.sessionData.quantity;
	    }
	  }, {
	    key: 'mobileRequest',
	    value: function mobileRequest() {
	      var requestType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'message';
	
	      var quantity = this.getQuantity();
	      var trip = this.props.trip;
	
	      var paymentData = {
	        trip: trip,
	        quantity: quantity,
	        requestType: requestType,
	        device: 'mobile'
	      };
	      this.props.setPaymentData(paymentData);
	      this.props.logRequest({
	        tripId: trip._id,
	        quantity: quantity,
	        requestType: requestType,
	        device: 'mobile'
	      });
	      this.props.push((0, _payment2.parseDataToQuery)(paymentData));
	    }
	  }, {
	    key: 'requestForm',
	    value: function requestForm() {
	      this.props.logCustomizeTrip('mobile', this.props.trip._id);
	      this.props.push('/customize/' + this.props.trip.slug);
	    }
	    // renderSalePrice() {
	    //   const {quantity, currency} = this.props.sessionData;
	    //   const {trip, omitBookingFee, rates, siteConfigs} = this.props;
	    //   if (siteConfigs.fixYuan) {
	    //     return (
	    //       <span styleName="mobile-request-price"><span styleName="mobile-request-price-yellow">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), 'CNY', rates))} 元</span>/
	    //         {
	    //           trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
	    //         }
	    //       </span>
	    //     );
	    //   }
	    //   return (
	    //     <span styleName="mobile-request-price"><span styleName="mobile-request-price-yellow">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), currency, rates))} {currency}</span>/
	    //       {
	    //         trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
	    //       }
	    //     </span>
	    //   );
	    // }
	
	  }, {
	    key: 'openPeerReview',
	    value: function openPeerReview() {
	      this.props.openPeerReview();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          trip = _props.trip,
	          requesting = _props.requesting,
	          peerReview = _props.peerReview,
	          isOpenPeerReview = _props.isOpenPeerReview,
	          siteConfigs = _props.siteConfigs;
	      var weChatEveryLink = this.props.weChatEveryLink;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: isOpenPeerReview ? 'mobile-request-toggle-hide' : 'mobile-request-toggle-show' },
	        function () {
	          if (peerReview) {
	            return _react3.default.createElement(
	              'a',
	              { styleName: 'btn-review', onClick: _this2.openPeerReview },
	              'Review This Trip'
	            );
	            // return (
	            //   <ScrollLink to="peerReview" smooth offset={-80} duration={500}>
	            //     <span styleName="btn-review">Review This Trip</span>
	            //   </ScrollLink>
	            // );
	          } else if (weChatEveryLink) {
	            return _react3.default.createElement(
	              'a',
	              { className: 'wechat-book', styleName: 'btn-request-first-mobile', onClick: function onClick() {
	                  return _this2.props.openWeChatPopup();
	                } },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
	            );
	          } else if (trip.is_request_form !== true) {
	            return _react3.default.createElement(
	              'div',
	              { styleName: 'mobile-request-action' },
	              siteConfigs.showLineAddAndFacebookMessage && [_react3.default.createElement(
	                'a',
	                { styleName: 'btn-chat-facebook', target: '_blank', href: 'https://m.me/pachantiew' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
	              ), _react3.default.createElement(
	                'a',
	                { styleName: 'btn-chat-line', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
	              )],
	              !siteConfigs.showLineAddAndFacebookMessage && (requesting ? _react3.default.createElement(
	                'a',
	                { styleName: 'btn-chat-mobile-loading' },
	                _react3.default.createElement(_LoadingButton2.default, null),
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	              ) : _react3.default.createElement(
	                'a',
	                { className: 'trip-message', styleName: 'btn-chat-mobile', onClick: _this2.mobileRequest.bind(_this2, 'message') },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	              )),
	              !siteConfigs.showLineAddAndFacebookMessage && (requesting ? _react3.default.createElement(
	                'a',
	                { styleName: 'btn-request-mobile-loading' },
	                _react3.default.createElement(_LoadingButton2.default, null),
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
	              ) : _react3.default.createElement(
	                'a',
	                { className: 'trip-book', styleName: 'btn-request-mobile', onClick: _this2.mobileRequest.bind(_this2, 'book') },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
	              ))
	            );
	          }
	          return _react3.default.createElement(
	            'a',
	            { className: 'trip-request-book', styleName: 'btn-request-first-mobile', onClick: _this2.requestForm },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.request_form' })
	          );
	        }()
	      );
	    }
	  }]);
	  return MobileAction;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  omitBookingFee: _react2.PropTypes.bool,
	  rates: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  requesting: _react2.PropTypes.bool,
	  peerReview: _react2.PropTypes.bool,
	  hideMobileAction: _react2.PropTypes.bool,
	  isOpenPeerReview: _react2.PropTypes.bool,
	  openPeerReview: _react2.PropTypes.func,
	  setPaymentData: _react2.PropTypes.func,
	  logCustomizeTrip: _react2.PropTypes.func,
	  push: _react2.PropTypes.func,
	  logRequest: _react2.PropTypes.func,
	  //
	  weChatEveryLink: _react2.PropTypes.bool,
	  openWeChatPopup: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = MobileAction;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _MobileTab = __webpack_require__(1237);
	
	var _MobileTab2 = _interopRequireDefault(_MobileTab);
	
	var _reactScroll = __webpack_require__(82);
	
	var _reactScroll2 = _interopRequireDefault(_reactScroll);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  MobileTab: {
	    displayName: 'MobileTab'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MobileTab.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var MobileTab = _wrapComponent('MobileTab')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    tab: state.trip.mobileTab,
	    trip: state.trip.data
	  };
	}, { changeTab: _trip.changeTab }), _dec2 = (0, _reactCssModules2.default)(_MobileTab2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(MobileTab, _Component);
	
	  function MobileTab() {
	    (0, _classCallCheck3.default)(this, MobileTab);
	    return (0, _possibleConstructorReturn3.default)(this, (MobileTab.__proto__ || (0, _getPrototypeOf2.default)(MobileTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MobileTab, [{
	    key: 'onSelectTab',
	    value: function onSelectTab(tab) {
	      // const bannerH = 240;
	      // const priceH = 80;
	      this.props.changeTab(tab);
	      // window.scrollTo(0, bannerH - priceH);
	      _reactScroll2.default.scroller.scrollTo(tab, {
	        offset: -100,
	        duration: 500,
	        smooth: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tab = _props.tab,
	          trip = _props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'container' },
	        _react3.default.createElement(
	          'ul',
	          { styleName: 'tabs' },
	          _react3.default.createElement(
	            'li',
	            { styleName: tab === 'overview' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'overview') },
	            _react3.default.createElement(
	              'a',
	              null,
	              'Overview'
	            )
	          ),
	          _react3.default.createElement(
	            'li',
	            { styleName: tab === 'detail' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'detail') },
	            _react3.default.createElement(
	              'a',
	              null,
	              'Detail'
	            )
	          ),
	          _react3.default.createElement(
	            'li',
	            { styleName: tab === 'review' ? 'active' : 'non-active', onClick: this.onSelectTab.bind(this, 'review') },
	            _react3.default.createElement(
	              'a',
	              null,
	              'Review',
	              trip.reviews && trip.reviews.length > 0 && ' (' + trip.reviews.length + ')'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return MobileTab;
	}(_react2.Component), _class2.propTypes = {
	  tab: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  changeTab: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = MobileTab;
	module.exports = exports['default'];

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PeerReviewForm = __webpack_require__(1238);
	
	var _PeerReviewForm2 = _interopRequireDefault(_PeerReviewForm);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _Loader = __webpack_require__(111);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PeerReviewForm: {
	    displayName: 'PeerReviewForm'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/PeerReviewForm.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import { FormattedMessage } from 'react-intl';
	
	// import { commaizeInt, getDisplayPrice } from 'utils/helpers';
	// import { ceil } from 'utils/price';
	
	var PeerReviewForm = _wrapComponent('PeerReviewForm')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    trip: state.trip.data,
	    data: state.trip.peerReviewData,
	    peerTrips: state.trip.peerTrips,
	    isLoading: state.trip.isLoadingPeerReview,
	    isSubmitting: state.trip.isSubmittingPeerReview
	  };
	}, { submitPeerReview: _trip.submitPeerReview, openPeerReview: _trip.openPeerReview, updatePeerTrips: _trip.updatePeerTrips, push: _reactRouterRedux.push }), _dec2 = (0, _reactCssModules2.default)(_PeerReviewForm2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PeerReviewForm, _Component);
	
	  // constructor(props) {
	  //   super(props);
	  //   this.renderSalePrice = this.renderSalePrice.bind(this);
	  // }
	  // getQuantity = () => {
	  //   const {trip, sessionData} = this.props;
	  //   if (trip.is_per_day !== true) {
	  //     return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
	  //   }
	  //   return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
	  // }
	  // renderSalePrice() {
	  //   const {currency} = this.props.sessionData;
	  //   const {trip, omitBookingFee, rates, siteConfigs} = this.props;
	  //   const quantity = this.getQuantity();
	  //   if (siteConfigs.fixYuan) {
	  //     return (
	  //       <span styleName="mobile-sale-price">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), 'CNY', rates))} 元/
	  //         {
	  //           trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
	  //         }
	  //       </span>
	  //     );
	  //   }
	  //   return (
	  //     <span styleName="mobile-sale-price">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), currency, rates))} {currency}/
	  //       {
	  //         trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
	  //       }
	  //     </span>
	  //   );
	  // }
	  function PeerReviewForm(props) {
	    (0, _classCallCheck3.default)(this, PeerReviewForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PeerReviewForm.__proto__ || (0, _getPrototypeOf2.default)(PeerReviewForm)).call(this, props));
	
	    _this.onSubmit = _this.onSubmit.bind(_this);
	
	    if (!(typeof _this.onSubmit === 'function')) {
	      throw new TypeError('Value of "this.onSubmit" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onSubmit));
	    }
	
	    _this.state = {
	      score: 0,
	      checked: false
	      // loading: true,
	      // done: true,
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(PeerReviewForm, [{
	    key: 'onSubmit',
	    value: function onSubmit() {
	      var _this2 = this;
	
	      this.props.submitPeerReview(this.props.trip.slug, this.state.score, this.state.checked).then(function () {
	        var peerTrips = _this2.props.peerTrips;
	
	        _this2.setState({ score: 0 });
	        _this2.props.openPeerReview(false);
	        if (!peerTrips || peerTrips.length === 0) {
	          _this2.props.push('/dashboard/peer-review?done=true');
	        } else {
	          _this2.props.push('/trip/' + peerTrips[0].slug + '?peerReview=true');
	          _this2.props.updatePeerTrips(peerTrips.slice(1));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.isLoading) {
	        return _react3.default.createElement(
	          'div',
	          { styleName: 'loader-container' },
	          _react3.default.createElement(_Loader2.default, null)
	        );
	      }
	      if (this.props.data && this.props.data._id) {
	        return _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'h2',
	            { styleName: 'header' },
	            'Thankyou for your rating'
	          ),
	          _react3.default.createElement(
	            'p',
	            { styleName: 'description' },
	            'You already gave rating to this trip.'
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'rating' },
	            [1, 2, 3, 4, 5].map(function (score) {
	              return _react3.default.createElement('div', { key: 'score-' + score, styleName: _this3.props.data.score >= score ? 'star' : 'star-o' });
	            })
	          ),
	          _react3.default.createElement(
	            'p',
	            { styleName: 'score-text' },
	            function () {
	              switch (_this3.props.data.score) {
	                case 1:
	                  return _react3.default.createElement(
	                    'span',
	                    null,
	                    'Poor'
	                  );
	                case 2:
	                  return _react3.default.createElement(
	                    'span',
	                    null,
	                    'Below average'
	                  );
	                case 3:
	                  return _react3.default.createElement(
	                    'span',
	                    null,
	                    'Normal'
	                  );
	                case 4:
	                  return _react3.default.createElement(
	                    'span',
	                    null,
	                    'Good'
	                  );
	                case 5:
	                  return _react3.default.createElement(
	                    'span',
	                    null,
	                    'Excellent'
	                  );
	                default:
	                  return _react3.default.createElement('span', null);
	              }
	            }()
	          ),
	          this.props.data.can_do_this_trip && _react3.default.createElement(
	            'p',
	            null,
	            'You can do this trip'
	          )
	        );
	      }
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'header' },
	          'How local is this trip?'
	        ),
	        _react3.default.createElement(
	          'p',
	          { styleName: 'description' },
	          'Please give a score on how local this trip is (scale 1-5).'
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'rating' },
	          [1, 2, 3, 4, 5].map(function (score) {
	            return _react3.default.createElement('div', { key: 'score-' + score, styleName: _this3.state.score >= score ? 'star' : 'star-o', onClick: _this3.props.isSubmitting ? function () {} : function () {
	                return _this3.setState({ score: score });
	              } });
	          })
	        ),
	        _react3.default.createElement(
	          'p',
	          { styleName: 'score-text' },
	          function () {
	            switch (_this3.state.score) {
	              case 1:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Poor'
	                );
	              case 2:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Below average'
	                );
	              case 3:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Normal'
	                );
	              case 4:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Good'
	                );
	              case 5:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Excellent'
	                );
	              default:
	                return _react3.default.createElement(
	                  'span',
	                  null,
	                  'Undecided'
	                );
	            }
	          }()
	        ),
	        _react3.default.createElement(
	          'label',
	          { styleName: 'custom-checkbox' },
	          _react3.default.createElement('input', { type: 'checkbox', checked: this.state.checked, onChange: this.props.isSubmitting ? function () {} : function () {
	              return _this3.setState({ checked: !_this3.state.checked });
	            } }),
	          _react3.default.createElement(
	            'span',
	            null,
	            'I can do this trip'
	          )
	        ),
	        function () {
	          if (_this3.state.score <= 0) {
	            return _react3.default.createElement(
	              'a',
	              { styleName: 'btn-disable' },
	              'Submit'
	            );
	          } else if (_this3.props.isSubmitting) {
	            return _react3.default.createElement(
	              'a',
	              { styleName: 'btn-loading' },
	              _react3.default.createElement(_LoadingButton2.default, null),
	              'Submitting'
	            );
	          }
	          return _react3.default.createElement(
	            'a',
	            { styleName: 'btn-submit', onClick: _this3.onSubmit },
	            _react3.default.createElement(_LoadingButton2.default, null),
	            'Submit'
	          );
	        }()
	      );
	    }
	  }]);
	  return PeerReviewForm;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  data: _react2.PropTypes.object,
	  isLoading: _react2.PropTypes.bool,
	  isSubmitting: _react2.PropTypes.bool,
	  peerTrips: _react2.PropTypes.array,
	  push: _react2.PropTypes.func,
	  openPeerReview: _react2.PropTypes.func,
	  updatePeerTrips: _react2.PropTypes.func,
	  submitPeerReview: _react2.PropTypes.func }, _temp)) || _class) || _class));
	
	exports.default = PeerReviewForm;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PeerReviewHeader = __webpack_require__(1239);
	
	var _PeerReviewHeader2 = _interopRequireDefault(_PeerReviewHeader);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PeerReviewHeader: {
	    displayName: 'PeerReviewHeader'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/PeerReviewHeader.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import Scroll from 'react-scroll';
	// const ScrollLink = Scroll.Link;
	
	var PeerReviewHeader = _wrapComponent('PeerReviewHeader')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    peerTrips: state.trip.peerTrips
	  };
	}, { openPeerReview: _trip.openPeerReview }), _dec2 = (0, _reactCssModules2.default)(_PeerReviewHeader2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PeerReviewHeader, _Component);
	
	  function PeerReviewHeader(props) {
	    (0, _classCallCheck3.default)(this, PeerReviewHeader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PeerReviewHeader.__proto__ || (0, _getPrototypeOf2.default)(PeerReviewHeader)).call(this, props));
	
	    _this.openPeerReview = _this.openPeerReview.bind(_this);
	
	    if (!(typeof _this.openPeerReview === 'function')) {
	      throw new TypeError('Value of "this.openPeerReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openPeerReview));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(PeerReviewHeader, [{
	    key: 'openPeerReview',
	    value: function openPeerReview() {
	      this.props.openPeerReview();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const { trip, requesting, peerReview, isOpenPeerReview } = this.props;
	      var peerTrips = this.props.peerTrips;
	
	      var current = peerTrips && peerTrips.length && 3 - peerTrips.length || 3;
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'counter' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'current' },
	              current
	            ),
	            _react3.default.createElement(
	              'span',
	              null,
	              '/3'
	            )
	          ),
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'header' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'peer_review.description' })
	          ),
	          _react3.default.createElement(
	            'h3',
	            { styleName: 'link' },
	            _react3.default.createElement(
	              'a',
	              { onClick: this.openPeerReview },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'peer_review.click_here' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PeerReviewHeader;
	}(_react2.Component), _class2.propTypes = {
	  openPeerReview: _react2.PropTypes.func,
	  peerTrips: _react2.PropTypes.array
	}, _temp)) || _class) || _class));
	
	exports.default = PeerReviewHeader;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PriceBar = __webpack_require__(631);
	
	var _PriceBar2 = _interopRequireDefault(_PriceBar);
	
	var _Price = __webpack_require__(675);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PriceBar: {
	    displayName: 'PriceBar'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/PriceBar.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var PriceBar = _wrapComponent('PriceBar')((_dec = (0, _reactCssModules2.default)(_PriceBar2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PriceBar, _Component);
	
	  function PriceBar() {
	    (0, _classCallCheck3.default)(this, PriceBar);
	    return (0, _possibleConstructorReturn3.default)(this, (PriceBar.__proto__ || (0, _getPrototypeOf2.default)(PriceBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PriceBar, [{
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'cover-shadow' },
	        _react3.default.createElement(_Price2.default, { trip: this.props.trip })
	      );
	    }
	  }]);
	  return PriceBar;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = PriceBar;
	module.exports = exports['default'];

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PriceCondition = __webpack_require__(1240);
	
	var _PriceCondition2 = _interopRequireDefault(_PriceCondition);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PriceCondition: {
	    displayName: 'PriceCondition'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/PriceCondition.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var PriceCondition = _wrapComponent('PriceCondition')((_dec = (0, _reactCssModules2.default)(_PriceCondition2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PriceCondition, _Component);
	
	  function PriceCondition() {
	    (0, _classCallCheck3.default)(this, PriceCondition);
	    return (0, _possibleConstructorReturn3.default)(this, (PriceCondition.__proto__ || (0, _getPrototypeOf2.default)(PriceCondition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PriceCondition, [{
	    key: 'render',
	    value: function render() {
	      var trip = this.props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'sub-header' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.price_condition.label' })
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'price-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'price-cond-label' },
	            ['food', 'transport', 'ticket'].map(function (cond) {
	              return _react3.default.createElement('i', { key: cond, styleName: trip.price_condition.enabled_icons.indexOf(cond) >= 0 ? 'inc-' + cond : 'exc-' + cond });
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'price-cond-detail' },
	            _react3.default.createElement(
	              'h3',
	              null,
	              trip.price_condition.text
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'price-cond-details' },
	          trip.price_condition.detail_traveler && trip.price_condition.detail_traveler.map(function (det, index) {
	            return _react3.default.createElement(
	              'div',
	              { styleName: det.enabled ? 'price-cond-check' : 'price-cond-uncheck', key: 'det-' + index },
	              _react3.default.createElement('i', null),
	              _react3.default.createElement(
	                'span',
	                null,
	                det.text
	              )
	            );
	          })
	        ),
	        trip.extra_expense && _react3.default.createElement(
	          'div',
	          { styleName: 'price-extra' },
	          _react3.default.createElement(
	            'h3',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.price_condition.extra_prepare' })
	          ),
	          _react3.default.createElement(
	            'div',
	            null,
	            trip.extra_expense.split('\n').map(function (extra, i) {
	              return _react3.default.createElement(
	                'p',
	                { key: i },
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  extra
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return PriceCondition;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = PriceCondition;
	module.exports = exports['default'];

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _RequestBook = __webpack_require__(1241);
	
	var _RequestBook2 = _interopRequireDefault(_RequestBook);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(11);
	
	var _trip = __webpack_require__(47);
	
	var tripAction = _interopRequireWildcard(_trip);
	
	var _session = __webpack_require__(22);
	
	var _payment = __webpack_require__(46);
	
	var _calendar = __webpack_require__(169);
	
	var _customize = __webpack_require__(64);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _reactTooltip = __webpack_require__(229);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _SelectPeople = __webpack_require__(97);
	
	var _SelectPeople2 = _interopRequireDefault(_SelectPeople);
	
	var _LoadingButton = __webpack_require__(29);
	
	var _LoadingButton2 = _interopRequireDefault(_LoadingButton);
	
	var _Calendar = __webpack_require__(89);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _helpers = __webpack_require__(19);
	
	var _price = __webpack_require__(60);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _payment2 = __webpack_require__(73);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  RequestBook: {
	    displayName: 'RequestBook'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/RequestBook.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import Scroll from 'react-scroll';
	// const ScrollLink = Scroll.Link;
	
	// import moment from 'moment';
	// moment.tz.setDefault('Asia/Bangkok');
	
	
	var RequestBook = _wrapComponent('RequestBook')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sessionData: state.session.data,
	    // selectedDate: state.calendar.selected.day,
	    isLoggedIn: state.session.isLoggedIn,
	    creating: state.booking.creating,
	    user: state.session.user,
	    rates: state.info.exchangeRates,
	    isInstant: state.calendar.selected.instant,
	    paymentDate: state.payment.date,
	    paymentDateStatus: state.payment.dateStatus,
	    acceptSwap: state.payment.acceptSwap,
	    requesting: state.payment.requesting,
	    omitBookingFee: state.info.userConfig.omitBookingFee,
	    siteConfigs: state.info.siteConfigs
	  };
	}, (0, _extends3.default)({}, tripAction, {
	  setSessionData: _session.setSessionData,
	  setLocalSessionData: _session.setLocalSessionData,
	  push: _reactRouterRedux.push,
	  setError: _calendar.setError,
	  setPaymentField: _payment.setField,
	  setPaymentData: _payment.setPaymentData,
	  logCustomizeTrip: _customize.logCustomizeTrip,
	  logSetDate: _payment.logSetDate,
	  logAcceptSwap: _payment.logAcceptSwap,
	  logRequest: _payment.logRequest
	})), _dec2 = (0, _reactCssModules2.default)(_RequestBook2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(RequestBook, _Component);
	
	  function RequestBook(props) {
	    (0, _classCallCheck3.default)(this, RequestBook);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RequestBook.__proto__ || (0, _getPrototypeOf2.default)(RequestBook)).call(this, props));
	
	    _this.state = {
	      showGuarantee: false
	    };
	
	    _this.onClose = function () {
	      _this.props.onClose();
	    };
	
	    _this.getMaxTravelerOption = function () {
	      var max_travelers = _this.props.trip.max_travelers;
	
	      return _lodash2.default.fill(Array(max_travelers)).map(function (item, index) {
	        return index + 1;
	      });
	    };
	
	    _this.getQuantity = function () {
	      var _this$props = _this.props,
	          trip = _this$props.trip,
	          sessionData = _this$props.sessionData;
	
	      if (trip.is_per_day !== true) {
	        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
	      }
	      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
	    };
	
	    _this.setDate = function (date, status) {
	      // this.props.setSessionData({'date': date});
	      _this.props.setPaymentField('date', date);
	      _this.props.setPaymentField('dateStatus', status);
	      _this.props.setPaymentField('isInstant', status === 'available');
	      _this.props.logSetDate(date, status);
	    };
	
	    _this.openChat = function () {
	      _this.props.onOpenChat();
	      var _this$props2 = _this.props,
	          trip = _this$props2.trip,
	          paymentDate = _this$props2.paymentDate;
	
	      var data = {
	        tripId: trip._id,
	        quantity: _this.getQuantity(),
	        date: paymentDate,
	        requestType: 'message',
	        device: 'desktop'
	      };
	      _this.props.logRequest(data);
	    };
	
	    _this.toggleGuarantee = function () {
	      _this.setState({ showGuarantee: !_this.state.showGuarantee });
	    };
	
	    _this.requestForm = function () {
	      _this.props.logCustomizeTrip('desktop', _this.props.trip._id);
	      _this.props.push('/customize/' + _this.props.trip.slug);
	    };
	
	    _this.requestBook = function () {
	      var _this$props3 = _this.props,
	          trip = _this$props3.trip,
	          paymentDate = _this$props3.paymentDate;
	
	      var quantity = _this.getQuantity();
	      var paymentData = {
	        trip: trip,
	        quantity: quantity,
	        date: paymentDate,
	        requestType: 'book',
	        device: 'desktop'
	      };
	      var data = {
	        tripId: trip._id,
	        quantity: quantity,
	        date: paymentDate,
	        requestType: 'book',
	        device: 'desktop'
	      };
	      _this.props.logRequest(data);
	      _this.props.setPaymentData(paymentData);
	      _this.props.push((0, _payment2.parseDataToQuery)(paymentData));
	    };
	
	    _this.toggleAcceptSwap = _this.toggleAcceptSwap.bind(_this);
	
	    if (!(typeof _this.toggleAcceptSwap === 'function')) {
	      throw new TypeError('Value of "this.toggleAcceptSwap" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.toggleAcceptSwap));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(RequestBook, [{
	    key: 'onChange',
	    value: function onChange(name, value, a) {
	      this.props.setLocalSessionData({ 'quantity': a });
	      this.props.setSessionData({ 'quantity': a });
	    }
	  }, {
	    key: 'toggleAcceptSwap',
	    value: function toggleAcceptSwap() {
	      this.props.setPaymentField('acceptSwap', !this.props.acceptSwap);
	      this.props.logAcceptSwap(!this.props.acceptSwap);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // const { trip, sessionData, rates, user, isInstant, paymentDate, paymentDateStatus, omitBookingFee, siteConfigs, acceptSwap, requesting, p2pReview } = this.props;
	      var _props = this.props,
	          trip = _props.trip,
	          sessionData = _props.sessionData,
	          rates = _props.rates,
	          user = _props.user,
	          isInstant = _props.isInstant,
	          paymentDate = _props.paymentDate,
	          paymentDateStatus = _props.paymentDateStatus,
	          omitBookingFee = _props.omitBookingFee,
	          siteConfigs = _props.siteConfigs,
	          acceptSwap = _props.acceptSwap,
	          requesting = _props.requesting;
	      var currency = sessionData.currency;
	
	      var quantity = this.getQuantity();
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'div',
	          { styleName: 'calendar-action-container' },
	          trip.is_request_form !== true && [_react3.default.createElement(_Calendar2.default, { tripAvailability: true, trip: trip, initialDate: paymentDate, onChange: this.setDate, offsetDay: 1, allowBookOnNA: trip.is_replaceable, key: 'req-0' }), _react3.default.createElement(
	            'div',
	            { styleName: 'checkbox-container', style: paymentDateStatus === 'n/a' ? null : { display: 'none' }, key: 'req-1' },
	            _react3.default.createElement('div', { styleName: acceptSwap ? 'checkbox-checked' : 'checkbox', onClick: this.toggleAcceptSwap }),
	            _react3.default.createElement(
	              'span',
	              { styleName: acceptSwap ? 'checkbox-label-checked' : 'checkbox-label', onClick: this.toggleAcceptSwap },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
	            )
	          )],
	          trip.is_per_day !== true && _react3.default.createElement(
	            'div',
	            { styleName: 'max-travelers-container' },
	            _react3.default.createElement('i', { styleName: 'max-travelers-icon' }),
	            _react3.default.createElement(
	              'span',
	              null,
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.guest' })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'input-container' },
	              _react3.default.createElement(_SelectPeople2.default, { options: this.getMaxTravelerOption(), value: quantity > trip.max_travelers ? trip.max_travelers : quantity, onChange: this.onChange.bind(this), fieldName: 'quantity' })
	            )
	          ),
	          trip.is_per_day !== true && _react3.default.createElement(
	            'div',
	            { styleName: 'price-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-label' },
	              _react3.default.createElement('i', { styleName: 'price-per-person-icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.price' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-detail' },
	              _react3.default.createElement(
	                'span',
	                { styleName: 'price' },
	                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates)),
	                ' ',
	                siteConfigs.fixYuan ? '元' : currency
	              )
	            )
	          ),
	          trip.is_per_day !== true && _react3.default.createElement(
	            'div',
	            { styleName: 'price-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-label' },
	              _react3.default.createElement('i', { styleName: 'price-icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.total_price' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-detail' },
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'span',
	                { styleName: 'percent-off' },
	                trip.discount_percentage * 100,
	                '%OFF'
	              ),
	              _react3.default.createElement(
	                'span',
	                { styleName: 'price' },
	                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates) * quantity),
	                ' ',
	                siteConfigs.fixYuan ? '元' : currency
	              ),
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'span',
	                { styleName: 'cross-price' },
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplaySeasonedPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates) * quantity),
	                  ' ',
	                  siteConfigs.fixYuan ? '元' : currency
	                )
	              )
	            )
	          ),
	          trip.is_per_day === true && _react3.default.createElement(
	            'div',
	            { styleName: 'price-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-label' },
	              _react3.default.createElement('i', { styleName: 'price-icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.price_per_day' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'price-detail' },
	              _react3.default.createElement(
	                'span',
	                { styleName: 'price' },
	                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates)),
	                ' ',
	                siteConfigs.fixYuan ? '元' : currency,
	                '/',
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.day' })
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'action-container' },
	            _react3.default.createElement(
	              'p',
	              { styleName: 'guarantee' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed' }),
	              ' ',
	              _react3.default.createElement('i', { styleName: 'question-mark', 'data-tip': true, 'data-for': 'guarantee' })
	            ),
	            _react3.default.createElement(
	              _reactTooltip2.default,
	              { id: 'guarantee', place: 'bottom', type: 'light', effect: 'solid', border: true },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'tooltip-header-container' },
	                _react3.default.createElement('i', { styleName: 'inspiration-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'tooltip-header' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed' })
	                )
	              ),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'tooltip-content' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed.description', values: { lineBreak: _react3.default.createElement('br', null) } })
	              )
	            ),
	            function () {
	              if (trip.is_request_form === true) {
	                return false;
	              }
	              if (user && user._id === trip.user_id._id) {
	                return _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-request-disable' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
	                );
	              } else if (requesting) {
	                return _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-request-loading' },
	                  _react3.default.createElement(_LoadingButton2.default, null),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.loading' })
	                );
	              }
	              if (siteConfigs.showLineAddAndFacebookMessage) return null;
	              return _react3.default.createElement(
	                'a',
	                { styleName: 'btn-request', onClick: _this2.requestBook },
	                isInstant ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.instant_book' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
	              );
	            }(),
	            function () {
	              if (trip.is_request_form === true) {
	                return false;
	              }
	              if (siteConfigs.showLineAddAndFacebookMessage) {
	                if (user && user._id === trip.user_id._id) {
	                  return [_react3.default.createElement(
	                    'a',
	                    { styleName: 'btn-chat-facebook-disabled', target: '_blank', href: 'https://www.facebook.com/messages/t/pachantiew' },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
	                  ), _react3.default.createElement(
	                    'a',
	                    { styleName: 'btn-chat-line-disabled', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
	                  )];
	                }
	                return [_react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-chat-facebook', target: '_blank', href: 'https://www.facebook.com/messages/t/pachantiew' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
	                ), _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-chat-line', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
	                )];
	              }
	              if (user && user._id === trip.user_id._id) {
	                return _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-chat-disable' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	                );
	              }
	              return _react3.default.createElement(
	                'a',
	                { styleName: 'btn-chat', onClick: _this2.openChat },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
	              );
	            }()
	          )
	        )
	      );
	    }
	  }]);
	  return RequestBook;
	}(_react2.Component), _class2.propTypes = {
	  onClose: _react2.PropTypes.func,
	  onOpenChat: _react2.PropTypes.func,
	  rates: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  trip: _react2.PropTypes.object,
	  setSessionData: _react2.PropTypes.func,
	  setLocalSessionData: _react2.PropTypes.func,
	  // selectedDate: PropTypes.object,
	  push: _react2.PropTypes.func,
	  isLoggedIn: _react2.PropTypes.bool,
	  creating: _react2.PropTypes.bool,
	  user: _react2.PropTypes.object,
	  isInstant: _react2.PropTypes.bool,
	  setError: _react2.PropTypes.func,
	  paymentDate: _react2.PropTypes.any,
	  paymentDateStatus: _react2.PropTypes.string,
	  // p2pReview: PropTypes.bool,
	  setPaymentField: _react2.PropTypes.func,
	  setPaymentData: _react2.PropTypes.func,
	  requesting: _react2.PropTypes.bool,
	  logCustomizeTrip: _react2.PropTypes.func,
	  omitBookingFee: _react2.PropTypes.bool,
	  siteConfigs: _react2.PropTypes.object,
	  acceptSwap: _react2.PropTypes.bool,
	  logSetDate: _react2.PropTypes.func,
	  logAcceptSwap: _react2.PropTypes.func,
	  setTripDate: _react2.PropTypes.func,
	  logRequest: _react2.PropTypes.func
	}, _temp)) || _class) || _class));
	
	exports.default = RequestBook;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ShareSocialsModal = __webpack_require__(1242);
	
	var _ShareSocialsModal2 = _interopRequireDefault(_ShareSocialsModal);
	
	var _reactIntl = __webpack_require__(10);
	
	var _ShareSocials = __webpack_require__(1527);
	
	var _ShareSocials2 = _interopRequireDefault(_ShareSocials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ShareSocialsModal: {
	    displayName: 'ShareSocialsModal'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/ShareSocialsModal.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ShareSocialsModal = _wrapComponent('ShareSocialsModal')((_dec = (0, _reactCssModules2.default)(_ShareSocialsModal2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ShareSocialsModal, _Component);
	
	  function ShareSocialsModal() {
	    (0, _classCallCheck3.default)(this, ShareSocialsModal);
	    return (0, _possibleConstructorReturn3.default)(this, (ShareSocialsModal.__proto__ || (0, _getPrototypeOf2.default)(ShareSocialsModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ShareSocialsModal, [{
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'social' },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'social-head' },
	          _react3.default.createElement(
	            'h2',
	            null,
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.label' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner' },
	          _react3.default.createElement(_ShareSocials2.default, { slug: this.props.slug })
	        )
	      );
	    }
	  }]);
	  return ShareSocialsModal;
	}(_react2.Component), _class2.propTypes = {
	  slug: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = ShareSocialsModal;
	module.exports = exports['default'];

/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SimilarTrips = __webpack_require__(1244);
	
	var _SimilarTrips2 = _interopRequireDefault(_SimilarTrips);
	
	var _reactIntl = __webpack_require__(10);
	
	var _SimilarTrip = __webpack_require__(321);
	
	var _SimilarTrip2 = _interopRequireDefault(_SimilarTrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  SimilarTrips: {
	    displayName: 'SimilarTrips'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/SimilarTrips.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var SimilarTrips = _wrapComponent('SimilarTrips')((_dec = (0, _reactCssModules2.default)(_SimilarTrips2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SimilarTrips, _Component);
	
	  function SimilarTrips() {
	    (0, _classCallCheck3.default)(this, SimilarTrips);
	    return (0, _possibleConstructorReturn3.default)(this, (SimilarTrips.__proto__ || (0, _getPrototypeOf2.default)(SimilarTrips)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SimilarTrips, [{
	    key: 'render',
	    value: function render() {
	      var trip = this.props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        null,
	        _react3.default.createElement(
	          'h2',
	          { styleName: 'sub-header' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.similar_trips.label' })
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'group' },
	          trip.similarTrips.map(function (st, index) {
	            return _react3.default.createElement(
	              'div',
	              { key: st._id, styleName: 'similar-container' },
	              _react3.default.createElement(_SimilarTrip2.default, { trip: st, prob: trip.similar_probs[index], index: index })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return SimilarTrips;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = SimilarTrips;
	module.exports = exports['default'];

/***/ }),

/***/ 1915:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsCircleCreator = __webpack_require__(1927);
	
	var _creatorsCircleCreator2 = _interopRequireDefault(_creatorsCircleCreator);
	
	var Circle = (function (_Component) {
	  _inherits(Circle, _Component);
	
	  function Circle() {
	    _classCallCheck(this, Circle);
	
	    _get(Object.getPrototypeOf(Circle.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(Circle, [{
	    key: "getBounds",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getBounds() {
	      return this.state.circle.getBounds();
	    }
	  }, {
	    key: "getCenter",
	    value: function getCenter() {
	      return this.state.circle.getCenter();
	    }
	  }, {
	    key: "getDraggable",
	    value: function getDraggable() {
	      return this.state.circle.getDraggable();
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable() {
	      return this.state.circle.getEditable();
	    }
	  }, {
	    key: "getMap",
	    value: function getMap() {
	      return this.state.circle.getMap();
	    }
	  }, {
	    key: "getRadius",
	    value: function getRadius() {
	      return this.state.circle.getRadius();
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.state.circle.getVisible();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var circle = _creatorsCircleCreator2["default"]._createCircle(this.props);
	
	      this.setState({ circle: circle });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.circle) {
	        return _react2["default"].createElement(
	          _creatorsCircleCreator2["default"],
	          _extends({ circle: this.state.circle }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsCircleCreator.circleDefaultPropTypes, _creatorsCircleCreator.circleControlledPropTypes, _creatorsCircleCreator.circleEventPropTypes),
	    enumerable: true
	  }]);
	
	  return Circle;
	})(_react.Component);
	
	exports["default"] = Circle;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsDirectionsRendererCreator = __webpack_require__(1928);
	
	var _creatorsDirectionsRendererCreator2 = _interopRequireDefault(_creatorsDirectionsRendererCreator);
	
	/*
	 * Original author: @alexishevia
	 * Original PR: https://github.com/tomchentw/react-google-maps/pull/22
	 */
	
	var DirectionsRenderer = (function (_Component) {
	  _inherits(DirectionsRenderer, _Component);
	
	  function DirectionsRenderer() {
	    _classCallCheck(this, DirectionsRenderer);
	
	    _get(Object.getPrototypeOf(DirectionsRenderer.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(DirectionsRenderer, [{
	    key: "getDirections",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getDirections() {
	      return this.state.directionsRenderer.getDirections();
	    }
	  }, {
	    key: "getPanel",
	    value: function getPanel() {
	      return this.state.directionsRenderer.getPanel();
	    }
	  }, {
	    key: "getRouteIndex",
	    value: function getRouteIndex() {
	      return this.state.directionsRenderer.getRouteIndex();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var directionsRenderer = _creatorsDirectionsRendererCreator2["default"]._createDirectionsRenderer(this.props);
	
	      this.setState({ directionsRenderer: directionsRenderer });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.directionsRenderer) {
	        return _react2["default"].createElement(
	          _creatorsDirectionsRendererCreator2["default"],
	          _extends({ directionsRenderer: this.state.directionsRenderer }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsDirectionsRendererCreator.directionsRendererDefaultPropTypes, _creatorsDirectionsRendererCreator.directionsRendererControlledPropTypes, _creatorsDirectionsRendererCreator.directionsRendererEventPropTypes),
	    enumerable: true
	  }]);
	
	  return DirectionsRenderer;
	})(_react.Component);
	
	exports["default"] = DirectionsRenderer;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsDrawingManagerCreator = __webpack_require__(1929);
	
	var _creatorsDrawingManagerCreator2 = _interopRequireDefault(_creatorsDrawingManagerCreator);
	
	/*
	 * Original author: @idolize
	 * Original PR: https://github.com/tomchentw/react-google-maps/pull/46
	 */
	
	var DrawingManager = (function (_Component) {
	  _inherits(DrawingManager, _Component);
	
	  function DrawingManager() {
	    _classCallCheck(this, DrawingManager);
	
	    _get(Object.getPrototypeOf(DrawingManager.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(DrawingManager, [{
	    key: "getDrawingMode",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getDrawingMode() {
	      return this.state.drawingManager.getDrawingMode();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var drawingManager = _creatorsDrawingManagerCreator2["default"]._createDrawingManager(this.props);
	
	      this.setState({ drawingManager: drawingManager });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.drawingManager) {
	        return _react2["default"].createElement(
	          _creatorsDrawingManagerCreator2["default"],
	          _extends({ drawingManager: this.state.drawingManager }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsDrawingManagerCreator.drawingManagerDefaultPropTypes, _creatorsDrawingManagerCreator.drawingManagerControlledPropTypes, _creatorsDrawingManagerCreator.drawingManagerEventPropTypes),
	    enumerable: true
	  }]);
	
	  return DrawingManager;
	})(_react.Component);
	
	exports["default"] = DrawingManager;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(757);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _creatorsGoogleMapHolder = __webpack_require__(99);
	
	var _creatorsGoogleMapHolder2 = _interopRequireDefault(_creatorsGoogleMapHolder);
	
	var _GoogleMapLoader = __webpack_require__(755);
	
	var _GoogleMapLoader2 = _interopRequireDefault(_GoogleMapLoader);
	
	var USE_NEW_BEHAVIOR_TAG_NAME = "__new_behavior__";
	
	var GoogleMap = (function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  function GoogleMap() {
	    _classCallCheck(this, GoogleMap);
	
	    _get(Object.getPrototypeOf(GoogleMap.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(GoogleMap, [{
	    key: "getBounds",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	    value: function getBounds() {
	      return (this.props.map || this.refs.delegate).getBounds();
	    }
	  }, {
	    key: "getCenter",
	    value: function getCenter() {
	      return (this.props.map || this.refs.delegate).getCenter();
	    }
	  }, {
	    key: "getDiv",
	    value: function getDiv() {
	      return (this.props.map || this.refs.delegate).getDiv();
	    }
	  }, {
	    key: "getHeading",
	    value: function getHeading() {
	      return (this.props.map || this.refs.delegate).getHeading();
	    }
	  }, {
	    key: "getMapTypeId",
	    value: function getMapTypeId() {
	      return (this.props.map || this.refs.delegate).getMapTypeId();
	    }
	  }, {
	    key: "getProjection",
	    value: function getProjection() {
	      return (this.props.map || this.refs.delegate).getProjection();
	    }
	  }, {
	    key: "getStreetView",
	    value: function getStreetView() {
	      return (this.props.map || this.refs.delegate).getStreetView();
	    }
	  }, {
	    key: "getTilt",
	    value: function getTilt() {
	      return (this.props.map || this.refs.delegate).getTilt();
	    }
	  }, {
	    key: "getZoom",
	    value: function getZoom() {
	      return (this.props.map || this.refs.delegate).getZoom();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	    //
	    // Public APIs - Use this carefully
	    // See discussion in https://github.com/tomchentw/react-google-maps/issues/62
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return !it.match(/^get/) && !it.match(/^set/) && !it.match(/Map$/); })
	  }, {
	    key: "fitBounds",
	    value: function fitBounds(bounds) {
	      return (this.props.map || this.refs.delegate).fitBounds(bounds);
	    }
	  }, {
	    key: "panBy",
	    value: function panBy(x, y) {
	      return (this.props.map || this.refs.delegate).panBy(x, y);
	    }
	  }, {
	    key: "panTo",
	    value: function panTo(latLng) {
	      return (this.props.map || this.refs.delegate).panTo(latLng);
	    }
	  }, {
	    key: "panToBounds",
	    value: function panToBounds(latLngBounds) {
	      return (this.props.map || this.refs.delegate).panToBounds(latLngBounds);
	    }
	
	    // END - Public APIs - Use this carefully
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var containerTagName = this.props.containerTagName;
	
	      var isUsingNewBehavior = USE_NEW_BEHAVIOR_TAG_NAME === containerTagName;
	
	      (0, _warning2["default"])(isUsingNewBehavior, "\"GoogleMap\" with containerTagName is deprecated now and will be removed in next major release (5.0.0).\nUse \"GoogleMapLoader\" instead. See https://github.com/tomchentw/react-google-maps/pull/157 for more details.");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var containerTagName = _props.containerTagName;
	      var _props$containerProps = _props.containerProps;
	      var containerProps = _props$containerProps === undefined ? {} : _props$containerProps;
	      var children = _props.children;
	
	      var mapProps = _objectWithoutProperties(_props, ["containerTagName", "containerProps", "children"]);
	
	      var isUsingNewBehavior = USE_NEW_BEHAVIOR_TAG_NAME === containerTagName;
	
	      if (isUsingNewBehavior) {
	        return _react2["default"].createElement(
	          _creatorsGoogleMapHolder2["default"],
	          mapProps,
	          children
	        );
	      } else {
	        // ------------ Deprecated ------------
	        var realContainerTagName = containerTagName === undefined || containerTagName === null ? "div" : containerTagName;
	
	        return _react2["default"].createElement(_GoogleMapLoader2["default"], {
	          ref: "loader",
	          containerElement: _react2["default"].createElement(realContainerTagName, containerProps),
	          googleMapElement: _react2["default"].createElement(
	            GoogleMap,
	            _extends({ ref: "delegate", containerTagName: USE_NEW_BEHAVIOR_TAG_NAME }, mapProps),
	            children
	          )
	        });
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({
	      containerTagName: _react.PropTypes.string,
	      containerProps: _react.PropTypes.object,
	      map: _react.PropTypes.object
	    }, _creatorsGoogleMapHolder.mapDefaultPropTypes, _creatorsGoogleMapHolder.mapControlledPropTypes, _creatorsGoogleMapHolder.mapEventPropTypes),
	    enumerable: true
	  }]);
	
	  return GoogleMap;
	})(_react.Component);
	
	exports["default"] = GoogleMap;
	module.exports = exports["default"];
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsInfoWindowCreator = __webpack_require__(1930);
	
	var _creatorsInfoWindowCreator2 = _interopRequireDefault(_creatorsInfoWindowCreator);
	
	var InfoWindow = (function (_Component) {
	  _inherits(InfoWindow, _Component);
	
	  function InfoWindow() {
	    _classCallCheck(this, InfoWindow);
	
	    _get(Object.getPrototypeOf(InfoWindow.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(InfoWindow, [{
	    key: "getContent",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getContent() {/* TODO: children */}
	  }, {
	    key: "getPosition",
	    value: function getPosition() {
	      return this.state.infoWindow.getPosition();
	    }
	  }, {
	    key: "getZIndex",
	    value: function getZIndex() {
	      return this.state.infoWindow.getZIndex();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var infoWindow = _creatorsInfoWindowCreator2["default"]._createInfoWindow(this.props);
	
	      this.setState({ infoWindow: infoWindow });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.infoWindow) {
	        return _react2["default"].createElement(
	          _creatorsInfoWindowCreator2["default"],
	          _extends({ infoWindow: this.state.infoWindow }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsInfoWindowCreator.infoWindowDefaultPropTypes, _creatorsInfoWindowCreator.infoWindowControlledPropTypes, _creatorsInfoWindowCreator.infoWindowEventPropTypes),
	    enumerable: true
	  }]);
	
	  return InfoWindow;
	})(_react.Component);
	
	exports["default"] = InfoWindow;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsKmlLayerCreator = __webpack_require__(1931);
	
	var _creatorsKmlLayerCreator2 = _interopRequireDefault(_creatorsKmlLayerCreator);
	
	var KmlLayer = (function (_Component) {
	  _inherits(KmlLayer, _Component);
	
	  function KmlLayer() {
	    _classCallCheck(this, KmlLayer);
	
	    _get(Object.getPrototypeOf(KmlLayer.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(KmlLayer, [{
	    key: "getDefaultViewport",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	    value: function getDefaultViewport() {
	      return this.state.kmlLayer.getDefaultViewport();
	    }
	  }, {
	    key: "getMetadata",
	    value: function getMetadata() {
	      return this.state.kmlLayer.getMetadata();
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      return this.state.kmlLayer.getStatus();
	    }
	  }, {
	    key: "getUrl",
	    value: function getUrl() {
	      return this.state.kmlLayer.getUrl();
	    }
	  }, {
	    key: "getZIndex",
	    value: function getZIndex() {
	      return this.state.marker.getZIndex();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var kmlLayer = _creatorsKmlLayerCreator2["default"]._createKmlLayer(this.props);
	
	      this.setState({ kmlLayer: kmlLayer });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.kmlLayer) {
	        return _react2["default"].createElement(
	          _creatorsKmlLayerCreator2["default"],
	          _extends({ kmlLayer: this.state.kmlLayer }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsKmlLayerCreator.kmlLayerDefaultPropTypes, _creatorsKmlLayerCreator.kmlLayerControlledPropTypes, _creatorsKmlLayerCreator.kmlLayerEventPropTypes),
	    enumerable: true
	  }]);
	
	  return KmlLayer;
	})(_react.Component);
	
	exports["default"] = KmlLayer;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsMarkerCreator = __webpack_require__(1932);
	
	var _creatorsMarkerCreator2 = _interopRequireDefault(_creatorsMarkerCreator);
	
	var Marker = (function (_Component) {
	  _inherits(Marker, _Component);
	
	  function Marker() {
	    _classCallCheck(this, Marker);
	
	    _get(Object.getPrototypeOf(Marker.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(Marker, [{
	    key: "getAnimation",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	    value: function getAnimation() {
	      return this.state.marker.getAnimation();
	    }
	  }, {
	    key: "getAttribution",
	    value: function getAttribution() {
	      return this.state.marker.getAttribution();
	    }
	  }, {
	    key: "getClickable",
	    value: function getClickable() {
	      return this.state.marker.getClickable();
	    }
	  }, {
	    key: "getCursor",
	    value: function getCursor() {
	      return this.state.marker.getCursor();
	    }
	  }, {
	    key: "getDraggable",
	    value: function getDraggable() {
	      return this.state.marker.getDraggable();
	    }
	  }, {
	    key: "getIcon",
	    value: function getIcon() {
	      return this.state.marker.getIcon();
	    }
	  }, {
	    key: "getLabel",
	    value: function getLabel() {
	      return this.state.marker.getLabel();
	    }
	  }, {
	    key: "getOpacity",
	    value: function getOpacity() {
	      return this.state.marker.getOpacity();
	    }
	  }, {
	    key: "getPlace",
	    value: function getPlace() {
	      return this.state.marker.getPlace();
	    }
	  }, {
	    key: "getPosition",
	    value: function getPosition() {
	      return this.state.marker.getPosition();
	    }
	  }, {
	    key: "getShape",
	    value: function getShape() {
	      return this.state.marker.getShape();
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle() {
	      return this.state.marker.getTitle();
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.state.marker.getVisible();
	    }
	  }, {
	    key: "getZIndex",
	    value: function getZIndex() {
	      return this.state.marker.getZIndex();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var marker = _creatorsMarkerCreator2["default"]._createMarker(this.props);
	
	      this.setState({ marker: marker });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	
	      var anchorHolderRef = this.props.anchorHolderRef;
	      var marker = this.state.marker;
	
	      if (anchorHolderRef) {
	        if ("MarkerClusterer" === anchorHolderRef.getAnchorType()) {
	          anchorHolderRef.getAnchor().removeMarker(marker);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.marker) {
	        return _react2["default"].createElement(
	          _creatorsMarkerCreator2["default"],
	          _extends({ marker: this.state.marker }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsMarkerCreator.markerDefaultPropTypes, _creatorsMarkerCreator.markerControlledPropTypes, _creatorsMarkerCreator.markerEventPropTypes),
	    enumerable: true
	  }]);
	
	  return Marker;
	})(_react.Component);
	
	exports["default"] = Marker;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1922:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsOverlayViewCreator = __webpack_require__(1933);
	
	var _creatorsOverlayViewCreator2 = _interopRequireDefault(_creatorsOverlayViewCreator);
	
	/*
	 * Original author: @petebrowne
	 * Original PR: https://github.com/tomchentw/react-google-maps/pull/63
	 */
	
	var OverlayView = (function (_Component) {
	  _inherits(OverlayView, _Component);
	
	  function OverlayView() {
	    _classCallCheck(this, OverlayView);
	
	    _get(Object.getPrototypeOf(OverlayView.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(OverlayView, [{
	    key: "getPanes",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getPanes() {
	      return this.state.overlayView.getPanes();
	    }
	  }, {
	    key: "getProjection",
	    value: function getProjection() {
	      return this.state.overlayView.getProjection();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var overlayView = _creatorsOverlayViewCreator2["default"]._createOverlayView(this.props);
	
	      this.setState({ overlayView: overlayView });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.overlayView) {
	        return _react2["default"].createElement(
	          _creatorsOverlayViewCreator2["default"],
	          _extends({ overlayView: this.state.overlayView }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "FLOAT_PANE",
	    value: "floatPane",
	    enumerable: true
	  }, {
	    key: "MAP_PANE",
	    value: "mapPane",
	    enumerable: true
	  }, {
	    key: "MARKER_LAYER",
	    value: "markerLayer",
	    enumerable: true
	  }, {
	    key: "OVERLAY_LAYER",
	    value: "overlayLayer",
	    enumerable: true
	  }, {
	    key: "OVERLAY_MOUSE_TARGET",
	    value: "overlayMouseTarget",
	    enumerable: true
	  }, {
	    key: "propTypes",
	    value: _extends({}, _creatorsOverlayViewCreator.overlayViewDefaultPropTypes, _creatorsOverlayViewCreator.overlayViewControlledPropTypes),
	    enumerable: true
	  }, {
	    key: "defaultProps",
	    value: {
	      mapPaneName: OverlayView.OVERLAY_LAYER
	    },
	    enumerable: true
	  }]);
	
	  return OverlayView;
	})(_react.Component);
	
	exports["default"] = OverlayView;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate

/***/ }),

/***/ 1923:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsPolygonCreator = __webpack_require__(1934);
	
	var _creatorsPolygonCreator2 = _interopRequireDefault(_creatorsPolygonCreator);
	
	var Polygon = (function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    _get(Object.getPrototypeOf(Polygon.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(Polygon, [{
	    key: "getDraggable",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getDraggable() {
	      return this.state.polygon.getDraggable();
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable() {
	      return this.state.polygon.getEditable();
	    }
	  }, {
	    key: "getPath",
	    value: function getPath() {
	      return this.state.polygon.getPath();
	    }
	  }, {
	    key: "getPaths",
	    value: function getPaths() {
	      return this.state.polygon.getPaths();
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.state.polygon.getVisible();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var polygon = _creatorsPolygonCreator2["default"]._createPolygon(this.props);
	
	      this.setState({ polygon: polygon });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.polygon) {
	        return _react2["default"].createElement(
	          _creatorsPolygonCreator2["default"],
	          _extends({ polygon: this.state.polygon }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsPolygonCreator.polygonDefaultPropTypes, _creatorsPolygonCreator.polygonControlledPropTypes, _creatorsPolygonCreator.polygonEventPropTypes),
	    enumerable: true
	  }]);
	
	  return Polygon;
	})(_react.Component);
	
	exports["default"] = Polygon;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1924:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsPolylineCreator = __webpack_require__(1935);
	
	var _creatorsPolylineCreator2 = _interopRequireDefault(_creatorsPolylineCreator);
	
	var Polyline = (function (_Component) {
	  _inherits(Polyline, _Component);
	
	  function Polyline() {
	    _classCallCheck(this, Polyline);
	
	    _get(Object.getPrototypeOf(Polyline.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(Polyline, [{
	    key: "getDraggable",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getDraggable() {
	      return this.state.polyline.getDraggable();
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable() {
	      return this.state.polyline.getEditable();
	    }
	  }, {
	    key: "getPath",
	    value: function getPath() {
	      return this.state.polyline.getPath();
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.state.polyline.getVisible();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var polyline = _creatorsPolylineCreator2["default"]._createPolyline(this.props);
	
	      this.setState({ polyline: polyline });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.polyline) {
	        return _react2["default"].createElement(
	          _creatorsPolylineCreator2["default"],
	          _extends({ polyline: this.state.polyline }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsPolylineCreator.polylineDefaultPropTypes, _creatorsPolylineCreator.polylineControlledPropTypes, _creatorsPolylineCreator.polylineEventPropTypes),
	    enumerable: true
	  }]);
	
	  return Polyline;
	})(_react.Component);
	
	exports["default"] = Polyline;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsRectangleCreator = __webpack_require__(1936);
	
	var _creatorsRectangleCreator2 = _interopRequireDefault(_creatorsRectangleCreator);
	
	/*
	 * Original author: @alistairjcbrown
	 * Original PR: https://github.com/tomchentw/react-google-maps/pull/80
	 */
	
	var Rectangle = (function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    _classCallCheck(this, Rectangle);
	
	    _get(Object.getPrototypeOf(Rectangle.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(Rectangle, [{
	    key: "getBounds",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/^getMap/); })
	    value: function getBounds() {
	      return this.state.rectangle.getBounds();
	    }
	  }, {
	    key: "getDraggable",
	    value: function getDraggable() {
	      return this.state.rectangle.getDraggable();
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable() {
	      return this.state.rectangle.getEditable();
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.state.rectangle.getVisible();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var rectangle = _creatorsRectangleCreator2["default"]._createRectangle(this.props);
	
	      this.setState({ rectangle: rectangle });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.rectangle) {
	        return _react2["default"].createElement(
	          _creatorsRectangleCreator2["default"],
	          _extends({ rectangle: this.state.rectangle }, this.props),
	          this.props.children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsRectangleCreator.rectangleDefaultPropTypes, _creatorsRectangleCreator.rectangleControlledPropTypes, _creatorsRectangleCreator.rectangleEventPropTypes),
	    enumerable: true
	  }]);
	
	  return Rectangle;
	})(_react.Component);
	
	exports["default"] = Rectangle;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canUseDom = __webpack_require__(105);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _creatorsSearchBoxCreator = __webpack_require__(1937);
	
	var _creatorsSearchBoxCreator2 = _interopRequireDefault(_creatorsSearchBoxCreator);
	
	/*
	 * Original author: @eyebraus
	 * Original PR: https://github.com/tomchentw/react-google-maps/pull/110
	 */
	
	var SearchBox = (function (_Component) {
	  _inherits(SearchBox, _Component);
	
	  function SearchBox() {
	    _classCallCheck(this, SearchBox);
	
	    _get(Object.getPrototypeOf(SearchBox.prototype), "constructor", this).apply(this, arguments);
	
	    this.state = {};
	  }
	
	  _createClass(SearchBox, [{
	    key: "getBounds",
	
	    // Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
	    //
	    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
	    value: function getBounds() {
	      return this.state.searchBox.getBounds();
	    }
	  }, {
	    key: "getPlaces",
	    value: function getPlaces() {
	      return this.state.searchBox.getPlaces();
	    }
	
	    // END - Public APIs
	    //
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
	
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!_canUseDom2["default"]) {
	        return;
	      }
	      var _props = this.props;
	      var mapHolderRef = _props.mapHolderRef;
	      var classes = _props.classes;
	      var style = _props.style;
	      var placeholder = _props.placeholder;
	
	      var searchBoxProps = _objectWithoutProperties(_props, ["mapHolderRef", "classes", "style", "placeholder"]);
	
	      // Cannot create input via component - Google Maps will mess with React's internal state by detaching/attaching.
	      // Allow developers to style the "hidden element" via inputClasses.
	      var domEl = document.createElement("input");
	      domEl.className = classes;
	      domEl.type = "text";
	      domEl.placeholder = placeholder;
	
	      for (var propKey in style) {
	        if (style.hasOwnProperty(propKey)) {
	          domEl.style[propKey] = style[propKey];
	        }
	      }
	
	      var searchBox = _creatorsSearchBoxCreator2["default"]._createSearchBox(domEl, searchBoxProps);
	
	      this.setState({
	        inputElement: domEl,
	        searchBox: searchBox
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props;
	      var mapHolderRef = _props2.mapHolderRef;
	      var controlPosition = _props2.controlPosition;
	
	      return this.state.searchBox ? _react2["default"].createElement(
	        _creatorsSearchBoxCreator2["default"],
	        _extends({ controlPosition: controlPosition, inputElement: this.state.inputElement, mapHolderRef: mapHolderRef, searchBox: this.state.searchBox }, this.props),
	        this.props.children
	      ) : _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "propTypes",
	    value: _extends({}, _creatorsSearchBoxCreator.searchBoxDefaultPropTypes, _creatorsSearchBoxCreator.searchBoxControlledPropTypes, _creatorsSearchBoxCreator.searchBoxEventPropTypes),
	    enumerable: true
	  }]);
	
	  return SearchBox;
	})(_react.Component);
	
	exports["default"] = SearchBox;
	module.exports = exports["default"];
	
	// Uncontrolled default[props] - used only in componentDidMount
	
	// Controlled [props] - used in componentDidMount/componentDidUpdate
	
	// Event [onEventName]

/***/ }),

/***/ 1927:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsCircleEventList = __webpack_require__(1938);
	
	var _eventListsCircleEventList2 = _interopRequireDefault(_eventListsCircleEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var circleControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	  center: _react.PropTypes.any,
	  draggable: _react.PropTypes.bool,
	  editable: _react.PropTypes.bool,
	  options: _react.PropTypes.object,
	  radius: _react.PropTypes.number,
	  visible: _react.PropTypes.bool
	};
	
	exports.circleControlledPropTypes = circleControlledPropTypes;
	var circleDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(circleControlledPropTypes);
	
	exports.circleDefaultPropTypes = circleDefaultPropTypes;
	var circleUpdaters = {
	  center: function center(_center, component) {
	    component.getCircle().setCenter(_center);
	  },
	  draggable: function draggable(_draggable, component) {
	    component.getCircle().setDraggable(_draggable);
	  },
	  editable: function editable(_editable, component) {
	    component.getCircle().setEditable(_editable);
	  },
	  options: function options(_options, component) {
	    component.getCircle().setOptions(_options);
	  },
	  radius: function radius(_radius, component) {
	    component.getCircle().setRadius(_radius);
	  },
	  visible: function visible(_visible, component) {
	    component.getCircle().setVisible(_visible);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsCircleEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var circleEventPropTypes = eventPropTypes;
	
	exports.circleEventPropTypes = circleEventPropTypes;
	
	var CircleCreator = (function (_Component) {
	  _inherits(CircleCreator, _Component);
	
	  function CircleCreator() {
	    _classCallCheck(this, _CircleCreator);
	
	    _get(Object.getPrototypeOf(_CircleCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(CircleCreator, [{
	    key: "getCircle",
	    value: function getCircle() {
	      return this.props.circle;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createCircle",
	    value: function _createCircle(circleProps) {
	      var mapHolderRef = circleProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	      var circle = new google.maps.Circle((0, _utilsComposeOptions2["default"])(circleProps, circleControlledPropTypes));
	
	      circle.setMap(mapHolderRef.getMap());
	
	      return circle;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      circle: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _CircleCreator = CircleCreator;
	  CircleCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getCircle",
	    updaters: circleUpdaters
	  })(CircleCreator) || CircleCreator;
	  return CircleCreator;
	})(_react.Component);
	
	exports["default"] = CircleCreator;

/***/ }),

/***/ 1928:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsDirectionsRendererEventList = __webpack_require__(1939);
	
	var _eventListsDirectionsRendererEventList2 = _interopRequireDefault(_eventListsDirectionsRendererEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var directionsRendererControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	  directions: _react.PropTypes.any,
	  options: _react.PropTypes.object,
	  panel: _react.PropTypes.object,
	  routeIndex: _react.PropTypes.number
	};
	
	exports.directionsRendererControlledPropTypes = directionsRendererControlledPropTypes;
	var directionsRendererDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(directionsRendererControlledPropTypes);
	
	exports.directionsRendererDefaultPropTypes = directionsRendererDefaultPropTypes;
	var directionsRendererUpdaters = {
	  directions: function directions(_directions, component) {
	    component.getDirectionsRenderer().setDirections(_directions);
	  },
	  options: function options(_options, component) {
	    component.getDirectionsRenderer().setOptions(_options);
	  },
	  panel: function panel(_panel, component) {
	    component.getDirectionsRenderer().setPanel(_panel);
	  },
	  routeIndex: function routeIndex(_routeIndex, component) {
	    component.getDirectionsRenderer().setRouteIndex(_routeIndex);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsDirectionsRendererEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var directionsRendererEventPropTypes = eventPropTypes;
	
	exports.directionsRendererEventPropTypes = directionsRendererEventPropTypes;
	
	var DirectionsRendererCreator = (function (_Component) {
	  _inherits(DirectionsRendererCreator, _Component);
	
	  function DirectionsRendererCreator() {
	    _classCallCheck(this, _DirectionsRendererCreator);
	
	    _get(Object.getPrototypeOf(_DirectionsRendererCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(DirectionsRendererCreator, [{
	    key: "getDirectionsRenderer",
	    value: function getDirectionsRenderer() {
	      return this.props.directionsRenderer;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	
	      if (_react.Children.count(children) > 0) {
	        // TODO: take a look at DirectionsRendererOptions#infoWindow and DirectionsRendererOptions#markerOptions ?
	        return _react2["default"].createElement(
	          "div",
	          null,
	          children
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "_createDirectionsRenderer",
	    value: function _createDirectionsRenderer(directionsRendererProps) {
	      var mapHolderRef = directionsRendererProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	      var directionsRenderer = new google.maps.DirectionsRenderer((0, _utilsComposeOptions2["default"])(directionsRendererProps, directionsRendererControlledPropTypes));
	
	      directionsRenderer.setMap(mapHolderRef.getMap());
	
	      return directionsRenderer;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      directionsRenderer: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _DirectionsRendererCreator = DirectionsRendererCreator;
	  DirectionsRendererCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getDirectionsRenderer",
	    updaters: directionsRendererUpdaters
	  })(DirectionsRendererCreator) || DirectionsRendererCreator;
	  return DirectionsRendererCreator;
	})(_react.Component);
	
	exports["default"] = DirectionsRendererCreator;

/***/ }),

/***/ 1929:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsDrawingManagerEventList = __webpack_require__(1940);
	
	var _eventListsDrawingManagerEventList2 = _interopRequireDefault(_eventListsDrawingManagerEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var drawingManagerControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	  drawingMode: _react.PropTypes.any,
	  options: _react.PropTypes.object
	};
	
	exports.drawingManagerControlledPropTypes = drawingManagerControlledPropTypes;
	var drawingManagerDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(drawingManagerControlledPropTypes);
	
	exports.drawingManagerDefaultPropTypes = drawingManagerDefaultPropTypes;
	var drawingManagerUpdaters = {
	  drawingMode: function drawingMode(_drawingMode, component) {
	    component.getDrawingManager().setDrawingMode(_drawingMode);
	  },
	  options: function options(_options, component) {
	    component.getDrawingManager().setOptions(_options);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsDrawingManagerEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var drawingManagerEventPropTypes = eventPropTypes;
	
	exports.drawingManagerEventPropTypes = drawingManagerEventPropTypes;
	
	var DrawingManagerCreator = (function (_Component) {
	  _inherits(DrawingManagerCreator, _Component);
	
	  function DrawingManagerCreator() {
	    _classCallCheck(this, _DrawingManagerCreator);
	
	    _get(Object.getPrototypeOf(_DrawingManagerCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(DrawingManagerCreator, [{
	    key: "getDrawingManager",
	    value: function getDrawingManager() {
	      return this.props.drawingManager;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createDrawingManager",
	    value: function _createDrawingManager(drawingManagerProps) {
	      var mapHolderRef = drawingManagerProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	      var drawingManager = new google.maps.drawing.DrawingManager((0, _utilsComposeOptions2["default"])(drawingManagerProps, drawingManagerControlledPropTypes));
	
	      drawingManager.setMap(mapHolderRef.getMap());
	
	      return drawingManager;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      drawingManager: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _DrawingManagerCreator = DrawingManagerCreator;
	  DrawingManagerCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getDrawingManager",
	    updaters: drawingManagerUpdaters
	  })(DrawingManagerCreator) || DrawingManagerCreator;
	  return DrawingManagerCreator;
	})(_react.Component);
	
	exports["default"] = DrawingManagerCreator;

/***/ }),

/***/ 1930:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsInfoWindowEventList = __webpack_require__(1942);
	
	var _eventListsInfoWindowEventList2 = _interopRequireDefault(_eventListsInfoWindowEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsSetContentForOptionalReactElement = __webpack_require__(1951);
	
	var _utilsSetContentForOptionalReactElement2 = _interopRequireDefault(_utilsSetContentForOptionalReactElement);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var infoWindowControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	  content: _react.PropTypes.any,
	  options: _react.PropTypes.object,
	  position: _react.PropTypes.any,
	  zIndex: _react.PropTypes.number
	};
	
	exports.infoWindowControlledPropTypes = infoWindowControlledPropTypes;
	var infoWindowDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(infoWindowControlledPropTypes);
	
	exports.infoWindowDefaultPropTypes = infoWindowDefaultPropTypes;
	var infoWindowUpdaters = {
	  children: function children(_children, component) {
	    (0, _utilsSetContentForOptionalReactElement2["default"])(_children, component.getInfoWindow());
	  },
	  content: function content(_content, component) {
	    component.getInfoWindow().setContent(_content);
	  },
	  options: function options(_options, component) {
	    component.getInfoWindow().setOptions(_options);
	  },
	  position: function position(_position, component) {
	    component.getInfoWindow().setPosition(_position);
	  },
	  zIndex: function zIndex(_zIndex, component) {
	    component.getInfoWindow().setZIndex(_zIndex);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsInfoWindowEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var infoWindowEventPropTypes = eventPropTypes;
	
	exports.infoWindowEventPropTypes = infoWindowEventPropTypes;
	
	var InfoWindowCreator = (function (_Component) {
	  _inherits(InfoWindowCreator, _Component);
	
	  function InfoWindowCreator() {
	    _classCallCheck(this, _InfoWindowCreator);
	
	    _get(Object.getPrototypeOf(_InfoWindowCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(InfoWindowCreator, [{
	    key: "getInfoWindow",
	    value: function getInfoWindow() {
	      return this.props.infoWindow;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createInfoWindow",
	    value: function _createInfoWindow(infoWindowProps) {
	      var mapHolderRef = infoWindowProps.mapHolderRef;
	      var anchorHolderRef = infoWindowProps.anchorHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	      var infoWindow = new google.maps.InfoWindow((0, _utilsComposeOptions2["default"])(infoWindowProps, infoWindowControlledPropTypes));
	
	      if (infoWindowProps.children) {
	        (0, _utilsSetContentForOptionalReactElement2["default"])(infoWindowProps.children, infoWindow);
	      }
	
	      if (anchorHolderRef) {
	        infoWindow.open(mapHolderRef.getMap(), anchorHolderRef.getAnchor());
	      } else {
	        infoWindow.setMap(mapHolderRef.getMap());
	      }
	
	      return infoWindow;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      infoWindow: _react.PropTypes.object.isRequired,
	      anchorHolderRef: _react.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  var _InfoWindowCreator = InfoWindowCreator;
	  InfoWindowCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getInfoWindow",
	    updaters: infoWindowUpdaters
	  })(InfoWindowCreator) || InfoWindowCreator;
	  return InfoWindowCreator;
	})(_react.Component);
	
	exports["default"] = InfoWindowCreator;

/***/ }),

/***/ 1931:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsKmlLayerEventList = __webpack_require__(1943);
	
	var _eventListsKmlLayerEventList2 = _interopRequireDefault(_eventListsKmlLayerEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var kmlLayerControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	  defaultViewport: _react.PropTypes.any,
	  metadata: _react.PropTypes.any,
	  status: _react.PropTypes.any,
	  url: _react.PropTypes.string,
	  zIndex: _react.PropTypes.number
	};
	
	exports.kmlLayerControlledPropTypes = kmlLayerControlledPropTypes;
	var kmlLayerDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(kmlLayerControlledPropTypes);
	
	exports.kmlLayerDefaultPropTypes = kmlLayerDefaultPropTypes;
	var kmlLayerUpdaters = {
	  defaultViewport: function defaultViewport(_defaultViewport, component) {
	    component.getKmlLayer().setDefaultViewport(_defaultViewport);
	  },
	  metadata: function metadata(_metadata, component) {
	    component.getKmlLayer().setMetadata(_metadata);
	  },
	  status: function status(_status, component) {
	    component.getKmlLayer().setStatus(_status);
	  },
	  url: function url(_url, component) {
	    component.getKmlLayer().setUrl(_url);
	  },
	  zIndex: function zIndex(_zIndex, component) {
	    component.getKmlLayer().setZIndex(_zIndex);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsKmlLayerEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var kmlLayerEventPropTypes = eventPropTypes;
	
	exports.kmlLayerEventPropTypes = kmlLayerEventPropTypes;
	
	var KmlLayerCreator = (function (_Component) {
	  _inherits(KmlLayerCreator, _Component);
	
	  function KmlLayerCreator() {
	    _classCallCheck(this, _KmlLayerCreator);
	
	    _get(Object.getPrototypeOf(_KmlLayerCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(KmlLayerCreator, [{
	    key: "getKmlLayer",
	    value: function getKmlLayer() {
	      return this.props.kmlLayer;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var mapHolderRef = _props.mapHolderRef;
	      var children = _props.children;
	
	      if (_react.Children.count(children) > 0) {
	        return _react2["default"].createElement(
	          "div",
	          null,
	          _react.Children.map(children, function (childElement) {
	            return childElement && _react2["default"].cloneElement(childElement, {
	              mapHolderRef: mapHolderRef
	            });
	          })
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "_createKmlLayer",
	    value: function _createKmlLayer(kmlLayerProps) {
	      var mapHolderRef = kmlLayerProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	      var kmlLayer = new google.maps.KmlLayer((0, _utilsComposeOptions2["default"])(kmlLayerProps, kmlLayerControlledPropTypes));
	
	      kmlLayer.setMap(mapHolderRef.getMap());
	
	      return kmlLayer;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      kmlLayer: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _KmlLayerCreator = KmlLayerCreator;
	  KmlLayerCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getKmlLayer",
	    updaters: kmlLayerUpdaters
	  })(KmlLayerCreator) || KmlLayerCreator;
	  return KmlLayerCreator;
	})(_react.Component);
	
	exports["default"] = KmlLayerCreator;

/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsMarkerEventList = __webpack_require__(1944);
	
	var _eventListsMarkerEventList2 = _interopRequireDefault(_eventListsMarkerEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var markerControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	  animation: _react.PropTypes.any,
	  attribution: _react.PropTypes.any,
	  clickable: _react.PropTypes.bool,
	  cursor: _react.PropTypes.string,
	  draggable: _react.PropTypes.bool,
	  icon: _react.PropTypes.any,
	  label: _react.PropTypes.any,
	  opacity: _react.PropTypes.number,
	  options: _react.PropTypes.object,
	  place: _react.PropTypes.any,
	  position: _react.PropTypes.any,
	  shape: _react.PropTypes.any,
	  title: _react.PropTypes.string,
	  visible: _react.PropTypes.bool,
	  zIndex: _react.PropTypes.number
	};
	
	exports.markerControlledPropTypes = markerControlledPropTypes;
	var markerDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(markerControlledPropTypes);
	
	exports.markerDefaultPropTypes = markerDefaultPropTypes;
	var markerUpdaters = {
	  animation: function animation(_animation, component) {
	    component.getMarker().setAnimation(_animation);
	  },
	  attribution: function attribution(_attribution, component) {
	    component.getMarker().setAttribution(_attribution);
	  },
	  clickable: function clickable(_clickable, component) {
	    component.getMarker().setClickable(_clickable);
	  },
	  cursor: function cursor(_cursor, component) {
	    component.getMarker().setCursor(_cursor);
	  },
	  draggable: function draggable(_draggable, component) {
	    component.getMarker().setDraggable(_draggable);
	  },
	  icon: function icon(_icon, component) {
	    component.getMarker().setIcon(_icon);
	  },
	  label: function label(_label, component) {
	    component.getMarker().setLabel(_label);
	  },
	  opacity: function opacity(_opacity, component) {
	    component.getMarker().setOpacity(_opacity);
	  },
	  options: function options(_options, component) {
	    component.getMarker().setOptions(_options);
	  },
	  place: function place(_place, component) {
	    component.getMarker().setPlace(_place);
	  },
	  position: function position(_position, component) {
	    component.getMarker().setPosition(_position);
	  },
	  shape: function shape(_shape, component) {
	    component.getMarker().setShape(_shape);
	  },
	  title: function title(_title, component) {
	    component.getMarker().setTitle(_title);
	  },
	  visible: function visible(_visible, component) {
	    component.getMarker().setVisible(_visible);
	  },
	  zIndex: function zIndex(_zIndex, component) {
	    component.getMarker().setZIndex(_zIndex);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsMarkerEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var markerEventPropTypes = eventPropTypes;
	
	exports.markerEventPropTypes = markerEventPropTypes;
	
	var MarkerCreator = (function (_Component) {
	  _inherits(MarkerCreator, _Component);
	
	  function MarkerCreator() {
	    _classCallCheck(this, _MarkerCreator);
	
	    _get(Object.getPrototypeOf(_MarkerCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(MarkerCreator, [{
	    key: "getMarker",
	    value: function getMarker() {
	      return this.props.marker;
	    }
	
	    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindowOptions
	    // In the core API, the only anchor is the Marker class.
	  }, {
	    key: "getAnchor",
	    value: function getAnchor() {
	      return this.props.marker;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var mapHolderRef = _props.mapHolderRef;
	      var children = _props.children;
	
	      if (_react.Children.count(children) > 0) {
	        return _react2["default"].createElement(
	          "div",
	          null,
	          _react.Children.map(children, function (childElement) {
	            return childElement && _react2["default"].cloneElement(childElement, {
	              mapHolderRef: mapHolderRef,
	              anchorHolderRef: _this
	            });
	          })
	        );
	      } else {
	        return _react2["default"].createElement("noscript", null);
	      }
	    }
	  }], [{
	    key: "_createMarker",
	    value: function _createMarker(markerProps) {
	      var mapHolderRef = markerProps.mapHolderRef;
	      var anchorHolderRef = markerProps.anchorHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	      var marker = new google.maps.Marker((0, _utilsComposeOptions2["default"])(markerProps, markerControlledPropTypes));
	
	      if (anchorHolderRef) {
	        if ("MarkerClusterer" === anchorHolderRef.getAnchorType()) {
	          anchorHolderRef.getAnchor().addMarker(marker);
	        }
	      } else {
	        marker.setMap(mapHolderRef.getMap());
	      }
	
	      return marker;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      marker: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _MarkerCreator = MarkerCreator;
	  MarkerCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getMarker",
	    updaters: markerUpdaters
	  })(MarkerCreator) || MarkerCreator;
	  return MarkerCreator;
	})(_react.Component);
	
	exports["default"] = MarkerCreator;

/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(57);
	
	var _invariant = __webpack_require__(41);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var overlayViewControlledPropTypes = {
	  // CustomProps
	  mapPaneName: _react.PropTypes.string,
	  getPixelPositionOffset: _react.PropTypes.func,
	  position: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  bounds: _react.PropTypes.object
	};
	
	exports.overlayViewControlledPropTypes = overlayViewControlledPropTypes;
	// NOTICE!!!!!!
	//
	// Only expose those with getters & setters in the table as controlled props.
	//
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	//
	// https://developers.google.com/maps/documentation/javascript/3.exp/reference
	var overlayViewDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(overlayViewControlledPropTypes);
	
	exports.overlayViewDefaultPropTypes = overlayViewDefaultPropTypes;
	
	var OverlayViewCreator = (function (_Component) {
	  _inherits(OverlayViewCreator, _Component);
	
	  function OverlayViewCreator() {
	    _classCallCheck(this, OverlayViewCreator);
	
	    _get(Object.getPrototypeOf(OverlayViewCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(OverlayViewCreator, [{
	    key: "getOverlayView",
	    value: function getOverlayView() {
	      return this.props.overlayView;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.getOverlayView().setMap(this.props.mapHolderRef.getMap());
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.getOverlayView().setValues(this.props);
	      this.getOverlayView()._redraw(this.props.mapPaneName !== prevProps.mapPaneName);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.getOverlayView().setMap(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createOverlayView",
	    value: function _createOverlayView(overlayViewProps) {
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	      var overlayView = new google.maps.OverlayView();
	      overlayView.setValues((0, _utilsComposeOptions2["default"])(overlayViewProps, overlayViewControlledPropTypes));
	
	      overlayView.onAdd = function onAdd() {
	        this._containerElement = document.createElement("div");
	        this._containerElement.style.position = "absolute";
	      };
	
	      overlayView.draw = function draw() {
	        this._mountContainerToPane();
	        this._renderContent();
	      };
	
	      overlayView.onRemove = function onRemove() {
	        (0, _reactDom.unmountComponentAtNode)(this._containerElement);
	        this._unmountContainerFromPane();
	        this._containerElement = null;
	      };
	
	      overlayView._redraw = function _redraw(mapPaneNameChanged) {
	        if (mapPaneNameChanged) {
	          this._unmountContainerFromPane();
	          this._mountContainerToPane();
	        }
	        this._renderContent();
	      };
	
	      overlayView._renderContent = function _renderContent() {
	        if (this._containerElement) {
	          (0, _reactDom.render)(_react.Children.only(this.get("children")), this._containerElement, this._positionContainerElement.bind(this));
	        }
	      };
	
	      overlayView._mountContainerToPane = function _mountContainerToPane() {
	        var mapPaneName = this.get("mapPaneName");
	        (0, _invariant2["default"])(!!mapPaneName, "OverlayView requires a mapPaneName/defaultMapPaneName in your props instead of %s", mapPaneName);
	
	        this.getPanes()[mapPaneName].appendChild(this._containerElement);
	      };
	
	      overlayView._unmountContainerFromPane = function _unmountContainerFromPane() {
	        this._containerElement.parentNode.removeChild(this._containerElement);
	      };
	
	      overlayView._positionContainerElement = function _positionContainerElement() {
	        var left = undefined;
	        var top = undefined;
	        var offset = this._getOffset();
	        if (this.get("bounds")) {
	          var bounds = this._getPixelBounds();
	          if (bounds) {
	            var sw = bounds.sw;
	            var ne = bounds.ne;
	
	            if (offset) {
	              sw.x += offset.x;
	              ne.y += offset.y;
	            }
	            left = sw.x + "px";
	            top = ne.y + "px";
	            this._containerElement.style.width = ne.x - sw.x + "px";
	            this._containerElement.style.height = sw.y - ne.y + "px";
	          }
	        } else {
	          var position = this._getPixelPosition();
	          if (position) {
	            var x = position.x;
	            var y = position.y;
	
	            if (offset) {
	              x += offset.x;
	              y += offset.y;
	            }
	            left = x + "px";
	            top = y + "px";
	          }
	        }
	
	        this._containerElement.style.left = left;
	        this._containerElement.style.top = top;
	      };
	
	      overlayView._getPixelPosition = function _getPixelPosition() {
	        var projection = this.getProjection();
	        var position = this.get("position");
	        (0, _invariant2["default"])(!!position, "OverlayView requires a position/defaultPosition in your props instead of %s", position);
	        if (projection && position) {
	          if (!(position instanceof google.maps.LatLng)) {
	            position = new google.maps.LatLng(position.lat, position.lng);
	          }
	          return projection.fromLatLngToDivPixel(position);
	        }
	      };
	
	      overlayView._getPixelBounds = function _getPixelBounds() {
	        var projection = this.getProjection();
	        var bounds = this.get("bounds");
	        (0, _invariant2["default"])(!!bounds, "OverlayView requires a bounds in your props instead of %s", bounds);
	        if (projection && bounds) {
	          if (!(bounds instanceof google.maps.LatLngBounds)) {
	            bounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.ne.lat, bounds.ne.lng), new google.maps.LatLng(bounds.sw.lat, bounds.sw.lng));
	          }
	          return {
	            sw: projection.fromLatLngToDivPixel(this.bounds.getSouthWest()),
	            ne: projection.fromLatLngToDivPixel(this.bounds.getNorthEast())
	          };
	        }
	      };
	
	      overlayView._getOffset = function _getOffset() {
	        // Allows the component to control the visual position of the OverlayView
	        // relative to the LatLng pixel position.
	        var getPixelPositionOffset = this.get("getPixelPositionOffset");
	        if (getPixelPositionOffset) {
	          return getPixelPositionOffset(this._containerElement.offsetWidth, this._containerElement.offsetHeight);
	        }
	      };
	
	      // If we're inside a MarkerClusterer, allow ourselves to be clustered
	      if (overlayViewProps.anchorHolderRef) {
	        if ("MarkerClusterer" === overlayViewProps.anchorHolderRef.getAnchorType()) {
	          overlayView.getDraggable = function getDraggable() {
	            return !!overlayViewProps.draggable;
	          };
	
	          overlayView.getPosition = function getPosition() {
	            return new google.maps.LatLng(this.position);
	          };
	
	          overlayViewProps.anchorHolderRef.getAnchor().addMarker(overlayView);
	        }
	      }
	
	      return overlayView;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      mapPaneName: _react.PropTypes.string,
	      overlayView: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return OverlayViewCreator;
	})(_react.Component);
	
	exports["default"] = OverlayViewCreator;

/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsPolygonEventList = __webpack_require__(1945);
	
	var _eventListsPolygonEventList2 = _interopRequireDefault(_eventListsPolygonEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var polygonControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	  draggable: _react.PropTypes.bool,
	  editable: _react.PropTypes.bool,
	  options: _react.PropTypes.object,
	  path: _react.PropTypes.any,
	  paths: _react.PropTypes.any,
	  visible: _react.PropTypes.bool
	};
	
	exports.polygonControlledPropTypes = polygonControlledPropTypes;
	var polygonDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(polygonControlledPropTypes);
	
	exports.polygonDefaultPropTypes = polygonDefaultPropTypes;
	var polygonUpdaters = {
	  draggable: function draggable(_draggable, component) {
	    component.getPolygon().setDraggable(_draggable);
	  },
	  editable: function editable(_editable, component) {
	    component.getPolygon().setEditable(_editable);
	  },
	  options: function options(_options, component) {
	    component.getPolygon().setOptions(_options);
	  },
	  path: function path(_path, component) {
	    component.getPolygon().setPath(_path);
	  },
	  paths: function paths(_paths, component) {
	    component.getPolygon().setPaths(_paths);
	  },
	  visible: function visible(_visible, component) {
	    component.getPolygon().setVisible(_visible);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsPolygonEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var polygonEventPropTypes = eventPropTypes;
	
	exports.polygonEventPropTypes = polygonEventPropTypes;
	
	var PolygonCreator = (function (_Component) {
	  _inherits(PolygonCreator, _Component);
	
	  function PolygonCreator() {
	    _classCallCheck(this, _PolygonCreator);
	
	    _get(Object.getPrototypeOf(_PolygonCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(PolygonCreator, [{
	    key: "getPolygon",
	    value: function getPolygon() {
	      return this.props.polygon;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createPolygon",
	    value: function _createPolygon(polygonProps) {
	      var mapHolderRef = polygonProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	      var polygon = new google.maps.Polygon((0, _utilsComposeOptions2["default"])(polygonProps, polygonControlledPropTypes));
	
	      polygon.setMap(mapHolderRef.getMap());
	
	      return polygon;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      polygon: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _PolygonCreator = PolygonCreator;
	  PolygonCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getPolygon",
	    updaters: polygonUpdaters
	  })(PolygonCreator) || PolygonCreator;
	  return PolygonCreator;
	})(_react.Component);
	
	exports["default"] = PolygonCreator;

/***/ }),

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsPolylineEventList = __webpack_require__(1946);
	
	var _eventListsPolylineEventList2 = _interopRequireDefault(_eventListsPolylineEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var polylineControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	  draggable: _react.PropTypes.bool,
	  editable: _react.PropTypes.bool,
	  options: _react.PropTypes.object,
	  path: _react.PropTypes.any,
	  visible: _react.PropTypes.bool
	};
	
	exports.polylineControlledPropTypes = polylineControlledPropTypes;
	var polylineDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(polylineControlledPropTypes);
	
	exports.polylineDefaultPropTypes = polylineDefaultPropTypes;
	var polylineUpdaters = {
	  draggable: function draggable(_draggable, component) {
	    component.getPolyline().setDraggable(_draggable);
	  },
	  editable: function editable(_editable, component) {
	    component.getPolyline().setEditable(_editable);
	  },
	  options: function options(_options, component) {
	    component.getPolyline().setOptions(_options);
	  },
	  path: function path(_path, component) {
	    component.getPolyline().setPath(_path);
	  },
	  visible: function visible(_visible, component) {
	    component.getPolyline().setVisible(_visible);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsPolylineEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var polylineEventPropTypes = eventPropTypes;
	
	exports.polylineEventPropTypes = polylineEventPropTypes;
	
	var PolylineCreator = (function (_Component) {
	  _inherits(PolylineCreator, _Component);
	
	  function PolylineCreator() {
	    _classCallCheck(this, _PolylineCreator);
	
	    _get(Object.getPrototypeOf(_PolylineCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(PolylineCreator, [{
	    key: "getPolyline",
	    value: function getPolyline() {
	      return this.props.polyline;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createPolyline",
	    value: function _createPolyline(polylineProps) {
	      var mapHolderRef = polylineProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	      var polyline = new google.maps.Polyline((0, _utilsComposeOptions2["default"])(polylineProps, polylineControlledPropTypes));
	
	      polyline.setMap(mapHolderRef.getMap());
	
	      return polyline;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      polyline: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _PolylineCreator = PolylineCreator;
	  PolylineCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getPolyline",
	    updaters: polylineUpdaters
	  })(PolylineCreator) || PolylineCreator;
	  return PolylineCreator;
	})(_react.Component);
	
	exports["default"] = PolylineCreator;

/***/ }),

/***/ 1936:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsRectangleEventList = __webpack_require__(1947);
	
	var _eventListsRectangleEventList2 = _interopRequireDefault(_eventListsRectangleEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var rectangleControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; }).filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
	  //
	  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	  bounds: _react.PropTypes.any,
	  draggable: _react.PropTypes.bool,
	  editable: _react.PropTypes.bool,
	  options: _react.PropTypes.object,
	  visible: _react.PropTypes.bool
	};
	
	exports.rectangleControlledPropTypes = rectangleControlledPropTypes;
	var rectangleDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(rectangleControlledPropTypes);
	
	exports.rectangleDefaultPropTypes = rectangleDefaultPropTypes;
	var rectangleUpdaters = {
	  bounds: function bounds(_bounds, component) {
	    component.getRectangle().setBounds(_bounds);
	  },
	  draggable: function draggable(_draggable, component) {
	    component.getRectangle().setDraggable(_draggable);
	  },
	  editable: function editable(_editable, component) {
	    component.getRectangle().setEditable(_editable);
	  },
	  options: function options(_options, component) {
	    component.getRectangle().setOptions(_options);
	  },
	  visible: function visible(_visible, component) {
	    component.getRectangle().setVisible(_visible);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsRectangleEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var rectangleEventPropTypes = eventPropTypes;
	
	exports.rectangleEventPropTypes = rectangleEventPropTypes;
	
	var RectangleCreator = (function (_Component) {
	  _inherits(RectangleCreator, _Component);
	
	  function RectangleCreator() {
	    _classCallCheck(this, _RectangleCreator);
	
	    _get(Object.getPrototypeOf(_RectangleCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(RectangleCreator, [{
	    key: "getRectangle",
	    value: function getRectangle() {
	      return this.props.rectangle;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createRectangle",
	    value: function _createRectangle(rectangleProps) {
	      var mapHolderRef = rectangleProps.mapHolderRef;
	
	      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	      var rectangle = new google.maps.Rectangle((0, _utilsComposeOptions2["default"])(rectangleProps, rectangleControlledPropTypes));
	
	      rectangle.setMap(mapHolderRef.getMap());
	
	      return rectangle;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      rectangle: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _RectangleCreator = RectangleCreator;
	  RectangleCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getRectangle",
	    updaters: rectangleUpdaters
	  })(RectangleCreator) || RectangleCreator;
	  return RectangleCreator;
	})(_react.Component);
	
	exports["default"] = RectangleCreator;

/***/ }),

/***/ 1937:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListsSearchBoxEventList = __webpack_require__(1948);
	
	var _eventListsSearchBoxEventList2 = _interopRequireDefault(_eventListsSearchBoxEventList);
	
	var _utilsEventHandlerCreator = __webpack_require__(138);
	
	var _utilsEventHandlerCreator2 = _interopRequireDefault(_utilsEventHandlerCreator);
	
	var _utilsDefaultPropsCreator = __webpack_require__(114);
	
	var _utilsDefaultPropsCreator2 = _interopRequireDefault(_utilsDefaultPropsCreator);
	
	var _utilsComposeOptions = __webpack_require__(113);
	
	var _utilsComposeOptions2 = _interopRequireDefault(_utilsComposeOptions);
	
	var _utilsComponentLifecycleDecorator = __webpack_require__(137);
	
	var _utilsComponentLifecycleDecorator2 = _interopRequireDefault(_utilsComponentLifecycleDecorator);
	
	var _GoogleMapHolder = __webpack_require__(99);
	
	var _GoogleMapHolder2 = _interopRequireDefault(_GoogleMapHolder);
	
	var searchBoxControlledPropTypes = {
	  // NOTICE!!!!!!
	  //
	  // Only expose those with getters & setters in the table as controlled props.
	  //
	  bounds: _react.PropTypes.any
	};
	
	exports.searchBoxControlledPropTypes = searchBoxControlledPropTypes;
	var searchBoxDefaultPropTypes = (0, _utilsDefaultPropsCreator2["default"])(searchBoxControlledPropTypes);
	
	exports.searchBoxDefaultPropTypes = searchBoxDefaultPropTypes;
	var searchBoxUpdaters = {
	  bounds: function bounds(_bounds, component) {
	    component.getSearchBox().setBounds(_bounds);
	  }
	};
	
	var _eventHandlerCreator = (0, _utilsEventHandlerCreator2["default"])(_eventListsSearchBoxEventList2["default"]);
	
	var eventPropTypes = _eventHandlerCreator.eventPropTypes;
	var registerEvents = _eventHandlerCreator.registerEvents;
	var searchBoxEventPropTypes = eventPropTypes;
	
	exports.searchBoxEventPropTypes = searchBoxEventPropTypes;
	
	var SearchBoxCreator = (function (_Component) {
	  _inherits(SearchBoxCreator, _Component);
	
	  function SearchBoxCreator() {
	    _classCallCheck(this, _SearchBoxCreator);
	
	    _get(Object.getPrototypeOf(_SearchBoxCreator.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(SearchBoxCreator, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mountComponentToMap(this.props.controlPosition);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.controlPosition !== prevProps.controlPosition) {
	        this._unmountComponentFromMap(prevProps.controlPosition);
	        this._mountComponentToMap(this.props.controlPosition);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._unmountComponentFromMap(this.props.controlPosition);
	    }
	  }, {
	    key: "_mountComponentToMap",
	    value: function _mountComponentToMap(controlPosition) {
	      var _props = this.props;
	      var mapHolderRef = _props.mapHolderRef;
	      var inputElement = _props.inputElement;
	
	      mapHolderRef.getMap().controls[controlPosition].push(inputElement);
	    }
	  }, {
	    key: "_unmountComponentFromMap",
	    value: function _unmountComponentFromMap(controlPosition) {
	      var _props2 = this.props;
	      var mapHolderRef = _props2.mapHolderRef;
	      var inputElement = _props2.inputElement;
	
	      var index = mapHolderRef.getMap().controls[controlPosition].getArray().indexOf(inputElement);
	      mapHolderRef.getMap().controls[controlPosition].removeAt(index);
	    }
	  }, {
	    key: "getSearchBox",
	    value: function getSearchBox() {
	      return this.props.searchBox;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement("noscript", null);
	    }
	  }], [{
	    key: "_createSearchBox",
	    value: function _createSearchBox(inputElement, searchBoxProps) {
	      var searchBox = new google.maps.places.SearchBox(inputElement, (0, _utilsComposeOptions2["default"])(searchBoxProps, searchBoxControlledPropTypes));
	
	      return searchBox;
	    }
	  }, {
	    key: "propTypes",
	    value: {
	      mapHolderRef: _react.PropTypes.instanceOf(_GoogleMapHolder2["default"]).isRequired,
	      searchBox: _react.PropTypes.object.isRequired
	    },
	    enumerable: true
	  }]);
	
	  var _SearchBoxCreator = SearchBoxCreator;
	  SearchBoxCreator = (0, _utilsComponentLifecycleDecorator2["default"])({
	    registerEvents: registerEvents,
	    instanceMethodName: "getSearchBox",
	    updaters: searchBoxUpdaters
	  })(SearchBoxCreator) || SearchBoxCreator;
	  return SearchBoxCreator;
	})(_react.Component);
	
	exports["default"] = SearchBoxCreator;

/***/ }),

/***/ 1938:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["center_changed", "click", "dblclick", "drag", "dragend", "dragstart", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "radius_changed", "rightclick"];
	module.exports = exports["default"];

/***/ }),

/***/ 1939:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["directions_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1940:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#DrawingManager
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["circlecomplete", "markercomplete", "overlaycomplete", "polygoncomplete", "polylinecomplete", "rectanglecomplete"];
	module.exports = exports["default"];

/***/ }),

/***/ 1941:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["bounds_changed", "center_changed", "click", "dblclick", "drag", "dragend", "dragstart", "heading_changed", "idle", "maptypeid_changed", "mousemove", "mouseout", "mouseover", "projection_changed", "resize", "rightclick", "tilesloaded", "tilt_changed", "zoom_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1942:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["closeclick", "content_changed", "domready", "position_changed", "zindex_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1943:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["click", "defaultviewport_changed", "status_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1944:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["animation_changed", "click", "clickable_changed", "cursor_changed", "dblclick", "drag", "dragend", "draggable_changed", "dragstart", "flat_changed", "icon_changed", "mousedown", "mouseout", "mouseover", "mouseup", "position_changed", "rightclick", "shape_changed", "title_changed", "visible_changed", "zindex_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1945:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["click", "dblclick", "drag", "dragend", "dragstart", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"];
	module.exports = exports["default"];

/***/ }),

/***/ 1946:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["click", "dblclick", "drag", "dragend", "dragstart", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"];
	module.exports = exports["default"];

/***/ }),

/***/ 1947:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["bounds_changed", "click", "dblclick", "drag", "dragend", "dragstart", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "rightclick"];
	module.exports = exports["default"];

/***/ }),

/***/ 1948:
/***/ (function(module, exports) {

	// https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
	// [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["places_changed"];
	module.exports = exports["default"];

/***/ }),

/***/ 1949:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj["default"] : obj; }
	
	var _GoogleMapLoader = __webpack_require__(755);
	
	exports.GoogleMapLoader = _interopRequire(_GoogleMapLoader);
	
	var _GoogleMap = __webpack_require__(1918);
	
	exports.GoogleMap = _interopRequire(_GoogleMap);
	
	var _Circle = __webpack_require__(1915);
	
	exports.Circle = _interopRequire(_Circle);
	
	var _DirectionsRenderer = __webpack_require__(1916);
	
	exports.DirectionsRenderer = _interopRequire(_DirectionsRenderer);
	
	var _DrawingManager = __webpack_require__(1917);
	
	exports.DrawingManager = _interopRequire(_DrawingManager);
	
	var _InfoWindow = __webpack_require__(1919);
	
	exports.InfoWindow = _interopRequire(_InfoWindow);
	
	var _KmlLayer = __webpack_require__(1920);
	
	exports.KmlLayer = _interopRequire(_KmlLayer);
	
	var _Marker = __webpack_require__(1921);
	
	exports.Marker = _interopRequire(_Marker);
	
	var _OverlayView = __webpack_require__(1922);
	
	exports.OverlayView = _interopRequire(_OverlayView);
	
	var _Polygon = __webpack_require__(1923);
	
	exports.Polygon = _interopRequire(_Polygon);
	
	var _Polyline = __webpack_require__(1924);
	
	exports.Polyline = _interopRequire(_Polyline);
	
	var _Rectangle = __webpack_require__(1925);
	
	exports.Rectangle = _interopRequire(_Rectangle);
	
	var _SearchBox = __webpack_require__(1926);
	
	exports.SearchBox = _interopRequire(_SearchBox);

/***/ }),

/***/ 1950:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = controlledOrDefault;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _addDefaultPrefix = __webpack_require__(756);
	
	var _addDefaultPrefix2 = _interopRequireDefault(_addDefaultPrefix);
	
	function controlledOrDefault(props) {
	  return function (name) {
	    if (Object.prototype.hasOwnProperty.call(props, name)) {
	      return props[name];
	    } else {
	      return props[(0, _addDefaultPrefix2["default"])(name)];
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),

/***/ 1951:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = setContentForOptionalReactElement;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(57);
	
	function renderElement(contentElement, possiblePrevContent) {
	  var prevContent = possiblePrevContent;
	  if ("[object HTMLDivElement]" !== Object.prototype.toString.call(prevContent)) {
	    prevContent = document.createElement("div");
	  }
	
	  (0, _reactDom.render)(contentElement, prevContent);
	  return prevContent;
	}
	
	function setContentForOptionalReactElement(contentOptionalReactElement, infoWindowLikeInstance) {
	  if (_react2["default"].isValidElement(contentOptionalReactElement)) {
	    var contentElement = _react.Children.only(contentOptionalReactElement);
	    var prevContent = infoWindowLikeInstance.getContent();
	
	    var domEl = renderElement(contentElement, prevContent);
	    infoWindowLikeInstance.setContent(domEl);
	  } else {
	    infoWindowLikeInstance.setContent(contentOptionalReactElement);
	  }
	}
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// trip-bf4e76ff237642169397.js